var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _g, _g2, _g3, _g4, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _g5, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _g6, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _g7, _path1445, _path1446, _path1447, _path1448, _path1449;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelecommunications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 274,
    viewBox: "0 0 291 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 199.449V62.5486L21.8984 49.6002L38.3267 59.3117V92.9025L46.5408 88.0471V75.0988L54.755 70.2427V20.9657L79.3974 6.39885L90.3498 12.8727V27.9975L101.302 21.5237L112.255 27.9975V56.0542L123.207 62.5114V35.6081L134.159 29.1336L147.85 37.2266V69.5977L161.54 61.5048V9.71142L177.969 0L197.135 11.3299V53.3501L205.35 58.2061V75.2215L216.302 81.696V23.4939L229.992 15.4009L246.421 25.1123V38.9346L254.635 43.7906V81.1333L265.587 87.6072V62.3395L282.016 52.6288L290.23 57.4842L290.23 199.449H0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 123.459L96.8496 122.084V120.007L99.175 121.382V123.459Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 131.118L96.8496 129.743V127.667L99.175 129.041V131.118Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 119.629L96.8496 118.254V116.177L99.175 117.552V119.629Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 115.533L96.8496 114.159V112.082L99.175 113.456V115.533Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 127.289L96.8496 125.914V123.837L99.175 125.212V127.289Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 100.215L96.8496 98.8397V96.7627L99.175 98.1376V100.215Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 96.3844L96.8496 95.0101V92.9331L99.175 94.3074V96.3844Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 104.044L96.8496 102.67V100.593L99.175 101.967V104.044Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 111.704L96.8496 110.329V108.252L99.175 109.627V111.704Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 107.874L96.8496 106.499V104.422L99.175 105.797V107.874Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 142.607L96.8496 141.233V139.156L99.175 140.531V142.607Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 162.022L96.8496 160.647V158.57L99.175 159.945V162.022Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 154.096L96.8496 152.722V150.645L99.175 152.019V154.096Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 158.193L96.8496 156.818V154.741L99.175 156.116V158.193Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 169.681L96.8496 168.306V166.229L99.175 167.604V169.681Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 165.852L96.8496 164.477V162.4L99.175 163.775V165.852Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 138.777L96.8496 137.403V135.326L99.175 136.7V138.777Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 150.267L96.8496 148.892V146.815L99.175 148.19V150.267Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 134.948L96.8496 133.573V131.496L99.175 132.871V134.948Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 92.5548L96.8496 91.1798V89.1035L99.175 90.4778V92.5548Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 146.437L96.8496 145.062V142.986L99.175 144.36V146.437Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 45.2359L96.8496 43.8617V41.7847L99.175 43.1596V45.2359Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 41.4063L96.8496 40.0314V37.9551L99.175 39.3293V41.4063Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 37.5769L96.8496 36.202V34.125L99.175 35.4999V37.5769Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 170.657L92.0293 169.283V167.206L94.3547 168.58V170.657Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 166.827L92.0293 165.452V163.375L94.3547 164.75V166.827Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 174.486L92.0293 173.112V171.035L94.3547 172.41V174.486Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 178.316L92.0293 176.942V174.865L94.3547 176.239V178.316Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 173.511L96.8496 172.137V170.06L99.175 171.435V173.511Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 56.7258L96.8496 55.3509V53.2739L99.175 54.6489V56.7258Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 76.6882L96.8496 75.3133V73.2363L99.175 74.6112V76.6882Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 72.5921L96.8496 71.2178V69.1401L99.175 70.5151V72.5921Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 81.0657L96.8496 79.6908V77.6138L99.175 78.9887V81.0657Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 68.2146L96.8496 66.8397V64.7627L99.175 66.1376V68.2146Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 84.8956L96.8496 83.5207V81.4443L99.175 82.8186V84.8956Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 88.7247L96.8496 87.3504V85.2734L99.175 86.6477V88.7247Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 49.0662L96.8496 47.6912V45.6143L99.175 46.9892V49.0662Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 52.8956L96.8496 51.5207V49.4443L99.175 50.8193V52.8956Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 64.3848L96.8496 63.0106V60.9336L99.175 62.3085V64.3848Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 60.5553L96.8496 59.181V57.104L99.175 58.4783V60.5553Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 47.8079L56.3516 46.4329V44.356L58.677 45.7309V47.8079Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 117.637L56.3516 116.263V114.186L58.677 115.56V117.637Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 113.808L56.3516 112.433V110.356L58.677 111.731V113.808Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 109.978L56.3516 108.603V106.526L58.677 107.901V109.978Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 121.468L56.3516 120.093V118.016L58.677 119.391V121.468Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 125.297L56.3516 123.923V121.846L58.677 123.22V125.297Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 86.4519L56.3516 85.077V83L58.677 84.3749V86.4519Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 94.6588L56.3516 93.2845V91.2075L58.677 92.5818V94.6588Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 106.148L56.3516 104.774V102.697L58.677 104.071V106.148Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 90.8292L56.3516 89.4543V87.3779L58.677 88.7522V90.8292Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 98.489L56.3516 97.1141V95.0371L58.677 96.412V98.489Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 129.393L56.3516 128.018V125.941L58.677 127.316V129.393Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 102.319L56.3516 100.944V98.8677L58.677 100.242V102.319Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 160.03L56.3516 158.656V156.579L58.677 157.953V160.03Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 156.201L56.3516 154.826V152.75L58.677 154.124V156.201Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 167.956L56.3516 166.581V164.504L58.677 165.879V167.956Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 152.371L56.3516 150.996V148.919L58.677 150.294V152.371Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 163.861L56.3516 162.486V160.409L58.677 161.784V163.861Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 140.883L56.3516 139.508V137.431L58.677 138.806V140.883Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 148.542L56.3516 147.167V145.09L58.677 146.465V148.542Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 137.052L56.3516 135.677V133.601L58.677 134.975V137.052Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 133.223L56.3516 131.848V129.771L58.677 131.146V133.223Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 144.712L56.3516 143.337V141.26L58.677 142.635V144.712Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 51.6373L56.3516 50.263V48.186L58.677 49.5603V51.6373Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 28.6589L56.3516 27.284V25.207L58.677 26.582V28.6589Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 82.6222L56.3516 81.2479V79.1709L58.677 80.5458V82.6222Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 32.4889L56.3516 31.1139V29.0376L58.677 30.4119V32.4889Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 40.148L56.3516 38.7731V36.6968L58.677 38.071V40.148Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 36.3186L56.3516 34.9437V32.8667L58.677 34.2416V36.3186Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 71.0582L56.3516 69.6839V67.6069L58.677 68.9819V71.0582Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 67.2286L56.3516 65.8543V63.7773L58.677 65.1516V67.2286Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 78.7178L56.3516 77.3436V75.2666L58.677 76.6409V78.7178Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 74.8883L56.3516 73.5133V71.437L58.677 72.8113V74.8883Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 43.9776L56.3516 42.6034V40.5264L58.677 41.9006V43.9776Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 63.1265L56.3516 61.7523V59.6753L58.677 61.0496V63.1265Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M99.175 177.341L96.8496 175.966V173.889L99.175 175.264V177.341Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 162.997L92.0293 161.623V159.546L94.3547 160.92V162.997Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 55.4669L56.3516 54.0926V52.0156L58.677 53.3906V55.4669Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 59.2971L56.3516 57.9222V55.8452L58.677 57.2201V59.2971Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 36.127L177.217 34.7528V32.6758L179.542 34.0507V36.127Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 90.0505L177.217 88.6756V86.5986L179.542 87.9736V90.0505Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 97.7096L177.217 96.3353V94.2583L179.542 95.6332V97.7096Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 109.199L177.217 107.825V105.748L179.542 107.122V109.199Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 101.54L177.217 100.165V98.0879L179.542 99.4628V101.54Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 105.369L177.217 103.995V101.918L179.542 103.292V105.369Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 93.88L177.217 92.505V90.4287L179.542 91.803V93.88Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 66.7652L177.217 65.3909V63.314L179.542 64.6889V66.7652Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 70.595L177.217 69.2201V67.1431L179.542 68.518V70.595Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 74.4249L177.217 73.0506V70.9736L179.542 72.3479V74.4249Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 78.5606L177.217 77.1864V75.1094L179.542 76.4843V78.5606Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 82.3909L177.217 81.016V78.939L179.542 80.3139V82.3909Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 86.2203L177.217 84.846V82.769L179.542 84.1433V86.2203Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 136.273L177.217 134.898V132.822L179.542 134.196V136.273Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 140.103L177.217 138.728V136.651L179.542 138.026V140.103Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 143.933L177.217 142.558V140.481L179.542 141.856V143.933Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 147.762L177.217 146.387V144.311L179.542 145.685V147.762Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 132.443L177.217 131.069V128.992L179.542 130.367V132.443Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 124.784L177.217 123.409V121.332L179.542 122.707V124.784Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 120.954L177.217 119.579V117.502L179.542 118.877V120.954Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 128.613L177.217 127.239V125.162L179.542 126.536V128.613Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 117.125L177.217 115.75V113.673L179.542 115.048V117.125Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 113.029L177.217 111.654V109.577L179.542 110.952V113.029Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 151.593L177.217 150.218V148.141L179.542 149.515V151.593Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 175.812L172.396 174.437V172.36L174.722 173.735V175.812Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 62.9356L177.217 61.5607V59.4844L179.542 60.8586V62.9356Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 171.982L172.396 170.608V168.531L174.722 169.906V171.982Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 160.493L172.396 159.119V157.042L174.722 158.416V160.493Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 164.322L172.396 162.948V160.871L174.722 162.246V164.322Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 168.152L172.396 166.777V164.701L174.722 166.075V168.152Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 24.6378L177.217 23.2635V21.1865L179.542 22.5608V24.6378Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 51.4465L177.217 50.0716V47.9946L179.542 49.3696V51.4465Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 47.617L177.217 46.242V44.165L179.542 45.54V47.617Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 59.1055L177.217 57.7313V55.6543L179.542 57.0292V59.1055Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 55.276L177.217 53.9017V51.8247L179.542 53.199V55.276Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 43.7867L177.217 42.4118V40.3354L179.542 41.7097V43.7867Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 32.2974L177.217 30.9225V28.8462L179.542 30.2205V32.2974Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 39.9573L177.217 38.5824V36.5054L179.542 37.8803V39.9573Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 28.4674L177.217 27.0931V25.0161L179.542 26.391V28.4674Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 171.786L56.3516 170.411V168.334L58.677 169.709V171.786Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 97.3594L92.0293 95.9852V93.9082L94.3547 95.2831V97.3594Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 101.19L92.0293 99.8146V97.7383L94.3547 99.1125V101.19Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 155.687L177.217 154.313V152.236L179.542 153.611V155.687Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 108.849L92.0293 107.474V105.397L94.3547 106.772V108.849Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 112.679L92.0293 111.304V109.228L94.3547 110.602V112.679Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 116.775L92.0293 115.401V113.324L94.3547 114.698V116.775Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 85.8702L92.0293 84.4959V82.4189L94.3547 83.7932V85.8702Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 82.0411L92.0293 80.6668V78.5898L94.3547 79.9641V82.0411Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 78.2117L92.0293 76.8368V74.7598L94.3547 76.1347V78.2117Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 89.7009L92.0293 88.326V86.249L94.3547 87.624V89.7009Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 93.5299L92.0293 92.1556V90.0786L94.3547 91.4529V93.5299Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 147.413L92.0293 146.038V143.961L94.3547 145.336V147.413Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 120.605L92.0293 119.23V117.153L94.3547 118.528V120.605Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 151.242L92.0293 149.868V147.791L94.3547 149.165V151.242Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 139.753L92.0293 138.378V136.301L94.3547 137.676V139.753Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 155.338L92.0293 153.963V151.886L94.3547 153.261V155.338Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 143.583L92.0293 142.208V140.131L94.3547 141.506V143.583Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 124.434L92.0293 123.06V120.982L94.3547 122.357V124.434Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 135.923L92.0293 134.549V132.472L94.3547 133.846V135.923Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 128.264L92.0293 126.889V124.812L94.3547 126.187V128.264Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 132.094L92.0293 130.719V128.642L94.3547 130.017V132.094Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 105.019L92.0293 103.645V101.568L94.3547 102.942V105.019Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 178.666L177.217 177.291V175.214L179.542 176.589V178.666Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 174.836L177.217 173.462V171.385L179.542 172.76V174.836Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 159.168L92.0293 157.793V155.717L94.3547 157.091V159.168Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 73.8338L92.0293 72.4588V70.3818L94.3547 71.7568V73.8338Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 163.347L177.217 161.973V159.896L179.542 161.27V163.347Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 167.177L177.217 165.802V163.725L179.542 165.1V167.177Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 171.006L177.217 169.632V167.555L179.542 168.929V171.006Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M179.542 159.518L177.217 158.143V156.066L179.542 157.441V159.518Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 57.7014L92.0293 56.3265V54.2495L94.3547 55.6244V57.7014Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 61.5308L92.0293 60.1566V58.0796L94.3547 59.4545V61.5308Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 65.3611L92.0293 63.9862V61.9092L94.3547 63.2841V65.3611Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 69.7385L92.0293 68.3636V66.2866L94.3547 67.6616V69.7385Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 53.8707L92.0293 52.4964V50.4194L94.3547 51.7944V53.8707Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 38.5523L92.0293 37.1774V35.1011L94.3547 36.4753V38.5523Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 42.3819L92.0293 41.0077V38.9307L94.3547 40.3049V42.3819Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 34.7229L92.0293 33.348V31.271L94.3547 32.6459V34.7229Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 50.0416L92.0293 48.6673V46.5903L94.3547 47.9646V50.0416Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3547 46.2122L92.0293 44.8372V42.7603L94.3547 44.1352V46.2122Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 171.167L11.7773 169.792V167.715L14.1028 169.09V171.167Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 175.616L56.3516 174.241V172.164L58.677 173.539V175.616Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 152.728L6.95508 151.353V149.276L9.2805 150.651V152.728Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 160.653L6.95508 159.279V157.202L9.2805 158.576V160.653Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 148.898L6.95508 147.523V145.446L9.2805 146.821V148.898Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 164.483L6.95508 163.108V161.031L9.2805 162.406V164.483Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 141.238L6.95508 139.864V137.787L9.2805 139.162V141.238Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 129.749L6.95508 128.375V126.298L9.2805 127.672V129.749Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 133.579L6.95508 132.204V130.127L9.2805 131.502V133.579Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 137.408L6.95508 136.033V133.957L9.2805 135.331V137.408Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 168.312L6.95508 166.937V164.86L9.2805 166.235V168.312Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 175.971L6.95508 174.597V172.52L9.2805 173.895V175.971Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 179.802L6.95508 178.427V176.351L9.2805 177.725V179.802Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 172.142L6.95508 170.768V168.691L9.2805 170.065V172.142Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 125.919L6.95508 124.544V122.467L9.2805 123.842V125.919Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 145.068L6.95508 143.693V141.616L9.2805 142.991V145.068Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 122.089L6.95508 120.715V118.638L9.2805 120.013V122.089Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 75.7354L6.95508 74.3605V72.2842L9.2805 73.6584V75.7354Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 79.5645L6.95508 78.1903V76.1133L9.2805 77.4882V79.5645Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 71.8904L6.95508 70.5155V68.4385L9.2805 69.8127V71.8904Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 106.504L6.95508 105.13V103.053L9.2805 104.427V106.504Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 83.5264L6.95508 82.1515V80.0752L9.2805 81.4495V83.5264Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 110.334L6.95508 108.959V106.882L9.2805 108.257V110.334Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 117.994L6.95508 116.619V114.542L9.2805 115.917V117.994Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 114.164L6.95508 112.789V110.712L9.2805 112.087V114.164Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 102.675L6.95508 101.3V99.2231L9.2805 100.598V102.675Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 87.3556L6.95508 85.9813V83.9043L9.2805 85.2792V87.3556Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 91.1853L6.95508 89.8104V87.7334L9.2805 89.1083V91.1853Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 95.0152L6.95508 93.6403V91.564L9.2805 92.9382V95.0152Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 98.8448L6.95508 97.4705V95.3936L9.2805 96.7685V98.8448Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 147.922L11.7773 146.547V144.471L14.1028 145.845V147.922Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 167.336L11.7773 165.962V163.885L14.1028 165.26V167.336Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 156.663L172.396 155.288V153.211L174.722 154.586V156.663Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 178.826L11.7773 177.451V175.374L14.1028 176.749V178.826Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 159.412L11.7773 158.037V155.96L14.1028 157.335V159.412Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 155.581L11.7773 154.207V152.13L14.1028 153.505V155.581Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 163.506L11.7773 162.132V160.055L14.1028 161.429V163.506Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 151.752L11.7773 150.377V148.3L14.1028 149.675V151.752Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 174.996L11.7773 173.622V171.545L14.1028 172.919V174.996Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 144.092L11.7773 142.718V140.641L14.1028 142.016V144.092Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 86.38L11.7773 85.0057V82.9287L14.1028 84.303V86.38Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 82.4197L11.7773 81.0448V78.9678L14.1028 80.3427V82.4197Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 94.0398L11.7773 92.6649V90.5879L14.1028 91.9628V94.0398Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 97.8692L11.7773 96.495V94.418L14.1028 95.7922V97.8692Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 74.7437L11.7773 73.3695V71.2925L14.1028 72.6674V74.7437Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 101.7L11.7773 100.325V98.248L14.1028 99.623V101.7Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 78.5889L11.7773 77.2147V75.1377L14.1028 76.512V78.5889Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 90.2096L11.7773 88.8353V86.7583L14.1028 88.1332V90.2096Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 128.774L11.7773 127.399V125.322L14.1028 126.697V128.774Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 132.603L11.7773 131.228V129.151L14.1028 130.526V132.603Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 136.433L11.7773 135.058V132.981L14.1028 134.356V136.433Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 124.944L11.7773 123.569V121.492L14.1028 122.867V124.944Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 140.262L11.7773 138.888V136.811L14.1028 138.185V140.262Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 120.848L11.7773 119.473V117.396L14.1028 118.771V120.848Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 109.358L11.7773 107.984V105.907L14.1028 107.281V109.358Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 113.189L11.7773 111.814V109.737L14.1028 111.112V113.189Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 117.019L11.7773 115.644V113.567L14.1028 114.942V117.019Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1028 105.529L11.7773 104.154V102.078L14.1028 103.452V105.529Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2805 156.557L6.95508 155.182V153.105L9.2805 154.48V156.557Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 116.662L61.1719 115.287V113.21L63.4973 114.585V116.662Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 112.832L61.1719 111.457V109.38L63.4973 110.755V112.832Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 120.492L61.1719 119.117V117.04L63.4973 118.415V120.492Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 124.321L61.1719 122.946V120.87L63.4973 122.244V124.321Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 85.4763L61.1719 84.1014V82.0244L63.4973 83.3993V85.4763Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 105.172L61.1719 103.798V101.721L63.4973 103.095V105.172Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 93.6837L61.1719 92.3087V90.2324L63.4973 91.6067V93.6837Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 128.151L61.1719 126.777V124.7L63.4973 126.074V128.151Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 89.3057L61.1719 87.9308V85.8545L63.4973 87.2288V89.3057Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 97.5128L61.1719 96.1385V94.0615L63.4973 95.4365V97.5128Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 101.343L61.1719 99.9681V97.8911L63.4973 99.266V101.343Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 109.002L61.1719 107.628V105.551L63.4973 106.926V109.002Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 155.225L61.1719 153.85V151.773L63.4973 153.148V155.225Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 151.395L61.1719 150.021V147.944L63.4973 149.319V151.395Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 159.055L61.1719 157.681V155.604L63.4973 156.978V159.055Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 166.715L61.1719 165.34V163.263L63.4973 164.638V166.715Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 162.884L61.1719 161.51V159.433L63.4973 160.808V162.884Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 136.076L61.1719 134.702V132.625L63.4973 133.999V136.076Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 132.247L61.1719 130.872V128.795L63.4973 130.17V132.247Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 139.906L61.1719 138.532V136.455L63.4973 137.829V139.906Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 147.566L61.1719 146.191V144.115L63.4973 145.489V147.566Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 143.736L61.1719 142.361V140.284L63.4973 141.659V143.736Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 35.3429L61.1719 33.9686V31.8916L63.4973 33.2659V35.3429Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 170.81L61.1719 169.435V167.359L63.4973 168.733V170.81Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M58.677 179.445L56.3516 178.07V175.994L58.677 177.368V179.445Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 39.1726L61.1719 37.7977V35.7207L63.4973 37.0956V39.1726Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 81.5725L61.1719 80.1976V78.1206L63.4973 79.4955V81.5725Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 70.0831L61.1719 68.7088V66.6318L63.4973 68.0068V70.0831Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 65.9806L61.1719 64.6063V62.5293L63.4973 63.9042V65.9806Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 73.9133L61.1719 72.5384V70.4614L63.4973 71.8364V73.9133Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 62.151L61.1719 60.776V58.6997L63.4973 60.074V62.151Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 77.7423L61.1719 76.368V74.291L63.4973 75.6653V77.7423Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 46.8321L61.1719 45.4578V43.3809L63.4973 44.7558V46.8321Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 43.002L61.1719 41.6278V39.5508L63.4973 40.925V43.002Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 50.6619L61.1719 49.2869V47.21L63.4973 48.5849V50.6619Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 54.4913L61.1719 53.117V51.04L63.4973 52.4143V54.4913Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 58.3215L61.1719 56.9466V54.8696L63.4973 56.2446V58.3215Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 31.5133L61.1719 30.1383V28.062L63.4973 29.4363V31.5133Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 130.724L2.13281 129.35V127.273L4.45823 128.647V130.724Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 107.481L2.13281 106.106V104.029L4.45823 105.404V107.481Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 138.384L2.13281 137.01V134.933L4.45823 136.307V138.384Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 142.214L2.13281 140.839V138.762L4.45823 140.137V142.214Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 146.043L2.13281 144.668V142.591L4.45823 143.966V146.043Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 126.895L2.13281 125.52V123.443L4.45823 124.818V126.895Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 111.31L2.13281 109.935V107.858L4.45823 109.233V111.31Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 123.065L2.13281 121.69V119.613L4.45823 120.988V123.065Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 115.14L2.13281 113.765V111.688L4.45823 113.063V115.14Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 119.235L2.13281 117.861V115.784L4.45823 117.159V119.235Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 134.554L2.13281 133.18V131.103L4.45823 132.477V134.554Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 173.117L2.13281 171.743V169.666L4.45823 171.041V173.117Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 149.873L2.13281 148.499V146.422L4.45823 147.797V149.873Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 169.288L2.13281 167.913V165.836L4.45823 167.211V169.288Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 176.948L2.13281 175.573V173.496L4.45823 174.871V176.948Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 153.703L2.13281 152.328V150.251L4.45823 151.626V153.703Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 157.799L2.13281 156.424V154.348L4.45823 155.722V157.799Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 174.64L61.1719 173.265V171.188L63.4973 172.563V174.64Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 165.458L2.13281 164.083V162.006L4.45823 163.381V165.458Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 161.628L2.13281 160.254V158.177L4.45823 159.552V161.628Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 103.65L2.13281 102.276V100.199L4.45823 101.573V103.65Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4973 178.469L61.1719 177.095V175.018L63.4973 176.392V178.469Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 92.1607L2.13281 90.7858V88.7095L4.45823 90.0837V92.1607Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 88.3311L2.13281 86.9569V84.8799L4.45823 86.2548V88.3311Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 84.5015L2.13281 83.1266V81.0503L4.45823 82.4246V84.5015Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 95.9903L2.13281 94.616V92.5391L4.45823 93.9133V95.9903Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 99.8211L2.13281 98.4461V96.3691L4.45823 97.7441V99.8211Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 69.0357L2.13281 67.6615V65.5845L4.45823 66.9587V69.0357Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 80.6721L2.13281 79.2972V77.2202L4.45823 78.5951V80.6721Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 72.8811L2.13281 71.5062V69.4292L4.45823 70.8041V72.8811Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45823 76.7105L2.13281 75.3363V73.2593L4.45823 74.6335V76.7105Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 156.97L276.02 158.344V156.268L278.345 154.893V156.97Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 46.9644L218.141 45.5902V43.5132L220.466 44.8874V46.9644Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 50.7952L218.141 49.4202V47.3433L220.466 48.7182V50.7952Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 43.135L218.141 41.7601V39.6831L220.466 41.058V43.135Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 54.6241L218.141 53.2492V51.1729L220.466 52.5471V54.6241Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 58.4537L218.141 57.0794V55.0024L220.466 56.3767V58.4537Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 62.2839L218.141 60.909V58.832L220.466 60.207V62.2839Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 170.675L285.664 172.05V169.973L287.989 168.598V170.675Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 178.335L285.664 179.709V177.633L287.989 176.258V178.335Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 174.506L285.664 175.88V173.803L287.989 172.429V174.506Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 35.4752L218.141 34.1003V32.0239L220.466 33.3982V35.4752Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 39.3048L218.141 37.9305V35.8535L220.466 37.2278V39.3048Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 92.9216L218.141 91.5467V89.4697L220.466 90.8447V92.9216Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 66.1134L218.141 64.7384V62.6621L220.466 64.0364V66.1134Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 96.7515L218.141 95.3766V93.3003L220.466 94.6746V96.7515Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 100.581L218.141 99.2064V97.1294L220.466 98.5043V100.581Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 85.2618L218.141 83.8869V81.8105L220.466 83.1848V85.2618Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 89.0914L218.141 87.7171V85.6401L220.466 87.0151V89.0914Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 69.9429L218.141 68.5687V66.4917L220.466 67.866V69.9429Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 73.7727L218.141 72.3978V70.3208L220.466 71.6957V73.7727Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 81.4322L218.141 80.0579V77.981L220.466 79.3559V81.4322Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 77.6026L218.141 76.2283V74.1514L220.466 75.5256V77.6026Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 166.846L285.664 168.22V166.144L287.989 164.769V166.846Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 112.698L285.664 114.072V111.996L287.989 110.621V112.698Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 105.038L285.664 106.413V104.336L287.989 102.961V105.038Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 108.868L285.664 110.242V108.165L287.989 106.791V108.868Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 104.676L218.141 103.302V101.225L220.466 102.6V104.676Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 116.793L285.664 118.168V116.091L287.989 114.716V116.793Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 97.3786L285.664 98.7535V96.6765L287.989 95.3022V97.3786Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 89.7196L285.664 91.0938V89.0175L287.989 87.6426V89.7196Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 101.208L285.664 102.583V100.506L287.989 99.1313V101.208Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 93.5487L285.664 94.9236V92.8466L287.989 91.4717V93.5487Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 124.453L285.664 125.827V123.751L287.989 122.376V124.453Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 120.623L285.664 121.998V119.921L287.989 118.546V120.623Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 147.431L285.664 148.806V146.729L287.989 145.354V147.431Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 85.8893L285.664 87.2642V85.1873L287.989 83.813V85.8893Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 155.357L285.664 156.731V154.654L287.989 153.28V155.357Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 159.186L285.664 160.561V158.484L287.989 157.109V159.186Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 128.282L285.664 129.657V127.58L287.989 126.206V128.282Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 163.016L285.664 164.391V162.314L287.989 160.939V163.016Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 132.113L285.664 133.487V131.41L287.989 130.036V132.113Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 135.942L285.664 137.317V135.24L287.989 133.865V135.942Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 139.771L285.664 141.146V139.069L287.989 137.694V139.771Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 143.601L285.664 144.976V142.899L287.989 141.524V143.601Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 151.261L285.664 152.635V150.558L287.989 149.184V151.261Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 72.7976L222.963 71.4227V69.3457L225.288 70.7206V72.7976Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 68.9669L222.963 67.5926V65.5156L225.288 66.8899V68.9669Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 76.6272L222.963 75.2523V73.1753L225.288 74.5502V76.6272Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 80.4566L222.963 79.0824V77.0054L225.288 78.3796V80.4566Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 84.2864L222.963 82.9115V80.8345L225.288 82.2094V84.2864Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 49.8184L222.963 48.4442V46.3672L225.288 47.7415V49.8184Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 108.507L218.141 107.132V105.055L220.466 106.43V108.507Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 65.1379L222.963 63.763V61.686L225.288 63.061V65.1379Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 88.1163L222.963 86.742V84.665L225.288 86.0393V88.1163Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 61.3084L222.963 59.9334V57.8564L225.288 59.2314V61.3084Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 57.4781L222.963 56.1038V54.0269L225.288 55.4011V57.4781Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 119.02L222.963 117.645V115.568L225.288 116.943V119.02Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 111.36L222.963 109.985V107.909L225.288 109.283V111.36Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 115.19L222.963 113.816V111.739L225.288 113.114V115.19Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 45.989L222.963 44.6141V42.5371L225.288 43.912V45.989Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 122.85L222.963 121.475V119.398L225.288 120.773V122.85Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 126.68L222.963 125.305V123.228L225.288 124.603V126.68Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 95.7756L222.963 94.4007V92.3237L225.288 93.6987V95.7756Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 91.9459L222.963 90.5716V88.4946L225.288 89.8689V91.9459Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 99.6051L222.963 98.2308V96.1538L225.288 97.5281V99.6051Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 107.531L222.963 106.156V104.079L225.288 105.454V107.531Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 103.435L222.963 102.06V99.9834L225.288 101.358V103.435Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 53.6482L222.963 52.2733V50.1963L225.288 51.5712V53.6482Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 147.069L218.141 145.695V143.618L220.466 144.993V147.069Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 42.1594L222.963 40.7845V38.7075L225.288 40.0824V42.1594Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 139.145L218.141 137.77V135.693L220.466 137.068V139.145Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 127.656L218.141 126.281V124.204L220.466 125.579V127.656Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 143.24L218.141 141.865V139.789L220.466 141.163V143.24Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 135.315L218.141 133.94V131.863L220.466 133.238V135.315Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 116.166L218.141 114.791V112.714L220.466 114.089V116.166Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 112.336L218.141 110.962V108.885L220.466 110.259V112.336Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 119.996L218.141 118.621V116.544L220.466 117.919V119.996Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 123.825L218.141 122.451V120.374L220.466 121.748V123.825Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 131.484L218.141 130.11V128.033L220.466 129.407V131.484Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 177.707L218.141 176.333V174.256L220.466 175.631V177.707Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 173.878L218.141 172.503V170.426L220.466 171.801V173.878Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 38.3297L222.963 36.9554V34.8784L225.288 36.2527V38.3297Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 170.049L218.141 168.674V166.597L220.466 167.972V170.049Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 154.729L218.141 153.355V151.278L220.466 152.652V154.729Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 150.9L218.141 149.525V147.449L220.466 148.823V150.9Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 158.559L218.141 157.184V155.107L220.466 156.482V158.559Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 162.389L218.141 161.014V158.938L220.466 160.312V162.389Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 166.218L218.141 164.844V162.767L220.466 164.141V166.218Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 149.309L276.02 150.684V148.607L278.345 147.232V149.309Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 145.48L276.02 146.855V144.778L278.345 143.403V145.48Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 141.65L276.02 143.025V140.948L278.345 139.573V141.65Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 153.14L276.02 154.514V152.437L278.345 151.063V153.14Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 161.065L276.02 162.44V160.363L278.345 158.988V161.065Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 122.502L276.02 123.877V121.8L278.345 120.425V122.502Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 164.895L276.02 166.27V164.193L278.345 162.818V164.895Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 137.821L276.02 139.196V137.118L278.345 135.744V137.821Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 126.332L276.02 127.706V125.63L278.345 124.255V126.332Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 130.161L276.02 131.536V129.459L278.345 128.084V130.161Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 133.991L276.02 135.365V133.288L278.345 131.914V133.991Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 152.834L172.396 151.459V149.382L174.722 150.756V152.834Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 168.725L276.02 170.099V168.022L278.345 166.648V168.725Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 130.509L222.963 129.134V127.057L225.288 128.432V130.509Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 172.554L276.02 173.929V171.852L278.345 170.477V172.554Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 176.384L276.02 177.758V175.681L278.345 174.307V176.384Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 118.405L276.02 119.78V117.703L278.345 116.329V118.405Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 114.577L276.02 115.951V113.874L278.345 112.5V114.577Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 72.1424L276.02 73.5167V71.4404L278.345 70.0654V72.1424Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 68.3127L276.02 69.6876V67.6106L278.345 66.2363V68.3127Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 99.257L276.02 100.632V98.5549L278.345 97.1807V99.257Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 103.087L276.02 104.461V102.384L278.345 101.01V103.087Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 95.4276L276.02 96.8025V94.7255L278.345 93.3506V95.4276Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 106.916L276.02 108.291V106.214L278.345 104.839V106.916Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 110.746L276.02 112.121V110.044L278.345 108.669V110.746Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 87.7679L276.02 89.1428V87.0658L278.345 85.6909V87.7679Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 79.8021L276.02 81.1763V79.0994L278.345 77.7251V79.8021Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 83.9383L276.02 85.3126V83.2363L278.345 81.8613V83.9383Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 75.972L276.02 77.3469V75.2699L278.345 73.895V75.972Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M278.345 91.598L276.02 92.9723V90.8953L278.345 89.521V91.598Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 123.477L280.842 124.851V122.774L283.167 121.4V123.477Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 165.87L280.842 167.245V165.168L283.167 163.793V165.87Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 173.53L280.842 174.905V172.828L283.167 171.453V173.53Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 177.359L280.842 178.733V176.656L283.167 175.282V177.359Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 162.04L280.842 163.415V161.338L283.167 159.963V162.04Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 150.285L280.842 151.66V149.583L283.167 148.208V150.285Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 154.115L280.842 155.489V153.412L283.167 152.038V154.115Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 158.211L280.842 159.585V157.509L283.167 156.134V158.211Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 70.264L285.664 71.6389V69.5619L287.989 68.187V70.264Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 66.4344L285.664 67.8087V65.7317L287.989 64.3574V66.4344Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 74.0934L285.664 75.4683V73.3914L287.989 72.0171V74.0934Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 78.2303L285.664 79.6046V77.5276L287.989 76.1533V78.2303Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 62.6038L285.664 63.9788V61.9018L287.989 60.5269V62.6038Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 146.456L280.842 147.83V145.754L283.167 144.379V146.456Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 169.7L280.842 171.074V168.998L283.167 167.623V169.7Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 88.7435L280.842 90.1178V88.0408L283.167 86.6665V88.7435Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 84.9139L280.842 86.2888V84.2118L283.167 82.8369V84.9139Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 92.5731L280.842 93.9473V91.871L283.167 90.4961V92.5731Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 96.4027L280.842 97.7776V95.7006L283.167 94.3257V96.4027Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 81.0838L280.842 82.4581V80.3811L283.167 79.0068V81.0838Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 100.233L280.842 101.608V99.5305L283.167 98.1562V100.233Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 142.626L280.842 144.001V141.924L283.167 140.549V142.626Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 76.9474L280.842 78.3223V76.2454L283.167 74.8711V76.9474Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 65.4582L280.842 66.8331V64.7561L283.167 63.3818V65.4582Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 73.118L280.842 74.4929V72.4159L283.167 71.041V73.118Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 69.2884L280.842 70.6627V68.5857L283.167 67.2114V69.2884Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 127.307L280.842 128.682V126.605L283.167 125.23V127.307Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M287.989 82.0599L285.664 83.4348V81.3578L287.989 79.9829V82.0599Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 131.137L280.842 132.511V130.434L283.167 129.06V131.137Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 134.966L280.842 136.34V134.264L283.167 132.889V134.966Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 104.062L280.842 105.437V103.36L283.167 101.985V104.062Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 138.796L280.842 140.171V138.094L283.167 136.719V138.796Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 107.892L280.842 109.267V107.19L283.167 105.815V107.892Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 119.647L280.842 121.022V118.945L283.167 117.571V119.647Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 111.722L280.842 113.096V111.02L283.167 109.645V111.722Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M283.167 115.552L280.842 116.927V114.85L283.167 113.475V115.552Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 92.0015L167.572 90.6273V88.5503L169.898 89.9246V92.0015Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 95.8311L167.572 94.4569V92.3799L169.898 93.7548V95.8311Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 99.6607L167.572 98.2858V96.2095L169.898 97.5837V99.6607Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 107.32L167.572 105.946V103.869L169.898 105.244V107.32Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 103.49L167.572 102.116V100.039L169.898 101.413V103.49Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 76.6829L167.572 75.308V73.231L169.898 74.6059V76.6829Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 111.416L167.572 110.041V107.964L169.898 109.339V111.416Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 72.8526L167.572 71.4784V69.4014L169.898 70.7756V72.8526Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 84.3414L167.572 82.9671V80.8901L169.898 82.2644V84.3414Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 80.5125L167.572 79.1375V77.0605L169.898 78.4355V80.5125Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 88.1716L167.572 86.7967V84.7197L169.898 86.0946V88.1716Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 115.246L167.572 113.871V111.794L169.898 113.169V115.246Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 142.054L167.572 140.679V138.602L169.898 139.977V142.054Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 138.224L167.572 136.85V134.773L169.898 136.147V138.224Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 145.883L167.572 144.508V142.432L169.898 143.806V145.883Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 68.7166L167.572 67.3416V65.2646L169.898 66.6396V68.7166Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 134.394L167.572 133.019V130.942L169.898 132.317V134.394Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 149.979L167.572 148.605V146.528L169.898 147.902V149.979Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 122.906L167.572 121.531V119.454L169.898 120.829V122.906Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 119.076L167.572 117.701V115.624L169.898 116.999V119.076Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 126.735L167.572 125.361V123.284L169.898 124.658V126.735Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 130.565L167.572 129.19V127.113L169.898 128.488V130.565Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 170.104L162.75 168.729V166.652L165.076 168.027V170.104Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 177.763L162.75 176.389V174.312L165.076 175.686V177.763Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 18.9299L167.572 17.555V15.478L169.898 16.853V18.9299Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 173.934L162.75 172.559V170.482L165.076 171.857V173.934Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 22.7589L167.572 21.3846V19.3076L169.898 20.6819V22.7589Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 158.614L162.75 157.24V155.163L165.076 156.537V158.614Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 162.444L162.75 161.069V158.992L165.076 160.367V162.444Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 64.887L167.572 63.5121V61.4351L169.898 62.81V64.887Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 153.809L167.572 152.434V150.357L169.898 151.732V153.809Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 166.274L162.75 164.9V162.823L165.076 164.197V166.274Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 26.5891L167.572 25.2142V23.1372L169.898 24.5121V26.5891Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 45.738L167.572 44.3631V42.2861L169.898 43.6611V45.738Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 49.568L167.572 48.193V46.1167L169.898 47.491V49.568Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 61.0567L167.572 59.6825V57.6055L169.898 58.9797V61.0567Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 57.2273L167.572 55.8524V53.7754L169.898 55.1503V57.2273Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 53.3975L167.572 52.0233V49.9463L169.898 51.3212V53.3975Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 34.2486L167.572 32.8744V30.7974L169.898 32.1723V34.2486Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 41.9078L167.572 40.5335V38.4565L169.898 39.8308V41.9078Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 30.419L167.572 29.0448V26.9678L169.898 28.342V30.419Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 38.0789L167.572 36.7039V34.627L169.898 36.0019V38.0789Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 176.787L167.572 175.412V173.335L169.898 174.71V176.787Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 157.639L167.572 156.264V154.188L169.898 155.562V157.639Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 94.8555L172.396 93.4813V91.4043L174.722 92.7786V94.8555Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 91.026L172.396 89.651V87.5747L174.722 88.949V91.026Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 134.339L222.963 132.965V130.888L225.288 132.262V134.339Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 102.515L172.396 101.14V99.0635L174.722 100.438V102.515Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 87.1954L172.396 85.8211V83.7441L174.722 85.1191V87.1954Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 75.7066L172.396 74.3324V72.2554L174.722 73.6303V75.7066Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 79.5369L172.396 78.1619V76.085L174.722 77.4599V79.5369Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 83.3663L172.396 81.992V79.915L174.722 81.2893V83.3663Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 110.175L172.396 108.8V106.723L174.722 108.098V110.175Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 106.344L172.396 104.97V102.893L174.722 104.268V106.344Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 133.419L172.396 132.044V129.968L174.722 131.342V133.419Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 141.078L172.396 139.703V137.626L174.722 139.001V141.078Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 137.249L172.396 135.874V133.797L174.722 135.172V137.249Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 144.908L172.396 143.533V141.456L174.722 142.831V144.908Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 148.737L172.396 147.363V145.286L174.722 146.661V148.737Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 118.1L172.396 116.725V114.648L174.722 116.023V118.1Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 121.93L172.396 120.555V118.478L174.722 119.853V121.93Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 114.27L172.396 112.895V110.818L174.722 112.193V114.27Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 129.588L172.396 128.214V126.137L174.722 127.511V129.588Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 125.759L172.396 124.384V122.308L174.722 123.682V125.759Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 98.6853L172.396 97.3104V95.2334L174.722 96.6083V98.6853Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 154.785L162.75 153.41V151.333L165.076 152.708V154.785Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 25.614L172.396 24.2391V22.1621L174.722 23.537V25.614Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 21.7838L172.396 20.4095V18.3325L174.722 19.7068V21.7838Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 161.468L167.572 160.094V158.017L169.898 159.392V161.468Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 165.299L167.572 163.924V161.847L169.898 163.222V165.299Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 169.128L167.572 167.754V165.677L169.898 167.051V169.128Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M169.898 172.958L167.572 171.583V169.506L169.898 170.881V172.958Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 48.5921L172.396 47.2171V45.1401L174.722 46.5151V48.5921Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 52.4215L172.396 51.0472V48.9702L174.722 50.3445V52.4215Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 56.2517L172.396 54.8768V52.7998L174.722 54.1747V56.2517Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 67.7415L172.396 66.3665V64.2896L174.722 65.6645V67.7415Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 63.9107L172.396 62.5365V60.4595L174.722 61.8337V63.9107Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 60.0813L172.396 58.7064V56.6294L174.722 58.0043V60.0813Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 44.7618L172.396 43.3875V41.3105L174.722 42.6855V44.7618Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 33.273L172.396 31.8988V29.8218L174.722 31.196V33.273Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 37.1028L172.396 35.7279V33.6509L174.722 35.0258V37.1028Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 29.4431L172.396 28.0682V25.9912L174.722 27.3661V29.4431Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 40.9327L172.396 39.5578V37.4814L174.722 38.8557V40.9327Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M174.722 71.5704L172.396 70.1955V68.1191L174.722 69.4934V71.5704Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 90.9698L227.783 89.5949V87.5186L230.109 88.8928V90.9698Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 94.7999L227.783 93.4256V91.3486L230.109 92.7236V94.7999Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 98.6295L227.783 97.2546V95.1782L230.109 96.5525V98.6295Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 102.459L227.783 101.085V99.0078L230.109 100.383V102.459Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 106.289L227.783 104.914V102.837L230.109 104.212V106.289Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 71.8214L227.783 70.4471V68.3701L230.109 69.7444V71.8214Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 75.6516L227.783 74.2767V72.1997L230.109 73.5746V75.6516Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 110.385L227.783 109.01V106.934L230.109 108.308V110.385Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 87.1404L227.783 85.7655V83.6885L230.109 85.0634V87.1404Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 79.481L227.783 78.1068V76.0298L230.109 77.404V79.481Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 150.955L162.75 149.58V147.503L165.076 148.878V150.955Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 141.023L227.783 139.648V137.571L230.109 138.946V141.023Z",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 114.214L227.783 112.84V110.763L230.109 112.137V114.214Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 137.193L227.783 135.819V133.742L230.109 135.117V137.193Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 148.948L227.783 147.574V145.497L230.109 146.871V148.948Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 144.852L227.783 143.478V141.401L230.109 142.775V144.852Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 133.363L227.783 131.988V129.912L230.109 131.286V133.363Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 67.9918L227.783 66.6169V64.5405L230.109 65.9148V67.9918Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 121.874L227.783 120.5V118.422L230.109 119.797V121.874Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 118.045L227.783 116.67V114.593L230.109 115.968V118.045Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 125.703L227.783 124.329V122.252L230.109 123.626V125.703Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 129.534L227.783 128.159V126.082L230.109 127.457V129.534Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 169.072L222.963 167.698V165.621L225.288 166.995V169.072Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 64.1624L227.783 62.7874V60.7104L230.109 62.0854V64.1624Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 161.413L222.963 160.038V157.961L225.288 159.336V161.413Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 157.583L222.963 156.209V154.132L225.288 155.506V157.583Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 152.778L227.783 151.403V149.326L230.109 150.701V152.778Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 165.243L222.963 163.868V161.792L225.288 163.166V165.243Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 141.999L222.963 140.624V138.547L225.288 139.922V141.999Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 172.902L222.963 171.527V169.45L225.288 170.825V172.902Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 138.169L222.963 136.794V134.717L225.288 136.092V138.169Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 149.924L222.963 148.549V146.472L225.288 147.847V149.924Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 146.094L222.963 144.72V142.643L225.288 144.017V146.094Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 153.753L222.963 152.378V150.302L225.288 151.676V153.753Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 48.8429L227.783 47.4686V45.3916L230.109 46.7659V48.8429Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 176.732L222.963 175.358V173.281L225.288 174.655V176.732Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 52.6724L227.783 51.2982V49.2212L230.109 50.5961V52.6724Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 56.5027L227.783 55.1278V53.0508L230.109 54.4257V56.5027Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 60.3326L227.783 58.9577V56.8813L230.109 58.2556V60.3326Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 45.0139L227.783 43.639V41.562L230.109 42.9369V45.0139Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 41.1832L227.783 39.8089V37.7319L230.109 39.1062V41.1832Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M220.466 31.6936L218.141 30.3187V28.2417L220.466 29.6166V31.6936Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 34.5476L222.963 33.1727V31.0957L225.288 32.4706V34.5476Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 37.4016L227.783 36.0267V33.9497L230.109 35.3246V37.4016Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 83.3101L227.783 81.9359V79.8589L230.109 81.2331V83.3101Z",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 96.8069L162.75 95.432V93.355L165.076 94.7299V96.8069Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 89.1471L162.75 87.7721V85.6958L165.076 87.0701V89.1471Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 92.9766L162.75 91.6024V89.5254L165.076 90.8997V92.9766Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 104.466L162.75 103.092V101.015L165.076 102.39V104.466Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 69.9986L162.75 68.6243V66.5474L165.076 67.9216V69.9986Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 100.637L162.75 99.2619V97.1855L165.076 98.5598V100.637Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 73.8277L162.75 72.4535V70.3765L165.076 71.7514V73.8277Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 85.3181L162.75 83.9432V81.8662L165.076 83.2411V85.3181Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 77.658L162.75 76.283V74.2061L165.076 75.581V77.658Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 81.4874L162.75 80.1131V78.0361L165.076 79.4104V81.4874Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 156.608L227.783 155.234V153.157L230.109 154.531V156.608Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 139.2L162.75 137.826V135.749L165.076 137.123V139.2Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 131.54L162.75 130.165V128.088L165.076 129.463V131.54Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 135.37L162.75 133.995V131.918L165.076 133.293V135.37Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 143.03L162.75 141.655V139.578L165.076 140.953V143.03Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 147.126L162.75 145.751V143.674L165.076 145.049V147.126Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 116.221L162.75 114.847V112.77L165.076 114.144V116.221Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 120.051L162.75 118.676V116.599L165.076 117.974V120.051Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 112.392L162.75 111.017V108.94L165.076 110.315V112.392Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 127.711L162.75 126.336V124.259L165.076 125.634V127.711Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 123.881L162.75 122.507V120.43L165.076 121.804V123.881Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 108.562L162.75 107.187V105.11L165.076 106.485V108.562Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 65.8626L162.75 64.4876V62.4106L165.076 63.7856V65.8626Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 179.586L227.783 178.212V176.135L230.109 177.51V179.586Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 23.7356L162.75 22.3607V20.2837L165.076 21.6586V23.7356Z",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 19.9054L162.75 18.5311V16.4541L165.076 17.829V19.9054Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 16.0758L162.75 14.7008V12.6245L165.076 13.9988V16.0758Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 160.437L227.783 159.063V156.986L230.109 158.361V160.437Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 164.267L227.783 162.892V160.815L230.109 162.19V164.267Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 168.097L227.783 166.722V164.646L230.109 166.02V168.097Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 171.926L227.783 170.552V168.475L230.109 169.85V171.926Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M230.109 175.757L227.783 174.382V172.305L230.109 173.68V175.757Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 54.3738L162.75 52.9989V50.9219L165.076 52.2968V54.3738Z",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 46.7136L162.75 45.3387V43.2617L165.076 44.6366V46.7136Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 50.5431L162.75 49.1688V47.0918L165.076 48.4661V50.5431Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 58.2027L162.75 56.8278V54.7515L165.076 56.1257V58.2027Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 62.0323L162.75 60.658V58.5811L165.076 59.956V62.0323Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 31.3946L162.75 30.0203V27.9434L165.076 29.3176V31.3946Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 27.565L162.75 26.1908V24.1138L165.076 25.488V27.565Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 35.2244L162.75 33.8494V31.7725L165.076 33.1474V35.2244Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 39.0538L162.75 37.6795V35.6025L165.076 36.9768V39.0538Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M165.076 42.884L162.75 41.5091V39.4321L165.076 40.8071V42.884Z",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 54.3084L78.5566 55.6827V53.6057L80.8821 52.2314V54.3084Z",
    fill: "#E6E6E6"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 50.4782L78.5566 51.8531V49.7761L80.8821 48.4019V50.4782Z",
    fill: "#E6E6E6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 58.1375L78.5566 59.5125V57.4355L80.8821 56.0605V58.1375Z",
    fill: "#E6E6E6"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 62.3626L78.5566 63.7369V61.6606L80.8821 60.2856V62.3626Z",
    fill: "#E6E6E6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 66.1922L78.5566 67.5671V65.4902L80.8821 64.1152V66.1922Z",
    fill: "#E6E6E6"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 38.7962L78.5566 40.1705V38.0935L80.8821 36.7192V38.7962Z",
    fill: "#E6E6E6"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 112.456L78.5566 113.83V111.753L80.8821 110.379V112.456Z",
    fill: "#E6E6E6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 31.1366L78.5566 32.5108V30.4338L80.8821 29.0596V31.1366Z",
    fill: "#E6E6E6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 34.9662L78.5566 36.3411V34.2641L80.8821 32.8892V34.9662Z",
    fill: "#E6E6E6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 70.0223L78.5566 71.3966V69.3196L80.8821 67.9453V70.0223Z",
    fill: "#E6E6E6"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 42.6258L78.5566 44.0001V41.9238L80.8821 40.5488V42.6258Z",
    fill: "#E6E6E6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 108.626L78.5566 110.001V107.924L80.8821 106.55V108.626Z",
    fill: "#E6E6E6"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 119.139L73.7363 120.514V118.437L76.0611 117.062V119.139Z",
    fill: "#E6E6E6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 93.3075L78.5566 94.6817V92.6054L80.8821 91.2305V93.3075Z",
    fill: "#E6E6E6"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 97.1366L78.5566 98.5115V96.4345L80.8821 95.0596V97.1366Z",
    fill: "#E6E6E6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 104.796L78.5566 106.17V104.094L80.8821 102.719V104.796Z",
    fill: "#E6E6E6"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 73.8519L78.5566 75.2268V73.1498L80.8821 71.7749V73.8519Z",
    fill: "#E6E6E6"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 27.3068L78.5566 28.6817V26.6047L80.8821 25.2305V27.3068Z",
    fill: "#E6E6E6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 77.682L78.5566 79.0562V76.9792L80.8821 75.605V77.682Z",
    fill: "#E6E6E6"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 81.5116L78.5566 82.8858V80.8088L80.8821 79.4346V81.5116Z",
    fill: "#E6E6E6"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 85.6473L78.5566 87.0222V84.9452L80.8821 83.5703V85.6473Z",
    fill: "#E6E6E6"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 89.4772L78.5566 90.8521V88.7751L80.8821 87.4009V89.4772Z",
    fill: "#E6E6E6"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 46.6097L78.5566 47.9846V45.9076L80.8821 44.5327V46.6097Z",
    fill: "#E6E6E6"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 142.384L73.7363 143.759V141.682L76.0611 140.307V142.384Z",
    fill: "#E6E6E6"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 146.214L73.7363 147.588V145.512L76.0611 144.137V146.214Z",
    fill: "#E6E6E6"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 150.044L73.7363 151.419V149.342L76.0611 147.967V150.044Z",
    fill: "#E6E6E6"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 138.555L73.7363 139.929V137.852L76.0611 136.478V138.555Z",
    fill: "#E6E6E6"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 153.873L73.7363 155.248V153.171L76.0611 151.797V153.873Z",
    fill: "#E6E6E6"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 122.97L73.7363 124.344V122.267L76.0611 120.893V122.97Z",
    fill: "#E6E6E6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 157.703L73.7363 159.077V157L76.0611 155.626V157.703Z",
    fill: "#E6E6E6"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 127.065L73.7363 128.44V126.363L76.0611 124.988V127.065Z",
    fill: "#E6E6E6"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 130.895L73.7363 132.27V130.193L76.0611 128.818V130.895Z",
    fill: "#E6E6E6"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 134.724L73.7363 136.099V134.022L76.0611 132.648V134.724Z",
    fill: "#E6E6E6"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 169.458L73.7363 170.833V168.756L76.0611 167.381V169.458Z",
    fill: "#E6E6E6"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 161.533L73.7363 162.907V160.83L76.0611 159.456V161.533Z",
    fill: "#E6E6E6"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 177.118L73.7363 178.492V176.415L76.0611 175.041V177.118Z",
    fill: "#E6E6E6"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 23.4769L78.5566 24.8518V22.7748L80.8821 21.3999V23.4769Z",
    fill: "#E6E6E6"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 165.629L73.7363 167.003V164.926L76.0611 163.552V165.629Z",
    fill: "#E6E6E6"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 173.288L73.7363 174.663V172.586L76.0611 171.211V173.288Z",
    fill: "#E6E6E6"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 100.967L78.5566 102.341V100.264L80.8821 98.8896V100.967Z",
    fill: "#E6E6E6"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 47.6244L83.3789 48.9993V46.9223L85.7043 45.5474V47.6244Z",
    fill: "#E6E6E6"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 51.4539L83.3789 52.8282V50.7512L85.7043 49.377V51.4539Z",
    fill: "#E6E6E6"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 55.2835L83.3789 56.6578V54.5815L85.7043 53.2065V55.2835Z",
    fill: "#E6E6E6"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 67.1683L83.3789 68.5426V66.4656L85.7043 65.0913V67.1683Z",
    fill: "#E6E6E6"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 59.5086L83.3789 60.8829V58.8059L85.7043 57.4316V59.5086Z",
    fill: "#E6E6E6"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 28.283L83.3789 29.6573V27.5803L85.7043 26.2061V28.283Z",
    fill: "#E6E6E6"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 35.942L83.3789 37.317V35.24L85.7043 33.8657V35.942Z",
    fill: "#E6E6E6"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 32.1126L83.3789 33.4876V31.4106L85.7043 30.0356V32.1126Z",
    fill: "#E6E6E6"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 39.7723L83.3789 41.1466V39.0702L85.7043 37.6953V39.7723Z",
    fill: "#E6E6E6"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 43.7562L83.3789 45.1305V43.0541L85.7043 41.6792V43.7562Z",
    fill: "#E6E6E6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 63.3382L83.3789 64.7131V62.6362L85.7043 61.2612V63.3382Z",
    fill: "#E6E6E6"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 98.1125L83.3789 99.4874V97.4104L85.7043 96.0361V98.1125Z",
    fill: "#E6E6E6"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 90.453L83.3789 91.8272V89.7502L85.7043 88.376V90.453Z",
    fill: "#E6E6E6"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 94.2826L83.3789 95.6575V93.5805L85.7043 92.2056V94.2826Z",
    fill: "#E6E6E6"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 101.942L83.3789 103.316V101.239L85.7043 99.8652V101.942Z",
    fill: "#E6E6E6"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 70.9984L83.3789 72.3726V70.2963L85.7043 68.9214V70.9984Z",
    fill: "#E6E6E6"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 105.772L83.3789 107.147V105.07L85.7043 103.695V105.772Z",
    fill: "#E6E6E6"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 78.6576L83.3789 80.0318V77.9548L85.7043 76.5806V78.6576Z",
    fill: "#E6E6E6"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 74.8275L83.3789 76.2024V74.1254L85.7043 72.7505V74.8275Z",
    fill: "#E6E6E6"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 86.6232L83.3789 87.9981V85.9211L85.7043 84.5469V86.6232Z",
    fill: "#E6E6E6"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 82.7938L83.3789 84.1681V82.0917L85.7043 80.7168V82.7938Z",
    fill: "#E6E6E6"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 143.36L78.5566 144.734V142.657L80.8821 141.283V143.36Z",
    fill: "#E6E6E6"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 139.53L78.5566 140.905V138.828L80.8821 137.453V139.53Z",
    fill: "#E6E6E6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 135.701L78.5566 137.075V134.998L80.8821 133.624V135.701Z",
    fill: "#E6E6E6"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 147.189L78.5566 148.564V146.487L80.8821 145.112V147.189Z",
    fill: "#E6E6E6"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 154.849L78.5566 156.224V154.147L80.8821 152.772V154.849Z",
    fill: "#E6E6E6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 151.019L78.5566 152.394V150.317L80.8821 148.942V151.019Z",
    fill: "#E6E6E6"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 120.116L78.5566 121.49V119.413L80.8821 118.039V120.116Z",
    fill: "#E6E6E6"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 131.87L78.5566 133.245V131.168L80.8821 129.794V131.87Z",
    fill: "#E6E6E6"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 124.211L78.5566 125.586V123.509L80.8821 122.134V124.211Z",
    fill: "#E6E6E6"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 128.041L78.5566 129.416V127.339L80.8821 125.964V128.041Z",
    fill: "#E6E6E6"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 170.434L78.5566 171.809V169.732L80.8821 168.357V170.434Z",
    fill: "#E6E6E6"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 178.094L78.5566 179.468V177.392L80.8821 176.017V178.094Z",
    fill: "#E6E6E6"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 20.6234L83.3789 21.9976V19.9213L85.7043 18.5464V20.6234Z",
    fill: "#E6E6E6"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 116.285L78.5566 117.66V115.583L80.8821 114.208V116.285Z",
    fill: "#E6E6E6"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 166.604L78.5566 167.979V165.902L80.8821 164.527V166.604Z",
    fill: "#E6E6E6"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 174.263L78.5566 175.638V173.561L80.8821 172.187V174.263Z",
    fill: "#E6E6E6"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 158.679L78.5566 160.053V157.976L80.8821 156.602V158.679Z",
    fill: "#E6E6E6"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8821 162.774L78.5566 164.149V162.072L80.8821 160.697V162.774Z",
    fill: "#E6E6E6"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 24.453L83.3789 25.8279V23.7509L85.7043 22.376V24.453Z",
    fill: "#E6E6E6"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 176.142L68.9141 177.517V175.44L71.2395 174.065V176.142Z",
    fill: "#E6E6E6"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 63.8459L68.9141 65.2208V63.1438L71.2395 61.7695V63.8459Z",
    fill: "#E6E6E6"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 68.0706L68.9141 69.4456V67.3686L71.2395 65.9937V68.0706Z",
    fill: "#E6E6E6"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 71.9012L68.9141 73.2755V71.1985L71.2395 69.8242V71.9012Z",
    fill: "#E6E6E6"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 75.7303L68.9141 77.1046V75.0282L71.2395 73.6533V75.7303Z",
    fill: "#E6E6E6"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 60.0164L68.9141 61.3914V59.3144L71.2395 57.9395V60.0164Z",
    fill: "#E6E6E6"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 48.3343L68.9141 49.7092V47.6323L71.2395 46.2573V48.3343Z",
    fill: "#E6E6E6"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 56.1873L68.9141 57.5616V55.4846L71.2395 54.1104V56.1873Z",
    fill: "#E6E6E6"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 79.5602L68.9141 80.9351V78.8582L71.2395 77.4839V79.5602Z",
    fill: "#E6E6E6"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 44.5042L68.9141 45.8785V43.8022L71.2395 42.4272V44.5042Z",
    fill: "#E6E6E6"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 52.3182L68.9141 53.6931V51.6161L71.2395 50.2412V52.3182Z",
    fill: "#E6E6E6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 40.6745L68.9141 42.0494V39.9724L71.2395 38.5981V40.6745Z",
    fill: "#E6E6E6"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 83.39L68.9141 84.7642V82.6873L71.2395 81.313V83.39Z",
    fill: "#E6E6E6"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 106.675L68.9141 108.049V105.973L71.2395 104.598V106.675Z",
    fill: "#E6E6E6"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 118.164L68.9141 119.539V117.462L71.2395 116.087V118.164Z",
    fill: "#E6E6E6"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 102.846L68.9141 104.22V102.143L71.2395 100.769V102.846Z",
    fill: "#E6E6E6"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 114.335L68.9141 115.709V113.632L71.2395 112.258V114.335Z",
    fill: "#E6E6E6"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 110.505L68.9141 111.879V109.802L71.2395 108.428V110.505Z",
    fill: "#E6E6E6"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 99.0155L68.9141 100.39V98.3134L71.2395 96.9385V99.0155Z",
    fill: "#E6E6E6"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 87.2196L68.9141 88.5945V86.5175L71.2395 85.1426V87.2196Z",
    fill: "#E6E6E6"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 91.3556L68.9141 92.7306V90.6536L71.2395 89.2793V91.3556Z",
    fill: "#E6E6E6"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 95.1859L68.9141 96.5601V94.4831L71.2395 93.1089V95.1859Z",
    fill: "#E6E6E6"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 36.8451L68.9141 38.2193V36.143L71.2395 34.7681V36.8451Z",
    fill: "#E6E6E6"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 142.855L143.408 144.23V142.153L145.734 140.778V142.855Z",
    fill: "#E6E6E6"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 146.951L143.408 148.325V146.248L145.734 144.874V146.951Z",
    fill: "#E6E6E6"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 139.026L143.408 140.4V138.323L145.734 136.949V139.026Z",
    fill: "#E6E6E6"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 150.78L143.408 152.155V150.078L145.734 148.704V150.78Z",
    fill: "#E6E6E6"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 154.611L143.408 155.985V153.909L145.734 152.534V154.611Z",
    fill: "#E6E6E6"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 135.195L143.408 136.57V134.493L145.734 133.118V135.195Z",
    fill: "#E6E6E6"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 123.706L143.408 125.081V123.004L145.734 121.629V123.706Z",
    fill: "#E6E6E6"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 127.537L143.408 128.911V126.834L145.734 125.46V127.537Z",
    fill: "#E6E6E6"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 162.27L143.408 163.644V161.567L145.734 160.193V162.27Z",
    fill: "#E6E6E6"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 131.366L143.408 132.74V130.664L145.734 129.289V131.366Z",
    fill: "#E6E6E6"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 121.994L68.9141 123.369V121.292L71.2395 119.917V121.994Z",
    fill: "#E6E6E6"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 115.31L73.7363 116.684V114.608L76.0611 113.233V115.31Z",
    fill: "#E6E6E6"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 29.1849L68.9141 30.5598V28.4828L71.2395 27.1079V29.1849Z",
    fill: "#E6E6E6"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 33.0155L68.9141 34.3897V32.3127L71.2395 30.9385V33.0155Z",
    fill: "#E6E6E6"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 169.929L143.408 171.304V169.227L145.734 167.853V169.929Z",
    fill: "#E6E6E6"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 166.099L143.408 167.474V165.397L145.734 164.022V166.099Z",
    fill: "#E6E6E6"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 173.759L143.408 175.133V173.056L145.734 171.682V173.759Z",
    fill: "#E6E6E6"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 177.588L143.408 178.963V176.886L145.734 175.511V177.588Z",
    fill: "#E6E6E6"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 60.992L73.7363 62.367V60.29L76.0611 58.915V60.992Z",
    fill: "#E6E6E6"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 57.1624L73.7363 58.5367V56.4597L76.0611 55.0854V57.1624Z",
    fill: "#E6E6E6"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 69.0467L73.7363 70.421V68.344L76.0611 66.9697V69.0467Z",
    fill: "#E6E6E6"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 65.2171L73.7363 66.5921V64.5151L76.0611 63.1401V65.2171Z",
    fill: "#E6E6E6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 72.8763L73.7363 74.2506V72.1742L76.0611 70.7993V72.8763Z",
    fill: "#E6E6E6"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 53.3328L73.7363 54.7071V52.6301L76.0611 51.2559V53.3328Z",
    fill: "#E6E6E6"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 37.8213L73.7363 39.1956V37.1186L76.0611 35.7437V37.8213Z",
    fill: "#E6E6E6"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 41.6507L73.7363 43.025V40.948L76.0611 39.5737V41.6507Z",
    fill: "#E6E6E6"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 49.4642L73.7363 50.8391V48.7621L76.0611 47.3872V49.4642Z",
    fill: "#E6E6E6"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 45.4803L73.7363 46.8552V44.7782L76.0611 43.4033V45.4803Z",
    fill: "#E6E6E6"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 92.3319L73.7363 93.7061V91.6291L76.0611 90.2549V92.3319Z",
    fill: "#E6E6E6"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 76.7059L73.7363 78.0808V76.0038L76.0611 74.6289V76.7059Z",
    fill: "#E6E6E6"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 99.9909L73.7363 101.366V99.2888L76.0611 97.9146V99.9909Z",
    fill: "#E6E6E6"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 107.651L73.7363 109.026V106.949L76.0611 105.574V107.651Z",
    fill: "#E6E6E6"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 96.161L73.7363 97.5352V95.4589L76.0611 94.084V96.161Z",
    fill: "#E6E6E6"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 111.48L73.7363 112.855V110.778L76.0611 109.403V111.48Z",
    fill: "#E6E6E6"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 103.821L73.7363 105.195V103.119L76.0611 101.744V103.821Z",
    fill: "#E6E6E6"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 84.3656L73.7363 85.7405V83.6635L76.0611 82.2886V84.3656Z",
    fill: "#E6E6E6"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 125.824L68.9141 127.198V125.122L71.2395 123.747V125.824Z",
    fill: "#E6E6E6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 119.877L143.408 121.251V119.174L145.734 117.8V119.877Z",
    fill: "#E6E6E6"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 33.9911L73.7363 35.3653V33.289L76.0611 31.9141V33.9911Z",
    fill: "#E6E6E6"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 80.536L73.7363 81.9102V79.8332L76.0611 78.459V80.536Z",
    fill: "#E6E6E6"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 152.897L68.9141 154.272V152.195L71.2395 150.82V152.897Z",
    fill: "#E6E6E6"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 149.068L68.9141 150.442V148.366L71.2395 146.991V149.068Z",
    fill: "#E6E6E6"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 160.557L68.9141 161.932V159.855L71.2395 158.48V160.557Z",
    fill: "#E6E6E6"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 156.727L68.9141 158.102V156.025L71.2395 154.651V156.727Z",
    fill: "#E6E6E6"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 164.387L68.9141 165.762V163.685L71.2395 162.311V164.387Z",
    fill: "#E6E6E6"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 145.238L68.9141 146.613V144.536L71.2395 143.162V145.238Z",
    fill: "#E6E6E6"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 129.919L68.9141 131.294V129.217L71.2395 127.842V129.919Z",
    fill: "#E6E6E6"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 30.1615L73.7363 31.5357V29.4587L76.0611 28.0845V30.1615Z",
    fill: "#E6E6E6"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 141.409L68.9141 142.783V140.706L71.2395 139.332V141.409Z",
    fill: "#E6E6E6"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 137.579L68.9141 138.953V136.876L71.2395 135.502V137.579Z",
    fill: "#E6E6E6"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 133.749L68.9141 135.124V133.047L71.2395 131.672V133.749Z",
    fill: "#E6E6E6"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 26.3314L73.7363 27.7063V25.6293L76.0611 24.2544V26.3314Z",
    fill: "#E6E6E6"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 172.313L68.9141 173.687V171.61L71.2395 170.236V172.313Z",
    fill: "#E6E6E6"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 109.602L83.3789 110.976V108.899L85.7043 107.525V109.602Z",
    fill: "#E6E6E6"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2395 168.483L68.9141 169.857V167.78L71.2395 166.406V168.483Z",
    fill: "#E6E6E6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0611 88.5013L73.7363 89.8762V87.7992L76.0611 86.4243V88.5013Z",
    fill: "#E6E6E6"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 109.935L28.4961 111.31V109.233L30.8222 107.858V109.935Z",
    fill: "#E6E6E6"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 113.765L28.4961 115.14V113.063L30.8222 111.688V113.765Z",
    fill: "#E6E6E6"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 117.861L28.4961 119.235V117.159L30.8222 115.784V117.861Z",
    fill: "#E6E6E6"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 121.69L28.4961 123.065V120.988L30.8222 119.613V121.69Z",
    fill: "#E6E6E6"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 125.52L28.4961 126.895V124.818L30.8222 123.443V125.52Z",
    fill: "#E6E6E6"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 129.35L28.4961 130.724V128.647L30.8222 127.273V129.35Z",
    fill: "#E6E6E6"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 90.7858L28.4961 92.1607V90.0837L30.8222 88.7095V90.7858Z",
    fill: "#E6E6E6"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 94.616L28.4961 95.9903V93.9133L30.8222 92.5391V94.616Z",
    fill: "#E6E6E6"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 98.4461L28.4961 99.8211V97.7441L30.8222 96.3691V98.4461Z",
    fill: "#E6E6E6"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 102.276L28.4961 103.65V101.573L30.8222 100.199V102.276Z",
    fill: "#E6E6E6"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 106.106L28.4961 107.481V105.404L30.8222 104.029V106.106Z",
    fill: "#E6E6E6"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 137.01L28.4961 138.384V136.307L30.8222 134.933V137.01Z",
    fill: "#E6E6E6"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 133.18L28.4961 134.554V132.477L30.8222 131.103V133.18Z",
    fill: "#E6E6E6"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 160.254L28.4961 161.628V159.552L30.8222 158.177V160.254Z",
    fill: "#E6E6E6"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 156.424L28.4961 157.799V155.722L30.8222 154.348V156.424Z",
    fill: "#E6E6E6"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 167.913L28.4961 169.288V167.211L30.8222 165.836V167.913Z",
    fill: "#E6E6E6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 164.083L28.4961 165.458V163.381L30.8222 162.006V164.083Z",
    fill: "#E6E6E6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 152.328L28.4961 153.703V151.626L30.8222 150.251V152.328Z",
    fill: "#E6E6E6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 86.9569L28.4961 88.3311V86.2548L30.8222 84.8799V86.9569Z",
    fill: "#E6E6E6"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 140.839L28.4961 142.214V140.137L30.8222 138.762V140.839Z",
    fill: "#E6E6E6"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 144.668L28.4961 146.043V143.966L30.8222 142.591V144.668Z",
    fill: "#E6E6E6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 148.499L28.4961 149.873V147.797L30.8222 146.422V148.499Z",
    fill: "#E6E6E6"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 178.427L23.6758 179.802V177.725L26.0012 176.351V178.427Z",
    fill: "#E6E6E6"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 171.743L28.4961 173.117V171.041L30.8222 169.666V171.743Z",
    fill: "#E6E6E6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 155.182L23.6758 156.557V154.48L26.0012 153.105V155.182Z",
    fill: "#E6E6E6"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 113.432L83.3789 114.807V112.73L85.7043 111.355V113.432Z",
    fill: "#E6E6E6"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 159.279L23.6758 160.653V158.576L26.0012 157.202V159.279Z",
    fill: "#E6E6E6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 170.768L23.6758 172.142V170.065L26.0012 168.691V170.768Z",
    fill: "#E6E6E6"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 163.108L23.6758 164.483V162.406L26.0012 161.031V163.108Z",
    fill: "#E6E6E6"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 166.937L23.6758 168.312V166.235L26.0012 164.86V166.937Z",
    fill: "#E6E6E6"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 71.1126L28.4961 72.4876V70.4106L30.8222 69.0356V71.1126Z",
    fill: "#E6E6E6"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 67.6615L28.4961 69.0357V66.9587L30.8222 65.5845V67.6615Z",
    fill: "#E6E6E6"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 83.1266L28.4961 84.5015V82.4246L30.8222 81.0503V83.1266Z",
    fill: "#E6E6E6"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 79.2972L28.4961 80.6721V78.5951L30.8222 77.2202V79.2972Z",
    fill: "#E6E6E6"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 74.9425L28.4961 76.3175V74.2405L30.8222 72.8662V74.9425Z",
    fill: "#E6E6E6"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 174.597L23.6758 175.971V173.895L26.0012 172.52V174.597Z",
    fill: "#E6E6E6"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 130.326L33.3203 131.7V129.623L35.6457 128.249V130.326Z",
    fill: "#E6E6E6"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 134.156L33.3203 135.53V133.453L35.6457 132.079V134.156Z",
    fill: "#E6E6E6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 137.985L33.3203 139.359V137.283L35.6457 135.908V137.985Z",
    fill: "#E6E6E6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 145.645L33.3203 147.019V144.942L35.6457 143.568V145.645Z",
    fill: "#E6E6E6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 141.814L33.3203 143.189V141.112L35.6457 139.737V141.814Z",
    fill: "#E6E6E6"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 122.666L33.3203 124.041V121.964L35.6457 120.589V122.666Z",
    fill: "#E6E6E6"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 115.007L33.3203 116.381V114.304L35.6457 112.93V115.007Z",
    fill: "#E6E6E6"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 126.496L33.3203 127.87V125.793L35.6457 124.419V126.496Z",
    fill: "#E6E6E6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 118.836L33.3203 120.211V118.134L35.6457 116.759V118.836Z",
    fill: "#E6E6E6"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 149.474L33.3203 150.849V148.772L35.6457 147.397V149.474Z",
    fill: "#E6E6E6"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 176.549L33.3203 177.923V175.846L35.6457 174.472V176.549Z",
    fill: "#E6E6E6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 110.91L33.3203 112.285V110.208L35.6457 108.834V110.91Z",
    fill: "#E6E6E6"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 172.719L33.3203 174.094V172.017L35.6457 170.642V172.719Z",
    fill: "#E6E6E6"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 161.229L33.3203 162.604V160.527L35.6457 159.152V161.229Z",
    fill: "#E6E6E6"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 168.889L33.3203 170.263V168.186L35.6457 166.812V168.889Z",
    fill: "#E6E6E6"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 157.4L33.3203 158.774V156.697L35.6457 155.323V157.4Z",
    fill: "#E6E6E6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 153.57L33.3203 154.945V152.868L35.6457 151.493V153.57Z",
    fill: "#E6E6E6"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 165.059L33.3203 166.434V164.357L35.6457 162.982V165.059Z",
    fill: "#E6E6E6"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 64.8063L33.3203 66.1812V64.1042L35.6457 62.73V64.8063Z",
    fill: "#E6E6E6"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8222 175.573L28.4961 176.948V174.871L30.8222 173.496V175.573Z",
    fill: "#E6E6E6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 107.081L33.3203 108.456V106.379L35.6457 105.004V107.081Z",
    fill: "#E6E6E6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 91.7625L33.3203 93.1368V91.0598L35.6457 89.6855V91.7625Z",
    fill: "#E6E6E6"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 95.5916L33.3203 96.9659V94.8896L35.6457 93.5146V95.5916Z",
    fill: "#E6E6E6"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 99.4215L33.3203 100.796V98.7195L35.6457 97.3452V99.4215Z",
    fill: "#E6E6E6"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 87.9325L33.3203 89.3074V87.2304L35.6457 85.8555V87.9325Z",
    fill: "#E6E6E6"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 103.252L33.3203 104.626V102.55L35.6457 101.175V103.252Z",
    fill: "#E6E6E6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 80.2726L33.3203 81.6475V79.5706L35.6457 78.1963V80.2726Z",
    fill: "#E6E6E6"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 84.1029L33.3203 85.4771V83.4001L35.6457 82.0259V84.1029Z",
    fill: "#E6E6E6"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 76.4432L33.3203 77.8181V75.7411L35.6457 74.3662V76.4432Z",
    fill: "#E6E6E6"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 72.0887L33.3203 73.463V71.386L35.6457 70.0117V72.0887Z",
    fill: "#E6E6E6"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 68.2586L33.3203 69.6336V67.5566L35.6457 66.1816V68.2586Z",
    fill: "#E6E6E6"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 96.495L18.8535 97.8692V95.7922L21.1789 94.418V96.495Z",
    fill: "#E6E6E6"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 76.8211L18.8535 78.1954V76.1184L21.1789 74.7441V76.8211Z",
    fill: "#E6E6E6"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 80.6507L18.8535 82.025V79.9487L21.1789 78.5737V80.6507Z",
    fill: "#E6E6E6"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 88.8353L18.8535 90.2096V88.1332L21.1789 86.7583V88.8353Z",
    fill: "#E6E6E6"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 92.6649L18.8535 94.0398V91.9628L21.1789 90.5879V92.6649Z",
    fill: "#E6E6E6"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 85.0057L18.8535 86.38V84.303L21.1789 82.9287V85.0057Z",
    fill: "#E6E6E6"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 138.888L18.8535 140.262V138.185L21.1789 136.811V138.888Z",
    fill: "#E6E6E6"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 73.3695L18.8535 74.7437V72.6674L21.1789 71.2925V73.3695Z",
    fill: "#E6E6E6"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 123.569L18.8535 124.944V122.867L21.1789 121.492V123.569Z",
    fill: "#E6E6E6"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 127.399L18.8535 128.774V126.697L21.1789 125.322V127.399Z",
    fill: "#E6E6E6"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 131.228L18.8535 132.603V130.526L21.1789 129.151V131.228Z",
    fill: "#E6E6E6"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 119.473L18.8535 120.848V118.771L21.1789 117.396V119.473Z",
    fill: "#E6E6E6"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 135.058L18.8535 136.433V134.356L21.1789 132.981V135.058Z",
    fill: "#E6E6E6"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 104.154L18.8535 105.529V103.452L21.1789 102.078V104.154Z",
    fill: "#E6E6E6"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 100.325L18.8535 101.7V99.623L21.1789 98.248V100.325Z",
    fill: "#E6E6E6"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 107.984L18.8535 109.358V107.281L21.1789 105.907V107.984Z",
    fill: "#E6E6E6"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 115.644L18.8535 117.019V114.942L21.1789 113.567V115.644Z",
    fill: "#E6E6E6"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 111.814L18.8535 113.189V111.112L21.1789 109.737V111.814Z",
    fill: "#E6E6E6"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 136.676L83.3789 138.051V135.974L85.7043 134.599V136.676Z",
    fill: "#E6E6E6"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 140.506L83.3789 141.881V139.804L85.7043 138.429V140.506Z",
    fill: "#E6E6E6"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 148.165L83.3789 149.54V147.463L85.7043 146.088V148.165Z",
    fill: "#E6E6E6"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 144.336L83.3789 145.71V143.633L85.7043 142.259V144.336Z",
    fill: "#E6E6E6"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 151.995L83.3789 153.37V151.293L85.7043 149.918V151.995Z",
    fill: "#E6E6E6"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 121.357L83.3789 122.732V120.655L85.7043 119.28V121.357Z",
    fill: "#E6E6E6"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 117.261L83.3789 118.636V116.559L85.7043 115.185V117.261Z",
    fill: "#E6E6E6"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 125.187L83.3789 126.561V124.485L85.7043 123.11V125.187Z",
    fill: "#E6E6E6"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 129.016L83.3789 130.391V128.314L85.7043 126.94V129.016Z",
    fill: "#E6E6E6"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 132.846L83.3789 134.22V132.143L85.7043 130.769V132.846Z",
    fill: "#E6E6E6"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 151.353L23.6758 152.728V150.651L26.0012 149.276V151.353Z",
    fill: "#E6E6E6"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 175.239L83.3789 176.613V174.536L85.7043 173.162V175.239Z",
    fill: "#E6E6E6"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 155.825L83.3789 157.2V155.123L85.7043 153.748V155.825Z",
    fill: "#E6E6E6"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 159.92L83.3789 161.295V159.218L85.7043 157.843V159.92Z",
    fill: "#E6E6E6"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 163.75L83.3789 165.125V163.048L85.7043 161.673V163.75Z",
    fill: "#E6E6E6"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 167.58L83.3789 168.954V166.878L85.7043 165.503V167.58Z",
    fill: "#E6E6E6"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7043 171.41L83.3789 172.784V170.707L85.7043 169.333V171.41Z",
    fill: "#E6E6E6"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 93.6403L23.6758 95.0152V92.9382L26.0012 91.564V93.6403Z",
    fill: "#E6E6E6"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 97.4705L23.6758 98.8448V96.7685L26.0012 95.3936V97.4705Z",
    fill: "#E6E6E6"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 105.13L23.6758 106.504V104.427L26.0012 103.053V105.13Z",
    fill: "#E6E6E6"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 89.8104L23.6758 91.1853V89.1083L26.0012 87.7334V89.8104Z",
    fill: "#E6E6E6"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 101.3L23.6758 102.675V100.598L26.0012 99.2231V101.3Z",
    fill: "#E6E6E6"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 73.9669L23.6758 75.3419V73.2649L26.0012 71.8906V73.9669Z",
    fill: "#E6E6E6"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 108.959L23.6758 110.334V108.257L26.0012 106.882V108.959Z",
    fill: "#E6E6E6"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 77.7967L23.6758 79.171V77.0946L26.0012 75.7197V77.7967Z",
    fill: "#E6E6E6"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 85.9813L23.6758 87.3556V85.2792L26.0012 83.9043V85.9813Z",
    fill: "#E6E6E6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 82.1515L23.6758 83.5264V81.4495L26.0012 80.0752V82.1515Z",
    fill: "#E6E6E6"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 124.544L23.6758 125.919V123.842L26.0012 122.467V124.544Z",
    fill: "#E6E6E6"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 136.033L23.6758 137.408V135.331L26.0012 133.957V136.033Z",
    fill: "#E6E6E6"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 139.864L23.6758 141.238V139.162L26.0012 137.787V139.864Z",
    fill: "#E6E6E6"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 132.204L23.6758 133.579V131.502L26.0012 130.127V132.204Z",
    fill: "#E6E6E6"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 143.693L23.6758 145.068V142.991L26.0012 141.616V143.693Z",
    fill: "#E6E6E6"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 147.523L23.6758 148.898V146.821L26.0012 145.446V147.523Z",
    fill: "#E6E6E6"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 112.789L23.6758 114.164V112.087L26.0012 110.712V112.789Z",
    fill: "#E6E6E6"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 128.375L23.6758 129.749V127.672L26.0012 126.298V128.375Z",
    fill: "#E6E6E6"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 116.619L23.6758 117.994V115.917L26.0012 114.542V116.619Z",
    fill: "#E6E6E6"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 120.715L23.6758 122.089V120.013L26.0012 118.638V120.715Z",
    fill: "#E6E6E6"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0012 70.5155L23.6758 71.8904V69.8127L26.0012 68.4385V70.5155Z",
    fill: "#E6E6E6"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 169.792L18.8535 171.167V169.09L21.1789 167.715V169.792Z",
    fill: "#E6E6E6"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 165.962L18.8535 167.336V165.26L21.1789 163.885V165.962Z",
    fill: "#E6E6E6"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 142.718L18.8535 144.092V142.016L21.1789 140.641V142.718Z",
    fill: "#E6E6E6"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 162.132L18.8535 163.506V161.429L21.1789 160.055V162.132Z",
    fill: "#E6E6E6"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 177.451L18.8535 178.826V176.749L21.1789 175.374V177.451Z",
    fill: "#E6E6E6"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 173.622L18.8535 174.996V172.919L21.1789 171.545V173.622Z",
    fill: "#E6E6E6"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 146.547L18.8535 147.922V145.845L21.1789 144.471V146.547Z",
    fill: "#E6E6E6"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 150.377L18.8535 151.752V149.675L21.1789 148.3V150.377Z",
    fill: "#E6E6E6"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 158.037L18.8535 159.412V157.335L21.1789 155.96V158.037Z",
    fill: "#E6E6E6"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 154.207L18.8535 155.581V153.505L21.1789 152.13V154.207Z",
    fill: "#E6E6E6"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 158.44L143.408 159.815V157.738L145.734 156.363V158.44Z",
    fill: "#E6E6E6"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 178.212L235.426 179.586V177.51L237.751 176.135V178.212Z",
    fill: "#E6E6E6"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 36.9554L240.25 38.3297V36.2527L242.575 34.8784V36.9554Z",
    fill: "#E6E6E6"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 159.063L235.426 160.437V158.361L237.751 156.986V159.063Z",
    fill: "#E6E6E6"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 40.7845L240.25 42.1594V40.0824L242.575 38.7075V40.7845Z",
    fill: "#E6E6E6"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 162.892L235.426 164.267V162.19L237.751 160.815V162.892Z",
    fill: "#E6E6E6"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 155.234L235.426 156.608V154.531L237.751 153.157V155.234Z",
    fill: "#E6E6E6"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 170.552L235.426 171.926V169.85L237.751 168.475V170.552Z",
    fill: "#E6E6E6"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 174.382L235.426 175.757V173.68L237.751 172.305V174.382Z",
    fill: "#E6E6E6"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 166.722L235.426 168.097V166.02L237.751 164.646V166.722Z",
    fill: "#E6E6E6"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 71.4227L240.25 72.7976V70.7206L242.575 69.3457V71.4227Z",
    fill: "#E6E6E6"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 67.5926L240.25 68.9669V66.8899L242.575 65.5156V67.5926Z",
    fill: "#E6E6E6"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 75.2523L240.25 76.6272V74.5502L242.575 73.1753V75.2523Z",
    fill: "#E6E6E6"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 63.763L240.25 65.1379V63.061L242.575 61.686V63.763Z",
    fill: "#E6E6E6"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 79.0824L240.25 80.4566V78.3796L242.575 77.0054V79.0824Z",
    fill: "#E6E6E6"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 59.9334L240.25 61.3084V59.2314L242.575 57.8564V59.9334Z",
    fill: "#E6E6E6"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 48.4442L240.25 49.8184V47.7415L242.575 46.3672V48.4442Z",
    fill: "#E6E6E6"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 44.6141L240.25 45.989V43.912L242.575 42.5371V44.6141Z",
    fill: "#E6E6E6"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 52.2733L240.25 53.6482V51.5712L242.575 50.1963V52.2733Z",
    fill: "#E6E6E6"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 56.1038L240.25 57.4781V55.4011L242.575 54.0269V56.1038Z",
    fill: "#E6E6E6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 89.5949L235.426 90.9698V88.8928L237.751 87.5186V89.5949Z",
    fill: "#E6E6E6"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 93.4256L235.426 94.7999V92.7236L237.751 91.3486V93.4256Z",
    fill: "#E6E6E6"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 97.2546L235.426 98.6295V96.5525L237.751 95.1782V97.2546Z",
    fill: "#E6E6E6"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 82.9115L240.25 84.2864V82.2094L242.575 80.8345V82.9115Z",
    fill: "#E6E6E6"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 101.085L235.426 102.459V100.383L237.751 99.0078V101.085Z",
    fill: "#E6E6E6"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 151.403L235.426 152.778V150.701L237.751 149.326V151.403Z",
    fill: "#E6E6E6"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 109.01L235.426 110.385V108.308L237.751 106.934V109.01Z",
    fill: "#E6E6E6"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 85.7655L235.426 87.1404V85.0634L237.751 83.6885V85.7655Z",
    fill: "#E6E6E6"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 74.2767L235.426 75.6516V73.5746L237.751 72.1997V74.2767Z",
    fill: "#E6E6E6"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 78.1068L235.426 79.481V77.404L237.751 76.0298V78.1068Z",
    fill: "#E6E6E6"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 81.9359L235.426 83.3101V81.2331L237.751 79.8589V81.9359Z",
    fill: "#E6E6E6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 104.914L235.426 106.289V104.212L237.751 102.837V104.914Z",
    fill: "#E6E6E6"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 139.648L235.426 141.023V138.946L237.751 137.571V139.648Z",
    fill: "#E6E6E6"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 135.819L235.426 137.193V135.117L237.751 133.742V135.819Z",
    fill: "#E6E6E6"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 143.478L235.426 144.852V142.775L237.751 141.401V143.478Z",
    fill: "#E6E6E6"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 112.84L235.426 114.214V112.137L237.751 110.763V112.84Z",
    fill: "#E6E6E6"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 131.988L235.426 133.363V131.286L237.751 129.912V131.988Z",
    fill: "#E6E6E6"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 147.574L235.426 148.948V146.871L237.751 145.497V147.574Z",
    fill: "#E6E6E6"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 120.5L235.426 121.874V119.797L237.751 118.422V120.5Z",
    fill: "#E6E6E6"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 116.67L235.426 118.045V115.968L237.751 114.593V116.67Z",
    fill: "#E6E6E6"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 128.159L235.426 129.534V127.457L237.751 126.082V128.159Z",
    fill: "#E6E6E6"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 124.329L235.426 125.703V123.626L237.751 122.252V124.329Z",
    fill: "#E6E6E6"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 72.4894L182.793 73.8643V71.7873L185.118 70.4131V72.4894Z",
    fill: "#E6E6E6"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 30.3626L182.793 31.7376V29.6606L185.118 28.2856V30.3626Z",
    fill: "#E6E6E6"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 26.533L182.793 27.9073V25.831L185.118 24.4561V26.533Z",
    fill: "#E6E6E6"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 34.1922L182.793 35.5665V33.4895L185.118 32.1152V34.1922Z",
    fill: "#E6E6E6"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 41.8524L182.793 43.2266V41.1497L185.118 39.7754V41.8524Z",
    fill: "#E6E6E6"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 38.0223L182.793 39.3972V37.3202L185.118 35.9453V38.0223Z",
    fill: "#E6E6E6"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 22.7035L182.793 24.0777V22.0007L185.118 20.6265V22.7035Z",
    fill: "#E6E6E6"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 175.358L240.25 176.732V174.655L242.575 173.281V175.358Z",
    fill: "#E6E6E6"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 171.527L240.25 172.902V170.825L242.575 169.45V171.527Z",
    fill: "#E6E6E6"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 68.66L182.793 70.0349V67.9579L185.118 66.583V68.66Z",
    fill: "#E6E6E6"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 70.4471L235.426 71.8214V69.7444L237.751 68.3701V70.4471Z",
    fill: "#E6E6E6"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 80.4559L182.793 81.8308V79.7538L185.118 78.3789V80.4559Z",
    fill: "#E6E6E6"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 86.742L240.25 88.1163V86.0393L242.575 84.665V86.742Z",
    fill: "#E6E6E6"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 45.682L182.793 47.0569V44.9799L185.118 43.605V45.682Z",
    fill: "#E6E6E6"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 76.6263L182.793 78.0012V75.9236L185.118 74.5493V76.6263Z",
    fill: "#E6E6E6"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 61.0006L182.793 62.3756V60.2986L185.118 58.9243V61.0006Z",
    fill: "#E6E6E6"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 53.3416L182.793 54.7159V52.6396L185.118 51.2646V53.3416Z",
    fill: "#E6E6E6"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 49.5109L182.793 50.8858V48.8088L185.118 47.4346V49.5109Z",
    fill: "#E6E6E6"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 57.1707L182.793 58.5457V56.4687L185.118 55.0938V57.1707Z",
    fill: "#E6E6E6"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 64.8304L182.793 66.2047V64.1277L185.118 62.7534V64.8304Z",
    fill: "#E6E6E6"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 106.156L240.25 107.531V105.454L242.575 104.079V106.156Z",
    fill: "#E6E6E6"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 113.816L240.25 115.19V113.114L242.575 111.739V113.816Z",
    fill: "#E6E6E6"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 109.985L240.25 111.36V109.283L242.575 107.909V109.985Z",
    fill: "#E6E6E6"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 117.645L240.25 119.02V116.943L242.575 115.568V117.645Z",
    fill: "#E6E6E6"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 121.475L240.25 122.85V120.773L242.575 119.398V121.475Z",
    fill: "#E6E6E6"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 102.06L240.25 103.435V101.358L242.575 99.9834V102.06Z",
    fill: "#E6E6E6"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 90.5716L240.25 91.9459V89.8689L242.575 88.4946V90.5716Z",
    fill: "#E6E6E6"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 94.4007L240.25 95.7756V93.6987L242.575 92.3237V94.4007Z",
    fill: "#E6E6E6"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 98.2308L240.25 99.6051V97.5281L242.575 96.1538V98.2308Z",
    fill: "#E6E6E6"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 125.305L240.25 126.68V124.603L242.575 123.228V125.305Z",
    fill: "#E6E6E6"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 163.868L240.25 165.243V163.166L242.575 161.792V163.868Z",
    fill: "#E6E6E6"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 152.378L240.25 153.753V151.676L242.575 150.302V152.378Z",
    fill: "#E6E6E6"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 156.209L240.25 157.583V155.506L242.575 154.132V156.209Z",
    fill: "#E6E6E6"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 148.549L240.25 149.924V147.847L242.575 146.472V148.549Z",
    fill: "#E6E6E6"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 167.698L240.25 169.072V166.995L242.575 165.621V167.698Z",
    fill: "#E6E6E6"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 160.038L240.25 161.413V159.336L242.575 157.961V160.038Z",
    fill: "#E6E6E6"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 140.624L240.25 141.999V139.922L242.575 138.547V140.624Z",
    fill: "#E6E6E6"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 144.72L240.25 146.094V144.017L242.575 142.643V144.72Z",
    fill: "#E6E6E6"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 136.794L240.25 138.169V136.092L242.575 134.717V136.794Z",
    fill: "#E6E6E6"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 132.965L240.25 134.339V132.262L242.575 130.888V132.965Z",
    fill: "#E6E6E6"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 129.134L240.25 130.509V128.432L242.575 127.057V129.134Z",
    fill: "#E6E6E6"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 151.326L270.84 149.952V147.875L273.165 149.249V151.326Z",
    fill: "#E6E6E6"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 164.056L266.018 162.682V160.605L268.343 161.979V164.056Z",
    fill: "#E6E6E6"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 148.471L266.018 147.096V145.02L268.343 146.394V148.471Z",
    fill: "#E6E6E6"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 160.227L266.018 158.852V156.775L268.343 158.15V160.227Z",
    fill: "#E6E6E6"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 156.131L266.018 154.756V152.68L268.343 154.054V156.131Z",
    fill: "#E6E6E6"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 121.663L266.018 120.289V118.212L268.343 119.587V121.663Z",
    fill: "#E6E6E6"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 125.493L266.018 124.118V122.042L268.343 123.416V125.493Z",
    fill: "#E6E6E6"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 129.323L266.018 127.949V125.872L268.343 127.246V129.323Z",
    fill: "#E6E6E6"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 136.982L266.018 135.608V133.531L268.343 134.906V136.982Z",
    fill: "#E6E6E6"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 133.153L266.018 131.778V129.701L268.343 131.076V133.153Z",
    fill: "#E6E6E6"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 140.812L266.018 139.438V137.361L268.343 138.736V140.812Z",
    fill: "#E6E6E6"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 152.301L266.018 150.927V148.85L268.343 150.224V152.301Z",
    fill: "#E6E6E6"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 167.886L266.018 166.512V164.435L268.343 165.81V167.886Z",
    fill: "#E6E6E6"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 175.545L266.018 174.171V172.094L268.343 173.468V175.545Z",
    fill: "#E6E6E6"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 171.716L266.018 170.342V168.265L268.343 169.639V171.716Z",
    fill: "#E6E6E6"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 179.375L266.018 178V175.923L268.343 177.298V179.375Z",
    fill: "#E6E6E6"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 144.642L266.018 143.267V141.19L268.343 142.565V144.642Z",
    fill: "#E6E6E6"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 71.3045L266.018 69.9295V67.8525L268.343 69.2275V71.3045Z",
    fill: "#E6E6E6"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 75.1339L266.018 73.7596V71.6826L268.343 73.0569V75.1339Z",
    fill: "#E6E6E6"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 67.4742L266.018 66.0999V64.0229L268.343 65.3979V67.4742Z",
    fill: "#E6E6E6"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 90.7595L266.018 89.3846V87.3076L268.343 88.6825V90.7595Z",
    fill: "#E6E6E6"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 106.078L266.018 104.703V102.627L268.343 104.001V106.078Z",
    fill: "#E6E6E6"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 102.249L266.018 100.874V98.7974L268.343 100.172V102.249Z",
    fill: "#E6E6E6"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 113.738L266.018 112.363V110.287L268.343 111.661V113.738Z",
    fill: "#E6E6E6"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 98.4185L266.018 97.0443V94.9673L268.343 96.3422V98.4185Z",
    fill: "#E6E6E6"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 109.908L266.018 108.534V106.457L268.343 107.831V109.908Z",
    fill: "#E6E6E6"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 83.1002L266.018 81.7253V79.6489L268.343 81.0232V83.1002Z",
    fill: "#E6E6E6"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 86.9298L266.018 85.5555V83.4785L268.343 84.8528V86.9298Z",
    fill: "#E6E6E6"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 78.9641L266.018 77.5892V75.5122L268.343 76.8871V78.9641Z",
    fill: "#E6E6E6"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 117.567L266.018 116.193V114.116L268.343 115.49V117.567Z",
    fill: "#E6E6E6"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M268.343 94.5894L266.018 93.2145V91.1382L268.343 92.5124V94.5894Z",
    fill: "#E6E6E6"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 108.933L270.84 107.558V105.481L273.165 106.856V108.933Z",
    fill: "#E6E6E6"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 174.57L270.84 173.196V171.119L273.165 172.493V174.57Z",
    fill: "#E6E6E6"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 170.741L270.84 169.366V167.289L273.165 168.664V170.741Z",
    fill: "#E6E6E6"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 178.4L270.84 177.025V174.948L273.165 176.323V178.4Z",
    fill: "#E6E6E6"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 166.91L270.84 165.536V163.459L273.165 164.833V166.91Z",
    fill: "#E6E6E6"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 163.081L270.84 161.706V159.629L273.165 161.004V163.081Z",
    fill: "#E6E6E6"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 84.286L182.793 85.6602V83.5832L185.118 82.209V84.286Z",
    fill: "#E6E6E6"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 155.155L270.84 153.781V151.704L273.165 153.079V155.155Z",
    fill: "#E6E6E6"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 158.985L270.84 157.611V155.534L273.165 156.908V158.985Z",
    fill: "#E6E6E6"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 62.7874L235.426 64.1624V62.0854L237.751 60.7104V62.7874Z",
    fill: "#E6E6E6"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 55.1278L235.426 56.5027V54.4257L237.751 53.0508V55.1278Z",
    fill: "#E6E6E6"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 58.9577L235.426 60.3326V58.2556L237.751 56.8813V58.9577Z",
    fill: "#E6E6E6"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 147.496L270.84 146.121V144.045L273.165 145.419V147.496Z",
    fill: "#E6E6E6"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 47.4686L235.426 48.8429V46.7659L237.751 45.3916V47.4686Z",
    fill: "#E6E6E6"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 51.2982L235.426 52.6724V50.5961L237.751 49.2212V51.2982Z",
    fill: "#E6E6E6"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 43.639L235.426 45.0139V42.9369L237.751 41.562V43.639Z",
    fill: "#E6E6E6"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 39.8089L235.426 41.1832V39.1062L237.751 37.7319V39.8089Z",
    fill: "#E6E6E6"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M242.575 33.1727L240.25 34.5476V32.4706L242.575 31.0957V33.1727Z",
    fill: "#E6E6E6"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 36.0267L235.426 37.4016V35.3246L237.751 33.9497V36.0267Z",
    fill: "#E6E6E6"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 136.007L270.84 134.632V132.555L273.165 133.93V136.007Z",
    fill: "#E6E6E6"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 81.8181L270.84 80.4432V78.3662L273.165 79.7411V81.8181Z",
    fill: "#E6E6E6"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 85.9542L270.84 84.5793V82.5029L273.165 83.8772V85.9542Z",
    fill: "#E6E6E6"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 89.7838L270.84 88.4095V86.3325L273.165 87.7068V89.7838Z",
    fill: "#E6E6E6"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 97.4434L270.84 96.0692V93.9922L273.165 95.3665V97.4434Z",
    fill: "#E6E6E6"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 93.614L270.84 92.2391V90.1621L273.165 91.537V93.614Z",
    fill: "#E6E6E6"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 101.274L270.84 99.8988V97.8218L273.165 99.1967V101.274Z",
    fill: "#E6E6E6"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 70.3282L270.84 68.9539V66.877L273.165 68.2519V70.3282Z",
    fill: "#E6E6E6"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 77.9879L270.84 76.6136V74.5366L273.165 75.9116V77.9879Z",
    fill: "#E6E6E6"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 74.1588L270.84 72.7838V70.7075L273.165 72.0818V74.1588Z",
    fill: "#E6E6E6"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 120.421L270.84 119.047V116.97L273.165 118.345V120.421Z",
    fill: "#E6E6E6"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 124.517L270.84 123.143V121.066L273.165 122.441V124.517Z",
    fill: "#E6E6E6"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 132.177L270.84 130.803V128.726L273.165 130.1V132.177Z",
    fill: "#E6E6E6"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 128.347L270.84 126.972V124.896L273.165 126.27V128.347Z",
    fill: "#E6E6E6"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 105.103L270.84 103.728V101.651L273.165 103.026V105.103Z",
    fill: "#E6E6E6"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 139.837L270.84 138.462V136.385L273.165 137.76V139.837Z",
    fill: "#E6E6E6"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M237.751 66.6169L235.426 67.9918V65.9148L237.751 64.5405V66.6169Z",
    fill: "#E6E6E6"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 112.762L270.84 111.388V109.311L273.165 110.685V112.762Z",
    fill: "#E6E6E6"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 116.592L270.84 115.217V113.141L273.165 114.515V116.592Z",
    fill: "#E6E6E6"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 143.666L270.84 142.292V140.215L273.165 141.589V143.666Z",
    fill: "#E6E6E6"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 92.8024L143.408 94.1773V92.1003L145.734 90.7261V92.8024Z",
    fill: "#E6E6E6"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 159.534L192.436 160.908V158.832L194.761 157.457V159.534Z",
    fill: "#E6E6E6"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 45.6038L138.588 46.9781V44.9018L140.913 43.5269V45.6038Z",
    fill: "#E6E6E6"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 171.023L192.436 172.398V170.321L194.761 168.946V171.023Z",
    fill: "#E6E6E6"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 163.364L192.436 164.739V162.662L194.761 161.287V163.364Z",
    fill: "#E6E6E6"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 167.194L192.436 168.568V166.491L194.761 165.117V167.194Z",
    fill: "#E6E6E6"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 174.852L192.436 176.227V174.15L194.761 172.775V174.852Z",
    fill: "#E6E6E6"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 53.5291L138.588 54.9041V52.8271L140.913 51.4521V53.5291Z",
    fill: "#E6E6E6"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 49.7L138.588 51.075V48.998L140.913 47.623V49.7Z",
    fill: "#E6E6E6"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 80.3377L138.588 81.7127V79.6357L140.913 78.2607V80.3377Z",
    fill: "#E6E6E6"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 84.1668L138.588 85.5418V83.4648L140.913 82.0898V84.1668Z",
    fill: "#E6E6E6"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 76.5081L138.588 77.8824V75.8054L140.913 74.4312V76.5081Z",
    fill: "#E6E6E6"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 91.827L138.588 93.2019V91.1249L140.913 89.75V91.827Z",
    fill: "#E6E6E6"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 57.3597L138.588 58.734V56.657L140.913 55.2827V57.3597Z",
    fill: "#E6E6E6"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 88.1156L182.793 89.4898V87.4135L185.118 86.0386V88.1156Z",
    fill: "#E6E6E6"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 61.1888L138.588 62.5637V60.4867L140.913 59.1118V61.1888Z",
    fill: "#E6E6E6"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 65.0187L138.588 66.3936V64.3166L140.913 62.9424V65.0187Z",
    fill: "#E6E6E6"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 68.8485L138.588 70.2227V68.1457L140.913 66.7715V68.8485Z",
    fill: "#E6E6E6"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 72.6781L138.588 74.053V71.976L140.913 70.6011V72.6781Z",
    fill: "#E6E6E6"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 113.311L192.436 114.686V112.609L194.761 111.234V113.311Z",
    fill: "#E6E6E6"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 97.7259L192.436 99.1008V97.0239L194.761 95.6489V97.7259Z",
    fill: "#E6E6E6"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 101.556L192.436 102.93V100.853L194.761 99.479V101.556Z",
    fill: "#E6E6E6"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 105.386L192.436 106.761V104.684L194.761 103.309V105.386Z",
    fill: "#E6E6E6"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 109.481L192.436 110.856V108.779L194.761 107.404V109.481Z",
    fill: "#E6E6E6"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 74.7479L192.436 76.1222V74.0458L194.761 72.6709V74.7479Z",
    fill: "#E6E6E6"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 93.8963L192.436 95.2706V93.1943L194.761 91.8193V93.8963Z",
    fill: "#E6E6E6"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 82.4076L192.436 83.7818V81.7055L194.761 80.3306V82.4076Z",
    fill: "#E6E6E6"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 155.704L192.436 157.079V155.002L194.761 153.627V155.704Z",
    fill: "#E6E6E6"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 86.2367L192.436 87.6116V85.5346L194.761 84.1597V86.2367Z",
    fill: "#E6E6E6"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 90.0672L192.436 91.4415V89.3645L194.761 87.9902V90.0672Z",
    fill: "#E6E6E6"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 78.5773L192.436 79.9522V77.8752L194.761 76.501V78.5773Z",
    fill: "#E6E6E6"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 143.949L192.436 145.323V143.246L194.761 141.872V143.949Z",
    fill: "#E6E6E6"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 140.119L192.436 141.494V139.417L194.761 138.042V140.119Z",
    fill: "#E6E6E6"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 151.875L192.436 153.25V151.173L194.761 149.798V151.875Z",
    fill: "#E6E6E6"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 148.045L192.436 149.42V147.343L194.761 145.968V148.045Z",
    fill: "#E6E6E6"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 136.29L192.436 137.664V135.588L194.761 134.213V136.29Z",
    fill: "#E6E6E6"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 124.801L192.436 126.175V124.099L194.761 122.724V124.801Z",
    fill: "#E6E6E6"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 132.459L192.436 133.834V131.757L194.761 130.382V132.459Z",
    fill: "#E6E6E6"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 120.971L192.436 122.345V120.268L194.761 118.894V120.971Z",
    fill: "#E6E6E6"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 117.141L192.436 118.515V116.439L194.761 115.064V117.141Z",
    fill: "#E6E6E6"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 128.63L192.436 130.005V127.928L194.761 126.553V128.63Z",
    fill: "#E6E6E6"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 95.6564L138.588 97.0313V94.9543L140.913 93.5801V95.6564Z",
    fill: "#E6E6E6"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 58.3348L143.408 59.7097V57.6327L145.734 56.2578V58.3348Z",
    fill: "#E6E6E6"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 73.6535L143.408 75.0284V72.9514L145.734 71.5771V73.6535Z",
    fill: "#E6E6E6"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 62.1642L143.408 63.5391V61.4622L145.734 60.0879V62.1642Z",
    fill: "#E6E6E6"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 69.8241L143.408 71.199V69.122L145.734 67.7471V69.8241Z",
    fill: "#E6E6E6"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 65.9945L143.408 67.3687V65.2918L145.734 63.9175V65.9945Z",
    fill: "#E6E6E6"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 54.5046L143.408 55.8795V53.8025L145.734 52.4282V54.5046Z",
    fill: "#E6E6E6"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 42.7498L143.408 44.1241V42.0471L145.734 40.6729V42.7498Z",
    fill: "#E6E6E6"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 46.8455L143.408 48.2198V46.1435L145.734 44.7686V46.8455Z",
    fill: "#E6E6E6"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 50.6751L143.408 52.0501V49.9731L145.734 48.5981V50.6751Z",
    fill: "#E6E6E6"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 96.6327L143.408 98.0069V95.9306L145.734 94.5557V96.6327Z",
    fill: "#E6E6E6"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 77.4837L143.408 78.858V76.7817L145.734 75.4067V77.4837Z",
    fill: "#E6E6E6"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 104.292L143.408 105.667V103.59L145.734 102.215V104.292Z",
    fill: "#E6E6E6"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 108.387L143.408 109.762V107.685L145.734 106.311V108.387Z",
    fill: "#E6E6E6"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 112.218L143.408 113.593V111.516L145.734 110.141V112.218Z",
    fill: "#E6E6E6"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 100.462L143.408 101.837V99.7597L145.734 98.3848V100.462Z",
    fill: "#E6E6E6"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 116.047L143.408 117.421V115.344L145.734 113.97V116.047Z",
    fill: "#E6E6E6"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 85.1429L143.408 86.5172V84.4402L145.734 83.0659V85.1429Z",
    fill: "#E6E6E6"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 81.3133L143.408 82.6882V80.6113L145.734 79.2363V81.3133Z",
    fill: "#E6E6E6"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M145.734 88.973L143.408 90.3479V88.2709L145.734 86.896V88.973Z",
    fill: "#E6E6E6"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 172.784L138.588 174.158V172.081L140.913 170.707V172.784Z",
    fill: "#E6E6E6"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 126.56L138.588 127.935V125.858L140.913 124.483V126.56Z",
    fill: "#E6E6E6"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 122.731L138.588 124.105V122.029L140.913 120.654V122.731Z",
    fill: "#E6E6E6"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 134.22L138.588 135.595V133.518L140.913 132.143V134.22Z",
    fill: "#E6E6E6"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 118.901L138.588 120.275V118.198L140.913 116.824V118.901Z",
    fill: "#E6E6E6"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 130.39L138.588 131.765V129.688L140.913 128.313V130.39Z",
    fill: "#E6E6E6"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 103.316L138.588 104.691V102.614L140.913 101.239V103.316Z",
    fill: "#E6E6E6"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 107.146L138.588 108.521V106.444L140.913 105.069V107.146Z",
    fill: "#E6E6E6"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 138.05L138.588 139.425V137.348L140.913 135.973V138.05Z",
    fill: "#E6E6E6"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 111.242L138.588 112.616V110.539L140.913 109.165V111.242Z",
    fill: "#E6E6E6"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 115.071L138.588 116.446V114.369L140.913 112.994V115.071Z",
    fill: "#E6E6E6"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 99.4862L138.588 100.861V98.7835L140.913 97.4092V99.4862Z",
    fill: "#E6E6E6"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 165.124L138.588 166.498V164.421L140.913 163.047V165.124Z",
    fill: "#E6E6E6"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 168.953L138.588 170.328V168.251L140.913 166.877V168.953Z",
    fill: "#E6E6E6"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 141.88L138.588 143.254V141.177L140.913 139.803V141.88Z",
    fill: "#E6E6E6"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 176.613L138.588 177.988V175.911L140.913 174.536V176.613Z",
    fill: "#E6E6E6"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 161.295L138.588 162.669V160.592L140.913 159.218V161.295Z",
    fill: "#E6E6E6"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 149.805L138.588 151.179V149.102L140.913 147.728V149.805Z",
    fill: "#E6E6E6"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 157.464L138.588 158.838V156.762L140.913 155.387V157.464Z",
    fill: "#E6E6E6"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 145.709L138.588 147.084V145.007L140.913 143.632V145.709Z",
    fill: "#E6E6E6"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 153.635L138.588 155.009V152.932L140.913 151.558V153.635Z",
    fill: "#E6E6E6"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M140.913 87.9969L138.588 89.3712V87.2949L140.913 85.9199V87.9969Z",
    fill: "#E6E6E6"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 35.1683L187.615 36.5426V34.4662L189.94 33.0913V35.1683Z",
    fill: "#E6E6E6"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 19.8494L187.615 21.2237V19.1467L189.94 17.7725V19.8494Z",
    fill: "#E6E6E6"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 23.679L187.615 25.054V22.9763L189.94 21.6021V23.679Z",
    fill: "#E6E6E6"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 31.3387L187.615 32.713V30.636L189.94 29.2617V31.3387Z",
    fill: "#E6E6E6"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 27.5081L187.615 28.8831V26.8061L189.94 25.4312V27.5081Z",
    fill: "#E6E6E6"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 172.902L182.793 174.277V172.199L185.118 170.825V172.902Z",
    fill: "#E6E6E6"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 176.732L182.793 178.107V176.03L185.118 174.655V176.732Z",
    fill: "#E6E6E6"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 58.1462L187.615 59.5211V57.4441L189.94 56.0698V58.1462Z",
    fill: "#E6E6E6"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 65.8065L187.615 67.1814V65.1044L189.94 63.7295V65.8065Z",
    fill: "#E6E6E6"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 61.9764L187.615 63.3507V61.2737L189.94 59.8994V61.9764Z",
    fill: "#E6E6E6"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 73.7723L187.615 75.1466V73.0702L189.94 71.6953V73.7723Z",
    fill: "#E6E6E6"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 69.6361L187.615 71.0103V68.9333L189.94 67.5591V69.6361Z",
    fill: "#E6E6E6"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 46.6571L187.615 48.032V45.955L189.94 44.5801V46.6571Z",
    fill: "#E6E6E6"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 42.8275L187.615 44.2017V42.1248L189.94 40.7505V42.8275Z",
    fill: "#E6E6E6"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 38.9977L187.615 40.3726V38.2957L189.94 36.9214V38.9977Z",
    fill: "#E6E6E6"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 50.487L187.615 51.8619V49.7849L189.94 48.4106V50.487Z",
    fill: "#E6E6E6"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 54.3167L187.615 55.6917V53.6147L189.94 52.2397V54.3167Z",
    fill: "#E6E6E6"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 119.02L182.793 120.394V118.318L185.118 116.943V119.02Z",
    fill: "#E6E6E6"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 107.264L182.793 108.638V106.562L185.118 105.187V107.264Z",
    fill: "#E6E6E6"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 126.679L182.793 128.053V125.976L185.118 124.602V126.679Z",
    fill: "#E6E6E6"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 111.093L182.793 112.468V110.391L185.118 109.017V111.093Z",
    fill: "#E6E6E6"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 77.6019L187.615 78.9768V76.8998L189.94 75.5249V77.6019Z",
    fill: "#E6E6E6"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 122.849L182.793 124.224V122.147L185.118 120.772V122.849Z",
    fill: "#E6E6E6"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 115.189L182.793 116.564V114.487L185.118 113.113V115.189Z",
    fill: "#E6E6E6"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 91.945L182.793 93.3199V91.2429L185.118 89.8687V91.945Z",
    fill: "#E6E6E6"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 103.435L182.793 104.809V102.732L185.118 101.358V103.435Z",
    fill: "#E6E6E6"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 95.7752L182.793 97.1495V95.0732L185.118 93.6982V95.7752Z",
    fill: "#E6E6E6"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 99.6043L182.793 100.979V98.9023L185.118 97.5273V99.6043Z",
    fill: "#E6E6E6"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 149.657L182.793 151.032V148.955L185.118 147.58V149.657Z",
    fill: "#E6E6E6"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 153.753L182.793 155.128V153.051L185.118 151.676V153.753Z",
    fill: "#E6E6E6"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 169.072L182.793 170.446V168.369L185.118 166.995V169.072Z",
    fill: "#E6E6E6"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 130.509L182.793 131.883V129.807L185.118 128.432V130.509Z",
    fill: "#E6E6E6"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 161.413L182.793 162.787V160.71L185.118 159.336V161.413Z",
    fill: "#E6E6E6"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 165.242L182.793 166.617V164.54L185.118 163.165V165.242Z",
    fill: "#E6E6E6"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 157.582L182.793 158.957V156.88L185.118 155.505V157.582Z",
    fill: "#E6E6E6"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 145.827L182.793 147.202V145.125L185.118 143.751V145.827Z",
    fill: "#E6E6E6"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 134.338L182.793 135.713V133.636L185.118 132.262V134.338Z",
    fill: "#E6E6E6"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 138.168L182.793 139.543V137.466L185.118 136.091V138.168Z",
    fill: "#E6E6E6"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M185.118 141.997L182.793 143.372V141.295L185.118 139.92V141.997Z",
    fill: "#E6E6E6"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 96.7508L187.615 98.1257V96.0487L189.94 94.6738V96.7508Z",
    fill: "#E6E6E6"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 16.9948L192.436 18.3697V16.2927L194.761 14.9185V16.9948Z",
    fill: "#E6E6E6"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 20.825L192.436 22.1993V20.123L194.761 18.748V20.825Z",
    fill: "#E6E6E6"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 24.6541L192.436 26.0291V23.9521L194.761 22.5771V24.6541Z",
    fill: "#E6E6E6"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 28.4847L192.436 29.859V27.782L194.761 26.4077V28.4847Z",
    fill: "#E6E6E6"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 170.047L187.615 171.421V169.344L189.94 167.97V170.047Z",
    fill: "#E6E6E6"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 173.877L187.615 175.252V173.175L189.94 171.8V173.877Z",
    fill: "#E6E6E6"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 177.707L187.615 179.082V177.005L189.94 175.63V177.707Z",
    fill: "#E6E6E6"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 55.2923L192.436 56.6672V54.5903L194.761 53.2153V55.2923Z",
    fill: "#E6E6E6"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 51.4627L192.436 52.837V50.7607L194.761 49.3857V51.4627Z",
    fill: "#E6E6E6"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 59.1224L192.436 60.4967V58.4197L194.761 57.0454V59.1224Z",
    fill: "#E6E6E6"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 166.218L187.615 167.593V165.516L189.94 164.141V166.218Z",
    fill: "#E6E6E6"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 66.7814L192.436 68.1563V66.0793L194.761 64.7051V66.7814Z",
    fill: "#E6E6E6"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 62.952L192.436 64.3269V62.2499L194.761 60.875V62.952Z",
    fill: "#E6E6E6"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 32.3143L192.436 33.6886V31.6122L194.761 30.2373V32.3143Z",
    fill: "#E6E6E6"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 36.1437L192.436 37.5186V35.4416L194.761 34.0674V36.1437Z",
    fill: "#E6E6E6"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 39.9735L192.436 41.3477V39.2707L194.761 37.8965V39.9735Z",
    fill: "#E6E6E6"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 43.8036L192.436 45.1785V43.1015L194.761 41.7266V43.8036Z",
    fill: "#E6E6E6"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 47.6333L192.436 49.0076V46.9306L194.761 45.5557V47.6333Z",
    fill: "#E6E6E6"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 92.9212L187.615 94.2955V92.2185L189.94 90.8442V92.9212Z",
    fill: "#E6E6E6"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 104.41L187.615 105.784V103.708L189.94 102.333V104.41Z",
    fill: "#E6E6E6"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 119.995L187.615 121.37V119.293L189.94 117.918V119.995Z",
    fill: "#E6E6E6"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 112.335L187.615 113.71V111.633L189.94 110.258V112.335Z",
    fill: "#E6E6E6"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 100.58L187.615 101.955V99.8777L189.94 98.5034V100.58Z",
    fill: "#E6E6E6"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 116.165L187.615 117.54V115.463L189.94 114.088V116.165Z",
    fill: "#E6E6E6"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 108.24L187.615 109.615V107.538L189.94 106.163V108.24Z",
    fill: "#E6E6E6"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 85.2611L187.615 86.6353V84.559L189.94 83.1841V85.2611Z",
    fill: "#E6E6E6"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M194.761 70.9183L192.436 72.2926V70.2156L194.761 68.8413V70.9183Z",
    fill: "#E6E6E6"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 89.091L187.615 90.4659V88.3889L189.94 87.0146V89.091Z",
    fill: "#E6E6E6"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 81.432L187.615 82.8062V80.7292L189.94 79.355V81.432Z",
    fill: "#E6E6E6"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 142.973L187.615 144.348V142.271L189.94 140.896V142.973Z",
    fill: "#E6E6E6"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 162.388L187.615 163.762V161.686L189.94 160.311V162.388Z",
    fill: "#E6E6E6"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 146.803L187.615 148.177V146.101L189.94 144.726V146.803Z",
    fill: "#E6E6E6"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 150.899L187.615 152.273V150.197L189.94 148.822V150.899Z",
    fill: "#E6E6E6"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 154.728L187.615 156.103V154.026L189.94 152.651V154.728Z",
    fill: "#E6E6E6"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 158.558L187.615 159.933V157.856L189.94 156.481V158.558Z",
    fill: "#E6E6E6"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 131.484L187.615 132.859V130.782L189.94 129.407V131.484Z",
    fill: "#E6E6E6"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 123.824L187.615 125.199V123.122L189.94 121.748V123.824Z",
    fill: "#E6E6E6"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 139.144L187.615 140.519V138.442L189.94 137.067V139.144Z",
    fill: "#E6E6E6"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 127.654L187.615 129.028V126.952L189.94 125.577V127.654Z",
    fill: "#E6E6E6"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M189.94 135.314L187.615 136.689V134.612L189.94 133.237V135.314Z",
    fill: "#E6E6E6"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M265.588 62.327L282.016 52.6162L290.23 57.4716L273.803 67.183L265.588 62.327Z",
    fill: "#FAFAFA"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M216.299 23.495L230.001 15.4033L246.429 25.1147L232.727 33.2057L216.299 23.495Z",
    fill: "#FAFAFA"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M246.422 38.9351V48.6385L254.636 43.7898L246.422 38.9351Z",
    fill: "#FAFAFA"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M161.541 9.71009L177.97 0L197.135 11.3299L180.706 21.04L161.541 9.71009Z",
    fill: "#FAFAFA"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7539 20.9664L79.397 6.39893L90.3475 12.8741L65.705 27.4415L54.7539 20.9664Z",
    fill: "#FAFAFA"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.5498L21.8919 49.5962L38.3396 59.3169L16.4477 72.2705L0 62.5498Z",
    fill: "#FAFAFA"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M123.203 35.61L134.157 29.1328L147.853 37.2271L136.9 43.7049L123.203 35.61Z",
    fill: "#FAFAFA"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3496 27.9986L101.304 21.5215L112.26 27.9953L101.306 34.4725L90.3496 27.9986Z",
    fill: "#FAFAFA"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M197.139 53.3511V63.0545L205.352 58.2065L197.139 53.3511Z",
    fill: "#FAFAFA"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7545 79.9456V70.2422L46.541 75.0903L54.7545 79.9456Z",
    fill: "#FAFAFA"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 174.892L57.625 202.54L104.396 230.188L151.167 202.541L104.396 174.892Z",
    fill: "#E0E0E0"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3879 82.7773L87.4301 83.985L85.3879 85.1921L83.3457 83.985L85.3879 82.7773Z",
    fill: "#455A64"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M83.345 83.9854L66.0547 202.556L68.0969 203.763L85.3872 85.1924L83.345 83.9854Z",
    fill: "#263238"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4301 83.9854L70.1399 202.556L68.0977 203.763L85.3879 85.1924L87.4301 83.9854Z",
    fill: "#37474F"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M123.411 82.7773L121.369 83.985L123.411 85.1921L125.454 83.985L123.411 82.7773Z",
    fill: "#455A64"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M125.454 83.9854L142.737 202.556L140.695 203.763L123.412 85.1924L125.454 83.9854Z",
    fill: "#37474F"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M121.369 83.9854L138.652 202.556L140.694 203.763L123.411 85.1924L121.369 83.9854Z",
    fill: "#263238"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 210.237V207.823L106.437 209.03V211.444L104.395 210.237Z",
    fill: "#455A64"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M106.438 211.444L139.752 191.801L139.575 189.488L106.438 209.03V211.444Z",
    fill: "#37474F"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 207.823L137.532 188.281L139.575 189.488L106.437 209.03L104.395 207.823Z",
    fill: "#455A64"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M106.437 167.532L104.395 168.739L106.437 169.946L108.479 168.739L106.437 167.532Z",
    fill: "#455A64"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 168.739L139.575 189.488L137.533 190.696L106.438 169.946L108.48 168.739Z",
    fill: "#37474F"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 168.739L135.49 189.488L137.532 190.696L106.437 169.946L104.395 168.739Z",
    fill: "#263238"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M131.405 152.816L133.448 154.023L131.405 155.23L129.363 154.023L131.405 152.816Z",
    fill: "#455A64"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M129.363 154.023L104.395 207.823L106.437 209.03L131.405 155.23L129.363 154.023Z",
    fill: "#263238"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 168.739L122.186 177.881L121.218 179.804L106.438 169.946L108.48 168.739Z",
    fill: "#37474F"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M133.448 154.023L108.48 207.823L106.438 209.03L131.406 155.23L133.448 154.023Z",
    fill: "#37474F"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 168.739V166.325L106.437 167.532V169.946L104.395 168.739Z",
    fill: "#455A64"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M106.438 169.946L133.448 154.023L133.123 151.795L106.438 167.531V169.946Z",
    fill: "#37474F"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 166.325L131.08 150.588L133.123 151.796L106.437 167.532L104.395 166.325Z",
    fill: "#455A64"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M106.437 129.703L104.395 130.91L106.437 132.117L108.479 130.91L106.437 129.703Z",
    fill: "#455A64"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 130.91L133.123 151.796L131.081 153.003L106.438 132.117L108.48 130.91Z",
    fill: "#37474F"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 130.91L129.038 151.796L131.08 153.003L106.437 132.117L104.395 130.91Z",
    fill: "#263238"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M126.175 118.07L128.367 119.191L126.175 120.484L124.133 119.277L126.175 118.07Z",
    fill: "#455A64"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M124.133 119.277L104.395 166.324L106.437 167.531L126.176 120.484L124.133 119.277Z",
    fill: "#263238"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 130.91L118.308 139.239L117.403 141.411L106.438 132.117L108.48 130.91Z",
    fill: "#37474F"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M128.368 119.191L108.48 166.325L106.438 167.532L126.176 120.484L128.368 119.191Z",
    fill: "#37474F"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M104.398 210.237V207.823L102.355 209.03V211.444L104.398 210.237Z",
    fill: "#455A64"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M102.356 211.445L69.041 191.802L69.2179 189.488L102.356 209.031V211.445Z",
    fill: "#263238"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M104.397 207.824L71.259 188.281L69.2168 189.488L102.355 209.031L104.397 207.824Z",
    fill: "#37474F"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M102.355 167.532L104.397 168.739L102.355 169.946L100.312 168.739L102.355 167.532Z",
    fill: "#455A64"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M100.312 168.739L69.2168 189.488L71.259 190.696L102.355 169.946L100.312 168.739Z",
    fill: "#263238"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M104.398 168.739L73.302 189.488L71.2598 190.696L102.355 169.946L104.398 168.739Z",
    fill: "#37474F"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3983 152.785L75.3496 154.01L77.3918 155.217L79.4405 153.992L77.3983 152.785Z",
    fill: "#455A64"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4413 153.992L104.397 207.824L102.355 209.031L77.3926 155.218L79.4413 153.992Z",
    fill: "#37474F"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M100.312 168.74L86.6055 177.881L87.5731 179.805L102.354 169.947L100.312 168.74Z",
    fill: "#263238"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3496 154.01L100.312 207.824L102.354 209.031L77.3918 155.217L75.3496 154.01Z",
    fill: "#263238"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 168.738V166.324L102.354 167.531V169.946L104.396 168.738Z",
    fill: "#455A64"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M102.354 169.946L75.3496 154.01L75.6801 151.77L102.354 167.531V169.946Z",
    fill: "#263238"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 166.324L77.7219 150.562L75.6797 151.77L102.354 167.531L104.396 166.324Z",
    fill: "#37474F"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 130.91V128.496L106.437 129.703V132.117L104.395 130.91Z",
    fill: "#455A64"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M106.438 132.117L128.368 119.191L128.042 116.964L106.438 129.703V132.117Z",
    fill: "#37474F"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 128.496L125.999 115.757L128.041 116.964L106.437 129.703L104.395 128.496Z",
    fill: "#455A64"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M106.437 95.2241L104.395 96.4312L106.437 97.6389L108.479 96.4312L106.437 95.2241Z",
    fill: "#455A64"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 96.4312L128.042 116.964L125.999 118.171L106.438 97.6389L108.48 96.4312Z",
    fill: "#37474F"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 96.4312L123.956 116.964L125.999 118.171L106.437 97.6389L104.395 96.4312Z",
    fill: "#263238"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M121.556 86.2896L123.598 87.4966L121.556 88.7036L119.514 87.4966L121.556 86.2896Z",
    fill: "#455A64"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M119.512 87.4966L104.395 128.496L106.437 129.703L121.555 88.7036L119.512 87.4966Z",
    fill: "#263238"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 96.4307L115.853 104.17L114.961 106.585L106.438 97.6384L108.48 96.4307Z",
    fill: "#37474F"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M123.598 87.4966L108.48 128.496L106.438 129.703L121.555 88.7036L123.598 87.4966Z",
    fill: "#37474F"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M102.355 129.703L104.397 130.91L102.355 132.117L100.312 130.91L102.355 129.703Z",
    fill: "#455A64"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M100.312 130.91L75.6797 151.77L77.5858 152.893L102.354 132.117L100.312 130.91Z",
    fill: "#263238"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M104.394 130.91L79.6262 151.686L77.584 152.893L102.352 132.117L104.394 130.91Z",
    fill: "#37474F"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4738 117.979L80.4316 119.187L82.4738 120.394L84.516 119.187L82.4738 117.979Z",
    fill: "#455A64"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5168 119.186L104.399 166.324L102.357 167.531L82.4746 120.393L84.5168 119.186Z",
    fill: "#37474F"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M100.314 130.91L90.4375 139.274L91.3222 141.371L102.356 132.117L100.314 130.91Z",
    fill: "#263238"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4316 119.186L100.314 166.324L102.356 167.531L82.4738 120.393L80.4316 119.186Z",
    fill: "#263238"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M104.398 130.91V128.496L102.355 129.703V132.117L104.398 130.91Z",
    fill: "#455A64"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M102.356 132.117L80.4316 119.186L80.7667 116.958L102.356 129.703V132.117Z",
    fill: "#263238"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M104.399 128.496L82.8091 115.75L80.7676 116.958L102.357 129.703L104.399 128.496Z",
    fill: "#37474F"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M102.353 95.2236L104.395 96.4307L102.353 97.6384L100.311 96.4307L102.353 95.2236Z",
    fill: "#455A64"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M100.311 96.4307L80.75 116.962L82.7922 118.169L102.353 97.6384L100.311 96.4307Z",
    fill: "#263238"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 96.4307L84.8352 116.962L82.793 118.169L102.354 97.6384L104.396 96.4307Z",
    fill: "#37474F"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2349 86.3091L85.1934 87.5161L87.2349 88.7232L89.2771 87.5161L87.2349 86.3091Z",
    fill: "#455A64"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2766 87.5166L104.395 128.496L102.353 129.703L87.2344 88.7236L89.2766 87.5166Z",
    fill: "#37474F"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M100.311 96.4307L92.9375 104.171L93.8261 106.589L102.353 97.6384L100.311 96.4307Z",
    fill: "#263238"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1934 87.5166L100.311 128.496L102.353 129.703L87.2349 88.7236L85.1934 87.5166Z",
    fill: "#263238"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 96.4314V94.0166L106.437 95.2236V97.6384L104.395 96.4314Z",
    fill: "#455A64"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M106.438 97.6379L125.778 86.2105L125.453 83.9849L106.438 95.2232V97.6379Z",
    fill: "#37474F"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 94.0163L123.41 82.7773L125.452 83.985L106.437 95.2234L104.395 94.0163Z",
    fill: "#455A64"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 96.4314V94.0166L102.354 95.2236V97.6384L104.396 96.4314Z",
    fill: "#455A64"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M102.354 97.6379L83.168 86.2974L83.3449 83.9849L102.354 95.2232V97.6379Z",
    fill: "#263238"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M104.395 94.0163L85.3859 82.7773L83.3438 83.985L102.353 95.2234L104.395 94.0163Z",
    fill: "#455A64"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M104.396 94.0166L106.438 95.2236L104.396 96.4314L102.354 95.2236L104.396 94.0166Z",
    fill: "#455A64"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M102.354 95.2236V224.015L104.396 225.222V96.4313L102.354 95.2236Z",
    fill: "#263238"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M106.439 95.2236V224.015L104.396 225.222V96.4313L106.439 95.2236Z",
    fill: "#37474F"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M104.401 69.23L125.455 81.676L104.401 94.122L83.3457 81.676L104.401 69.23Z",
    fill: "#C79BAD"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M104.401 69.23L125.455 81.676L104.401 94.122L83.3457 81.676L104.401 69.23Z",
    fill: "#C79BAD"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M104.401 69.23L125.455 81.676L104.401 94.122L83.3457 81.676L104.401 69.23Z",
    fill: "white"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3457 81.6758V83.9857L104.4 96.431L104.401 94.1218L83.3457 81.6758Z",
    fill: "#C79BAD"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.3457 81.6758V83.9857L104.4 96.431L104.401 94.1218L83.3457 81.6758Z",
    fill: "white"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M125.455 81.6758V83.9857L104.4 96.431L104.401 94.1218L125.455 81.6758Z",
    fill: "#C79BAD"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.455 81.6758V83.9857L104.4 96.431L104.401 94.1218L125.455 81.6758Z",
    fill: "white"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M121.601 12.042L123.008 81.7545C123.008 82.0166 122.839 82.2781 122.502 82.4778C121.826 82.8773 120.73 82.8773 120.054 82.4778C119.716 82.2781 119.547 82.016 119.547 81.7545L120.955 12.042H121.601Z",
    fill: "#455A64"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M121.205 12.042C121.094 42.0283 120.887 78.0425 120.813 79.9954C120.733 82.1029 122.082 82.442 123.001 81.799C122.983 82.0458 122.82 82.2894 122.502 82.4778C121.826 82.8773 120.73 82.8773 120.054 82.4778C119.716 82.2781 119.547 82.016 119.547 81.7545L120.955 12.042H121.205Z",
    fill: "#37474F"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M118.447 11.3527C118.447 12.9526 119.714 14.2499 121.277 14.2499C122.84 14.2499 124.107 12.9526 124.107 11.3527C124.107 9.75285 122.84 8.45557 121.277 8.45557C119.714 8.45557 118.447 9.75285 118.447 11.3527Z",
    fill: "#C79BAD"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.294 10.6634C123.235 10.7357 123.143 10.7716 123.053 10.7842C122.643 10.8419 122.298 10.4988 121.925 10.315C121.67 10.189 121.386 10.1359 121.102 10.1213C120.942 10.1126 120.778 10.116 120.626 10.0642C120.338 9.96599 120.133 9.68464 120.314 9.37873C120.406 9.22412 120.568 9.12591 120.735 9.06685C120.987 8.97793 121.259 8.96399 121.526 8.97395C121.705 8.98058 121.887 8.9985 122.056 9.0622C122.478 9.22279 122.785 9.38802 123.078 9.75166C123.262 9.98059 123.524 10.3787 123.294 10.6634Z",
    fill: "white"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.277 14.2496C119.714 14.2496 118.447 12.9524 118.447 11.3525C118.447 10.677 118.675 10.0565 119.054 9.56348C118.795 10.5509 118.94 12.178 120.154 12.8681C121.366 13.5582 123.754 13.03 124.099 11.1786C124.102 11.2363 124.107 11.2934 124.107 11.3525C124.107 12.9524 122.84 14.2496 121.277 14.2496Z",
    fill: "black"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M102.528 73.3395L90.5938 80.3946V76.1617L96.5609 63.3474L102.529 59.8198L102.528 73.3395Z",
    fill: "#C79BAD"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.528 73.3395L90.5938 80.3946V76.1617L96.5609 63.3474L102.529 59.8198L102.528 73.3395Z",
    fill: "black"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5947 80.3942L89.375 79.6755V75.4399L90.5947 76.1612V80.3942Z",
    fill: "#C79BAD"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M102.53 59.8196L101.336 59.1143L95.3691 62.6412L96.5623 63.3472L102.53 59.8196Z",
    fill: "#C79BAD"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M102.53 59.8196L101.336 59.1143L95.3691 62.6412L96.5623 63.3472L102.53 59.8196Z",
    fill: "white"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3687 62.6411L89.375 75.4401L90.5947 76.1615L96.5619 63.3472L95.3687 62.6411Z",
    fill: "#C79BAD"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95.3687 62.6411L89.375 75.4401L90.5947 76.1615L96.5619 63.3472L95.3687 62.6411Z",
    fill: "white"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M105.971 64.0818C112.327 52.8106 112.403 40.6729 106.142 36.9714C99.8801 33.2699 89.6516 39.4064 83.2956 50.6776C76.9396 61.9488 76.8631 74.0866 83.1246 77.788C89.3862 81.4895 99.6147 75.353 105.971 64.0818Z",
    fill: "#C79BAD"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M80.9923 55.4541C80.9755 55.6737 80.9593 55.8927 80.9489 56.113C80.7305 60.7939 82.1278 65.7189 85.463 68.9287C88.2933 71.652 92.2643 72.9048 96.1477 72.9526C97.2301 72.9658 98.3073 72.8902 99.3779 72.7469C97.8406 74.2406 96.2067 75.5299 94.5132 76.5458C85.5913 81.8989 78.4129 77.6553 78.479 67.0673C78.5029 63.342 79.4233 59.3274 80.9923 55.4541Z",
    fill: "black"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1562 70.2104C96.9928 69.5229 96.2728 68.0478 96.2734 65.9489C96.2734 61.7511 99.1523 56.6462 102.703 54.548C104.478 53.4982 106.085 53.3993 107.249 54.0868C107.955 54.5042 108.077 54.5765 108.783 54.9939C109.947 55.6814 110.666 57.1565 110.666 59.2554C110.666 63.4532 107.788 68.5581 104.237 70.6569C102.462 71.7067 100.854 71.8056 99.6909 71.1175C98.9845 70.7001 98.8626 70.6277 98.1562 70.2104Z",
    fill: "#C79BAD"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.1562 70.2104C96.9928 69.5229 96.2728 68.0478 96.2734 65.9489C96.2734 61.7511 99.1523 56.6462 102.703 54.548C104.478 53.4982 106.085 53.3993 107.249 54.0868C107.955 54.5042 108.077 54.5765 108.783 54.9939C109.947 55.6814 110.666 57.1565 110.666 59.2554C110.666 63.4532 107.788 68.5581 104.237 70.6569C102.462 71.7067 100.854 71.8056 99.6909 71.1175C98.9845 70.7001 98.8626 70.6277 98.1562 70.2104Z",
    fill: "white"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.2715 65.9489C96.2715 64.4817 96.6292 62.9044 97.2385 61.3828L107.614 67.5162C106.632 68.8175 105.477 69.923 104.235 70.6569C102.46 71.7067 100.853 71.8056 99.6896 71.1175C98.9832 70.7001 98.8607 70.6277 98.1549 70.2097C96.9915 69.5229 96.2715 68.0478 96.2715 65.9489Z",
    fill: "#C79BAD"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M102.701 54.548C104.476 53.4982 106.083 53.3993 107.247 54.0868C108.41 54.7743 109.129 56.2494 109.129 58.3483C109.129 62.5461 106.251 67.6509 102.7 69.7498C100.925 70.7989 99.3176 70.8985 98.1543 70.211C96.9909 69.5236 96.2715 68.0484 96.2715 65.9495C96.2715 61.7511 99.1504 56.6469 102.701 54.548Z",
    fill: "#C79BAD"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.701 54.548C104.476 53.4982 106.083 53.3993 107.247 54.0868C108.41 54.7743 109.129 56.2494 109.129 58.3483C109.129 62.5461 106.251 67.6509 102.7 69.7498C100.925 70.7989 99.3176 70.8985 98.1543 70.211C96.9909 69.5236 96.2715 68.0484 96.2715 65.9495C96.2715 61.7511 99.1504 56.6469 102.701 54.548Z",
    fill: "white"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5873 67.2824C96.7046 66.7608 96.1582 65.6413 96.1582 64.0488C96.1582 60.8636 98.3423 56.9897 101.037 55.3971C102.384 54.6008 103.604 54.5251 104.486 55.0474C105.022 55.3646 105.115 55.419 105.651 55.7362C106.534 56.2577 107.08 57.3772 107.08 58.9698C107.08 62.1556 104.896 66.0289 102.201 67.6214C100.854 68.4177 99.6347 68.4927 98.7513 67.9712C98.2159 67.654 98.1233 67.5989 97.5873 67.2824Z",
    fill: "#C79BAD"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.5873 67.2824C96.7046 66.7608 96.1582 65.6413 96.1582 64.0488C96.1582 60.8636 98.3423 56.9897 101.037 55.3971C102.384 54.6008 103.604 54.5251 104.486 55.0474C105.022 55.3646 105.115 55.419 105.651 55.7362C106.534 56.2577 107.08 57.3772 107.08 58.9698C107.08 62.1556 104.896 66.0289 102.201 67.6214C100.854 68.4177 99.6347 68.4927 98.7513 67.9712C98.2159 67.654 98.1233 67.5989 97.5873 67.2824Z",
    fill: "white"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.1582 64.049C96.1582 63.3894 96.2567 62.6999 96.4291 62.0078L103.793 66.3609C103.293 66.8599 102.76 67.2919 102.202 67.6217C100.854 68.4179 99.6353 68.4929 98.7519 67.9714C98.216 67.6548 98.1233 67.5998 97.5873 67.2826C96.7046 66.7603 96.1582 65.6416 96.1582 64.049Z",
    fill: "#C79BAD"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 55.3971C102.384 54.6008 103.603 54.5251 104.486 55.0474C105.369 55.5689 105.916 56.6884 105.915 58.281C105.915 61.4661 103.731 65.3401 101.037 66.9327C99.6891 67.7289 98.47 67.8046 97.5866 67.2824C96.7039 66.7608 96.1576 65.6413 96.1582 64.0488C96.1582 60.8629 98.3423 56.9897 101.037 55.3971Z",
    fill: "#C79BAD"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M101.037 55.3971C102.384 54.6008 103.603 54.5251 104.486 55.0474C105.369 55.5689 105.916 56.6884 105.915 58.281C105.915 61.4661 103.731 65.3401 101.037 66.9327C99.6891 67.7289 98.47 67.8046 97.5866 67.2824C96.7039 66.7608 96.1576 65.6413 96.1582 64.0488C96.1582 60.8629 98.3423 56.9897 101.037 55.3971Z",
    fill: "white"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M87.209 52.9917L101.672 60.0349C101.836 60.1311 101.936 60.3381 101.936 60.6321C101.936 61.2207 101.533 61.936 101.035 62.23C100.786 62.3773 100.561 62.3912 100.398 62.2944L87.209 52.9917Z",
    fill: "#F5F5F5"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M101.697 60.0561C101.845 60.159 101.936 60.3547 101.936 60.6321C101.936 61.2207 101.533 61.936 101.035 62.23C100.786 62.3773 100.561 62.3912 100.398 62.2944L87.209 52.9917C87.209 52.9917 98.1108 59.7515 99.7681 60.8212C101.051 61.6487 101.759 60.8935 101.697 60.0561Z",
    fill: "#E0E0E0"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4793 55.6143C88.4754 56.2036 89.7496 55.8539 90.3251 54.8333C90.9006 53.8134 90.5591 52.5088 89.5629 51.9195C88.5668 51.3303 87.2926 51.68 86.7171 52.7006C86.1416 53.7211 86.4831 55.0251 87.4793 55.6143Z",
    fill: "#455A64"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.8323 52.1971C88.8557 52.2621 88.8447 52.3351 88.8187 52.3988C88.704 52.6874 88.3631 52.7863 88.1117 52.9622C87.9393 53.0823 87.8012 53.2488 87.6884 53.428C87.6243 53.5295 87.5659 53.6377 87.4778 53.718C87.3106 53.8699 87.0598 53.8998 86.9366 53.6689C86.8744 53.5521 86.8731 53.4101 86.8977 53.2793C86.9347 53.0816 87.0267 52.8998 87.1311 52.7292C87.2011 52.6144 87.2795 52.5023 87.3812 52.416C87.6366 52.199 87.8524 52.0604 88.1868 52.0026C88.3955 51.9668 88.7397 51.9422 88.8323 52.1971Z",
    fill: "white"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3242 54.833C89.7494 55.8529 88.4745 56.2026 87.4784 55.614C87.0578 55.3652 86.7551 54.9883 86.5879 54.5596C86.7084 54.6379 86.8329 54.7082 86.9644 54.7673C87.4745 54.9969 88.085 55.0447 88.5821 54.7879C89.0533 54.5443 89.3696 54.0586 89.531 53.5443C89.7034 52.9949 89.7098 52.3711 89.4506 51.8608C89.4875 51.8801 89.5251 51.8973 89.5621 51.9192C90.5582 52.5085 90.8998 53.8131 90.3242 54.833Z",
    fill: "#37474F"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7656 67.346C77.7656 72.8557 79.6497 76.721 82.7029 78.5286C94.1136 85.2698 108.703 81.2685 115.291 69.5896C121.879 57.9027 117.967 42.9689 106.561 36.2237C103.507 34.4201 99.2913 34.6776 94.6314 37.4327C85.3161 42.9417 77.7656 56.3333 77.7656 67.346ZM78.4805 67.0693C78.5472 56.482 85.8307 43.5595 94.7545 38.2051C103.678 32.8547 110.854 37.095 110.788 47.6823C110.721 58.2703 103.434 71.1921 94.5141 76.5465C85.5903 81.9009 78.4137 77.6566 78.4805 67.0693Z",
    fill: "#C79BAD"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M77.7656 67.346C77.7656 72.8557 79.6497 76.721 82.7029 78.5286C94.1136 85.2698 108.703 81.2685 115.291 69.5896C121.879 57.9027 117.967 42.9689 106.561 36.2237C103.507 34.4201 99.2913 34.6776 94.6314 37.4327C85.3161 42.9417 77.7656 56.3333 77.7656 67.346ZM78.4805 67.0693C78.5472 56.482 85.8307 43.5595 94.7545 38.2051C103.678 32.8547 110.854 37.095 110.788 47.6823C110.721 58.2703 103.434 71.1921 94.5141 76.5465C85.5903 81.9009 78.4137 77.6566 78.4805 67.0693Z",
    fill: "black"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.2949 74.7542C80.1349 76.4218 81.2976 77.6952 82.704 78.5286C94.1146 85.2699 108.704 81.2685 115.292 69.5896C118.035 64.7276 118.957 59.3048 118.279 54.1436C117.946 58.6492 116.51 63.0753 113.883 66.6944C110.577 71.2492 105.315 74.3905 99.7739 74.5803C98.9819 74.6069 98.197 74.5764 97.4161 74.4967C96.4763 75.2658 95.5029 75.9519 94.5145 76.5465C87.9336 80.4948 82.3009 79.222 79.8283 74.0342C79.6391 74.2651 79.4615 74.504 79.2949 74.7542Z",
    fill: "black"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7656 67.3461C77.7656 78.3621 85.3161 82.826 94.6314 77.3196C103.951 71.81 111.501 58.4177 111.501 47.4057C111.501 36.3897 103.951 31.9258 94.6314 37.4321C85.3161 42.9418 77.7656 56.3334 77.7656 67.3461ZM78.4805 67.0694C78.5472 56.482 85.8307 43.5596 94.7545 38.2052C103.678 32.8548 110.854 37.095 110.788 47.6824C110.721 58.2704 103.434 71.1922 94.5141 76.5466C85.5903 81.901 78.4137 77.6567 78.4805 67.0694Z",
    fill: "#C79BAD"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.7656 67.3461C77.7656 78.3621 85.3161 82.826 94.6314 77.3196C103.951 71.81 111.501 58.4177 111.501 47.4057C111.501 36.3897 103.951 31.9258 94.6314 37.4321C85.3161 42.9418 77.7656 56.3334 77.7656 67.3461ZM78.4805 67.0694C78.5472 56.482 85.8307 43.5596 94.7545 38.2052C103.678 32.8548 110.854 37.095 110.788 47.6824C110.721 58.2704 103.434 71.1922 94.5141 76.5466C85.5903 81.901 78.4137 77.6567 78.4805 67.0694Z",
    fill: "white"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M105.703 68.9119C109.273 66.955 112.567 62.4626 114.394 58.6604C114.184 58.3478 113.972 58.0373 113.757 57.73C113.189 56.9152 112.623 56.0691 112.031 55.2363C110.869 59.9849 108.625 64.7838 105.703 68.9119ZM112.915 48.357C112.915 50.077 112.729 51.8547 112.381 53.6524C113.156 54.6192 113.88 55.6444 114.613 56.6623C114.751 56.8541 114.888 57.0472 115.022 57.2403C115.613 55.7678 115.93 54.4812 115.886 53.6105C115.72 50.357 114.169 46.511 112.644 44.9482C112.821 46 112.915 47.138 112.915 48.357Z",
    fill: "#C79BAD"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.703 68.9119C109.273 66.955 112.567 62.4626 114.394 58.6604C114.184 58.3478 113.972 58.0373 113.757 57.73C113.189 56.9152 112.623 56.0691 112.031 55.2363C110.869 59.9849 108.625 64.7838 105.703 68.9119ZM112.915 48.357C112.915 50.077 112.729 51.8547 112.381 53.6524C113.156 54.6192 113.88 55.6444 114.613 56.6623C114.751 56.8541 114.888 57.0472 115.022 57.2403C115.613 55.7678 115.93 54.4812 115.886 53.6105C115.72 50.357 114.169 46.511 112.644 44.9482C112.821 46 112.915 47.138 112.915 48.357Z",
    fill: "white"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M117.362 82.1087L105.428 89.1632V84.9302L111.394 72.1159L117.362 68.5884V82.1087Z",
    fill: "#C79BAD"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.362 82.1087L105.428 89.1632V84.9302L111.394 72.1159L117.362 68.5884V82.1087Z",
    fill: "white"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M105.429 89.1631L104.209 88.4451V84.2095L105.429 84.9301V89.1631Z",
    fill: "#C79BAD"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.429 89.1631L104.209 88.4451V84.2095L105.429 84.9301V89.1631Z",
    fill: "black"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M117.362 68.5882L116.168 67.8828L110.201 71.4104L111.394 72.1158L117.362 68.5882Z",
    fill: "#C79BAD"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M117.362 68.5882L116.168 67.8828L110.201 71.4104L111.394 72.1158L117.362 68.5882Z",
    fill: "white"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M110.202 71.4102L104.209 84.2092L105.429 84.9298L111.395 72.1155L110.202 71.4102Z",
    fill: "#C79BAD"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.202 71.4102L104.209 84.2092L105.429 84.9298L111.395 72.1155L110.202 71.4102Z",
    fill: "white"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M115.968 72.5867C116.126 72.6803 116.224 72.8814 116.224 73.1674C116.224 73.7394 115.832 74.4355 115.348 74.7215C115.106 74.8648 114.887 74.8781 114.728 74.7845C114.632 74.7274 113.752 74.2072 113.655 74.1501C113.496 74.0566 113.398 73.8555 113.398 73.5695C113.398 72.9975 113.791 72.3014 114.275 72.0154C114.517 71.8727 114.735 71.8588 114.894 71.953C114.991 72.0094 115.872 72.5297 115.968 72.5867Z",
    fill: "#455A64"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M115.347 74.7215C115.105 74.8648 114.886 74.8781 114.727 74.7845C114.569 74.691 114.471 74.4899 114.471 74.2039C114.471 73.6319 114.863 72.9358 115.347 72.6498C115.589 72.5071 115.808 72.4932 115.967 72.5868C116.125 72.6803 116.223 72.8814 116.223 73.1674C116.223 73.7401 115.831 74.4355 115.347 74.7215Z",
    fill: "#37474F"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0397 44.3516C71.1835 47.6436 70.971 51.6867 72.4707 55.1679C72.5828 55.4293 72.7688 55.6416 73.008 55.783C73.2082 55.9011 73.4344 55.9635 73.6632 55.9635C73.8434 55.9635 74.0203 55.9243 74.1875 55.8493C74.5051 55.706 74.7494 55.4439 74.8752 55.1121C75.0009 54.7797 74.9931 54.418 74.8518 54.0915C73.6852 51.3848 73.8512 48.2428 75.2939 45.6847C76.7366 43.126 79.3121 41.4086 82.1839 41.0901C82.53 41.0516 82.8405 40.8778 83.0582 40.5997C83.276 40.3224 83.3758 39.9746 83.3382 39.6203C83.2669 38.9421 82.7115 38.4305 82.0472 38.4305C81.9999 38.4305 81.9519 38.4332 81.9039 38.4385C78.2097 38.8499 74.8959 41.0603 73.0397 44.3516ZM65.313 39.7835C62.4502 44.8586 61.7814 50.982 63.4775 56.5826C63.5747 56.9038 63.7847 57.1738 64.0692 57.3424C64.2682 57.4598 64.4931 57.5215 64.7199 57.5215C64.8502 57.5215 64.9805 57.5016 65.1062 57.4612C65.438 57.355 65.7103 57.1241 65.8729 56.8089C66.035 56.4937 66.0674 56.1327 65.9643 55.7923C64.4827 50.9004 65.0667 45.5507 67.5671 41.116C70.0675 36.6813 74.3003 33.4889 79.1793 32.3568C79.5182 32.2778 79.8079 32.0688 79.9933 31.7669C80.1787 31.4663 80.2383 31.1086 80.1618 30.7616C80.0283 30.1597 79.4949 29.7231 78.8941 29.7231C78.7975 29.7231 78.6997 29.7337 78.6038 29.7563C73.019 31.0535 68.1744 34.7085 65.313 39.7835ZM54.323 58.1201C54.4117 58.4665 54.6282 58.7558 54.9309 58.935C55.1292 59.0524 55.3534 59.1148 55.5803 59.1148C55.6918 59.1148 55.8045 59.1002 55.9141 59.0703C56.2511 58.9794 56.5324 58.7598 56.7073 58.4519C56.883 58.144 56.9303 57.785 56.8415 57.4413C54.9976 50.2833 55.973 42.8114 59.5875 36.4006C63.2034 29.9898 69.0357 25.3886 76.012 23.445C76.3477 23.3521 76.6277 23.1298 76.8001 22.8212C76.9725 22.5127 77.0172 22.1523 76.9264 21.8093C76.7728 21.2293 76.2569 20.8252 75.6717 20.8252C75.5563 20.8252 75.441 20.8411 75.3276 20.8723C67.6844 23.0017 61.2934 28.0436 57.3328 35.0675C53.3702 42.0914 52.3015 50.2786 54.323 58.1201Z",
    fill: "#455A64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.219 235.898L206.546 222.495C206.469 222.45 206.422 222.366 206.422 222.275C206.422 222.184 206.469 222.1 206.546 222.055L228.386 209.133C228.463 209.088 228.557 209.088 228.635 209.133L251.308 222.536C251.385 222.581 251.432 222.666 251.432 222.757C251.432 222.848 251.385 222.932 251.308 222.977L229.468 235.898C229.429 235.921 229.386 235.932 229.344 235.932C229.301 235.932 229.258 235.921 229.219 235.898ZM228.51 209.648L207.168 222.275L229.344 235.383L250.686 222.757L228.51 209.648Z",
    fill: "#C0A3FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.106 254.873L174.433 241.47C174.357 241.425 174.309 241.341 174.309 241.25C174.309 241.159 174.356 241.075 174.433 241.03L196.289 228.107C196.367 228.061 196.461 228.061 196.538 228.107L219.212 241.509C219.288 241.554 219.335 241.638 219.335 241.729C219.335 241.82 219.288 241.904 219.212 241.949L197.355 254.873C197.317 254.896 197.274 254.906 197.231 254.906C197.188 254.907 197.145 254.896 197.106 254.873ZM196.414 228.621L175.055 241.249L197.23 254.358L218.589 241.728L196.414 228.621Z",
    fill: "#C0A3FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.805 273.966L142.132 260.563C142.055 260.518 142.008 260.434 142.008 260.343C142.008 260.252 142.055 260.168 142.132 260.123L164.179 247.09C164.257 247.044 164.351 247.044 164.428 247.09L187.101 260.492C187.178 260.538 187.225 260.622 187.225 260.713C187.225 260.804 187.178 260.888 187.101 260.934L165.053 273.967C165.014 273.99 164.972 274.001 164.929 274.001C164.887 274 164.844 273.99 164.805 273.966ZM164.304 247.604L142.754 260.343L164.93 273.451L186.48 260.713L164.304 247.604Z",
    fill: "#C0A3FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.317 216.923L238.643 203.52C238.567 203.475 238.52 203.391 238.52 203.3C238.52 203.209 238.567 203.125 238.643 203.079L260.483 190.158C260.561 190.113 260.655 190.113 260.733 190.158L283.406 203.561C283.483 203.606 283.531 203.691 283.531 203.782C283.531 203.872 283.483 203.957 283.406 204.002L261.566 216.923C261.527 216.946 261.485 216.957 261.442 216.957C261.398 216.957 261.356 216.946 261.317 216.923ZM260.608 190.673L239.266 203.299L261.441 216.407L282.784 203.781L260.608 190.673Z",
    fill: "#C0A3FF"
  }))), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M261.441 214.313L261.443 134.04L279.24 123.509L279.239 203.782L261.441 214.313Z",
    fill: "#C0A3FF"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.441 214.313L261.443 134.04L279.24 123.509L279.239 203.782L261.441 214.313Z",
    fill: "white"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M261.441 214.313L242.811 203.3L242.809 123.028L261.443 134.04L261.441 214.313Z",
    fill: "#C0A3FF"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.441 214.313L242.811 203.3L242.809 123.028L261.443 134.04L261.441 214.313Z",
    fill: "white"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M242.809 123.028L260.606 112.497L279.24 123.509L261.443 134.04L242.809 123.028Z",
    fill: "#C0A3FF"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.809 123.028L260.606 112.497L279.24 123.509L261.443 134.04L242.809 123.028Z",
    fill: "white"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M229.344 233.287L229.346 171.209L247.143 160.678L247.141 222.756L229.344 233.287Z",
    fill: "#C0A3FF"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.344 233.287L229.346 171.209L247.143 160.678L247.141 222.756L229.344 233.287Z",
    fill: "white"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M229.343 233.287L210.713 222.275L210.711 160.197L229.345 171.209L229.343 233.287Z",
    fill: "#C0A3FF"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.343 233.287L210.713 222.275L210.711 160.197L229.345 171.209L229.343 233.287Z",
    fill: "white"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M210.711 160.197L228.508 149.666L247.142 160.678L229.345 171.208L210.711 160.197Z",
    fill: "#C0A3FF"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.711 160.197L228.508 149.666L247.142 160.678L229.345 171.208L210.711 160.197Z",
    fill: "white"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M197.232 252.263L197.235 208.349L215.046 197.816L215.044 241.73L197.232 252.263Z",
    fill: "#C0A3FF"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.232 252.263L197.235 208.349L215.046 197.816L215.044 241.73L197.232 252.263Z",
    fill: "white"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M197.23 252.263L178.6 241.25L178.598 197.337L197.232 208.349L197.23 252.263Z",
    fill: "#C0A3FF"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.23 252.263L178.6 241.25L178.598 197.337L197.232 208.349L197.23 252.263Z",
    fill: "white"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M178.598 197.337L196.411 186.804L215.045 197.816L197.232 208.349L178.598 197.337Z",
    fill: "#C0A3FF"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M178.598 197.337L196.411 186.804L215.045 197.816L197.232 208.349L178.598 197.337Z",
    fill: "white"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M164.934 271.356L164.936 245.716L182.94 235.073L182.938 260.713L164.934 271.356Z",
    fill: "#C0A3FF"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.934 271.356L164.936 245.716L182.94 235.073L182.938 260.713L164.934 271.356Z",
    fill: "white"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M164.933 271.356L146.303 260.343L146.301 234.704L164.935 245.716L164.933 271.356Z",
    fill: "#C0A3FF"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.933 271.356L146.303 260.343L146.301 234.704L164.935 245.716L164.933 271.356Z",
    fill: "white"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M146.301 234.704L164.305 224.061L182.939 235.073L164.935 245.716L146.301 234.704Z",
    fill: "#C0A3FF"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.301 234.704L164.305 224.061L182.939 235.073L164.935 245.716L146.301 234.704Z",
    fill: "white"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M207.627 178.017L207.663 178.099L207.733 178.156C208.448 178.745 209.551 179.795 210.316 181.045C211.085 182.299 211.472 183.681 210.907 184.995C210.633 185.633 210.092 186.141 209.392 186.544C208.693 186.947 207.861 187.229 207.05 187.425C206.242 187.62 205.47 187.726 204.898 187.783C204.613 187.811 204.379 187.827 204.217 187.836C204.197 187.838 204.179 187.838 204.161 187.839L193.327 173.087L203.088 167.634L207.627 178.017Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M214.013 182.531C214.539 182.999 214.834 183.521 215.147 184.139C215.46 184.758 215.028 187.526 215.242 188.86C215.457 190.194 215.696 190.571 216.115 192.261C216.58 194.133 217.629 195.918 215.712 200.361C213.769 204.863 211.309 206.735 209.295 207.637C208.237 208.111 206.956 207.932 206.956 207.932C206.956 207.932 204.592 206.681 205.141 205.23C205.69 203.778 214.013 182.531 214.013 182.531Z",
    fill: "#263238"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M202.592 186.301C202.606 186.784 203.172 187.591 203.392 188.01C204.131 189.419 204.338 191.23 204.472 192.808C205.102 200.275 201.85 203.646 205.374 206.837C206.404 207.686 208.73 207.762 212.754 203.582C214.809 201.446 216.377 196.739 215.928 194.468C215.478 192.199 214.685 190.661 214.425 188.926C214.166 187.19 214.755 184.083 214.012 182.531C213.576 181.62 212.779 180.921 212.01 180.308C211.378 179.803 209.954 179.07 209.306 178.584C208.605 178.058 208.477 177.405 207.973 177.866L208.509 179.164C209.559 181.083 209.181 181.302 209.044 182.241C208.901 183.221 209.104 184.3 209.168 185.3C208.41 184.046 208.16 182.999 207.169 183.06C206.242 183.117 206.068 183.059 204.526 184.229C202.983 185.4 202.579 185.872 202.592 186.301Z",
    fill: "#455A64"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M212.754 203.583C214.809 201.447 216.377 196.739 215.928 194.469C215.766 193.649 215.558 192.926 215.347 192.253C215.36 192.404 215.386 192.56 215.391 192.689C215.403 192.977 215.407 193.265 215.401 193.553C215.379 194.661 215.24 195.854 214.671 196.822C214.165 197.682 212.976 199.852 211.771 199.76C211.09 199.708 210.593 198.96 210.42 198.152C210.347 197.811 210.265 196.904 210.265 196.904C210.265 196.904 208.452 197.084 207.002 197.836C205.13 198.807 205.163 199.076 205.163 199.076C205.19 199.487 205.192 200.179 205.043 200.645C204.894 201.112 204.541 201.854 204.219 202.125C204.063 202.256 203.899 202.354 203.735 202.435C203.616 204.126 203.896 205.5 205.375 206.839C206.404 207.686 208.73 207.763 212.754 203.583Z",
    fill: "#D4B4C1"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M204.47 192.808C204.666 195.124 204.487 197.045 204.254 198.691C204.697 200.637 205.277 200.649 205.465 199.691C205.654 198.728 204.849 194.566 204.288 191.136C204.369 191.704 204.424 192.27 204.47 192.808Z",
    fill: "#D4B4C1"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M210.131 181.628C210.339 180.73 210.166 179.762 209.736 178.876C209.574 178.773 209.423 178.673 209.304 178.584C208.603 178.058 208.475 177.405 207.971 177.866L208.507 179.164C209.557 181.083 209.179 181.302 209.042 182.241C208.899 183.221 209.102 184.3 209.166 185.3C209.533 188.553 210.076 189.689 210.08 192.722C210.083 195.754 209.27 197.695 209.663 197.914C210.056 198.132 210.929 197.892 211.351 195.512C211.774 193.132 211.198 188.981 210.685 186.985C210.172 184.989 209.837 182.889 210.131 181.628Z",
    fill: "#D4B4C1"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M210.449 197.137C210.405 197.174 210.35 197.197 210.29 197.203C208.19 197.392 207.037 197.79 205.302 199.449C205.18 199.558 204.999 199.556 204.887 199.435C204.777 199.313 204.783 199.124 204.902 199.01C206.735 197.257 208.005 196.804 210.239 196.605C210.4 196.591 210.542 196.712 210.556 196.877C210.566 196.982 210.522 197.077 210.449 197.137Z",
    fill: "#EBEBEB"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M210.364 194.599C210.32 194.635 210.267 194.659 210.208 194.666C208.03 194.917 206.782 195.392 204.941 197.138C204.803 197.264 204.628 197.247 204.516 197.122C204.403 196.996 204.41 196.801 204.532 196.686C206.474 194.847 207.831 194.318 210.141 194.053C210.307 194.034 210.456 194.155 210.474 194.324C210.485 194.433 210.441 194.535 210.364 194.599Z",
    fill: "#EBEBEB"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M210.726 191.858C210.679 191.897 210.621 191.924 210.555 191.931C208.153 192.208 206.695 192.788 204.667 194.714C204.539 194.839 204.323 194.833 204.198 194.695C204.073 194.558 204.081 194.343 204.216 194.214C206.351 192.192 207.934 191.55 210.481 191.256C210.663 191.234 210.827 191.369 210.848 191.556C210.861 191.675 210.812 191.787 210.726 191.858Z",
    fill: "#EBEBEB"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M210.605 189.465C210.558 189.503 210.501 189.529 210.437 189.536C208.082 189.807 206.672 190.362 204.679 192.253C204.553 192.373 204.341 192.37 204.22 192.234C204.097 192.099 204.105 191.888 204.238 191.764C206.329 189.779 207.868 189.16 210.365 188.874C210.543 188.853 210.705 188.985 210.725 189.168C210.737 189.286 210.688 189.396 210.605 189.465Z",
    fill: "#EBEBEB"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M210.023 187.08C209.977 187.118 209.919 187.144 209.855 187.151C207.499 187.423 206.092 187.976 204.097 189.869C203.967 189.991 203.759 189.985 203.637 189.85C203.515 189.715 203.523 189.505 203.656 189.38C205.75 187.393 207.286 186.776 209.783 186.488C209.961 186.468 210.122 186.6 210.143 186.782C210.156 186.9 210.107 187.011 210.023 187.08Z",
    fill: "#EBEBEB"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M198.041 180.227L198.057 180.218L198.072 180.207L204.048 175.888L209.136 184.707L198.69 189.827L194.352 182.383L198.041 180.227Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M216.619 141.173C216.619 141.173 194.373 137.398 184.854 137.459C175.14 137.522 174.67 146.719 177.101 151.293C181.755 160.051 194.595 175.946 194.595 175.946C194.595 175.946 202.941 174.346 204.611 169.53L200.92 160.865L212.535 164.67L218.467 160.594L218.951 157.494L216.619 141.173Z",
    fill: "#D4B4C1"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M216.619 141.172L255.131 147.738C255.131 147.738 255.509 157.176 251.885 165.63C248.773 172.891 242.425 176.115 237.477 176.895C232.28 177.713 225.826 177.864 225.826 177.864C225.826 177.864 222.787 180.717 219.722 181.964C216.657 183.21 205.088 188.163 205.088 188.163C205.088 188.163 199.495 185.266 199.87 178.462L212.535 164.67C215.4 161.094 216.406 159.938 218 159.129C215.555 154.295 216.346 146.499 216.619 141.172Z",
    fill: "#D4B4C1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.982 153.484C201.409 157.188 202.93 159.935 203.887 161.832L200.919 160.864C197.575 152.705 196.888 150.327 191.543 146.504C191.543 146.504 195.378 147.982 198.982 153.484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.666 173.29C228.666 173.29 226.639 176.3 220.073 179.149C216.656 180.632 206.612 184.665 202.391 185.919C203.726 187.453 205.089 188.162 205.089 188.162C205.089 188.162 216.659 183.21 219.723 181.962C220.298 181.729 220.871 181.438 221.424 181.121C223.452 179.958 225.2 178.43 225.69 177.988C225.779 177.907 225.827 177.863 225.827 177.863C228.711 175.292 228.666 173.29 228.666 173.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45 162.357C213.152 163.915 212.535 164.669 212.535 164.669L210.676 164.045C210.676 164.045 213.973 160.373 216.099 158.443C216.53 158.051 216.848 157.737 217.316 157.464C216.244 154.579 216.282 149.848 216.282 149.848C216.695 153.122 218.253 155.593 219.091 156.768C220.578 156.346 222.299 156.341 224.437 156.706C228.165 157.342 238.962 159.224 238.962 159.224C238.962 159.224 228.611 158.27 223.226 158.058C217.842 157.846 215.748 160.799 214.45 162.357Z",
    fill: "black"
  }))), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M179.367 186.464C176.599 187.582 174.889 188.707 173.61 190.418C172.332 192.129 171.942 193.863 173.156 195.936C174.371 198.009 176.603 200.442 179.254 200.283C181.905 200.125 183.536 199.448 185.996 198.083L179.367 186.464Z",
    fill: "#263238"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M201.49 188.862C201.529 189.711 198.033 191.404 194.4 193.179C190.506 195.081 189.547 196.319 186.369 197.921C182.737 199.751 181.357 199.856 178.539 199.054C175.72 198.253 172.243 194.122 174.665 190.323C176.64 187.227 179.198 186.376 183.079 185.33C187.091 184.249 189.227 183.493 192.159 182.326C194.961 181.211 197.272 179.209 197.851 179.903C197.451 180.102 194.518 181.955 195.073 182.459C195.208 182.719 195.627 182.638 196.349 182.333C196.663 182.199 197.027 182.118 197.354 182.283C197.683 182.449 197.894 182.823 198.079 183.175C198.529 184.03 198.587 184.556 198.958 185.452C199.175 185.976 199.085 185.672 199.287 186.203C199.514 186.797 199.945 187.692 199.889 188.236C199.854 188.564 199.622 188.668 199.375 188.829C199.129 188.989 198.782 189.183 198.55 189.366C198.456 189.44 198.29 189.683 198.343 189.808C198.431 190.016 198.937 189.917 199.147 189.828C199.4 189.72 199.711 189.649 199.968 189.552C200.211 189.459 200.849 189.168 201.49 188.862Z",
    fill: "#455A64"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M187.617 197.305C187.094 197.575 183.798 199.144 182.762 198.203C181.642 197.185 184.287 195.56 184.287 195.56C184.287 195.56 184.69 193.014 181.688 189.268C181.168 189.681 179 189.66 179.03 188.354C179.06 187.056 182.692 185.447 182.745 185.423C179.029 186.441 176.582 187.317 174.665 190.324C172.243 194.122 175.72 198.254 178.539 199.055C181.357 199.856 182.737 199.751 186.369 197.921C186.733 197.738 187.297 197.497 187.617 197.305Z",
    fill: "#D4B4C1"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M183.932 195.304C182.557 195.775 183.501 197.055 185.514 196.64C188.533 196.017 191.04 194.265 194.4 193.178C198.032 191.404 201.732 189.752 201.494 188.812C200.844 189.062 199.454 189.655 199.454 189.655C199.182 189.774 198.48 190.041 198.48 190.041C195.726 191.258 192.681 193.216 189.703 194.042C187.079 194.77 185.307 194.835 183.932 195.304Z",
    fill: "#D4B4C1"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M181.889 189.75C183.148 189.005 183.366 188.368 185.835 187.207C188.285 186.054 192.475 183.563 195.053 182.025C195.86 181.572 197.825 179.918 197.853 179.904C197.425 179.405 195.853 179.866 194.28 180.881C192.707 181.896 191.749 182.543 190.189 183.375C187.159 185.238 183.706 186.496 181.975 187.636C180.245 188.777 180.631 190.496 181.889 189.75Z",
    fill: "#D4B4C1"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M181.703 189.407C181.72 189.448 181.745 189.486 181.774 189.521C181.8 189.549 183.769 191.766 184.13 195.758C184.149 195.954 184.303 196.11 184.474 196.107C184.646 196.105 184.771 195.944 184.753 195.747C184.367 191.476 182.304 189.159 182.191 189.034C182.062 188.892 181.863 188.885 181.749 189.021C181.662 189.122 181.647 189.277 181.703 189.407Z",
    fill: "#F0F0F0"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M184.142 187.583C184.158 187.62 184.179 187.655 184.206 187.687C184.233 187.719 186.594 190.639 187.122 195.05C187.148 195.244 187.304 195.395 187.476 195.387C187.648 195.378 187.768 195.211 187.744 195.016C187.184 190.351 184.758 187.36 184.64 187.219C184.514 187.072 184.316 187.058 184.196 187.186C184.103 187.287 184.085 187.447 184.142 187.583Z",
    fill: "#F0F0F0"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M189.52 194.787C189.573 194.912 189.685 195.004 189.812 195.012C189.985 195.021 190.121 194.872 190.115 194.677C189.97 190.161 187.13 185.925 186.996 185.778C186.866 185.635 186.668 185.629 186.554 185.764C186.44 185.899 186.455 186.124 186.58 186.264C186.61 186.297 189.357 190.437 189.487 194.639C189.488 194.691 189.5 194.741 189.52 194.787Z",
    fill: "#F0F0F0"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M191.778 193.311C191.83 193.433 191.939 193.524 192.063 193.534C192.238 193.548 192.375 193.401 192.372 193.206C192.288 188.215 189.221 184.896 189.084 184.762C188.947 184.629 188.75 184.636 188.644 184.78C188.538 184.923 188.563 185.151 188.698 185.28C188.73 185.309 191.666 188.51 191.745 193.155C191.746 193.21 191.758 193.263 191.778 193.311Z",
    fill: "#F0F0F0"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M194.703 192.045C194.754 192.165 194.861 192.256 194.984 192.268C195.157 192.285 195.297 192.141 195.296 191.946C195.277 187.249 192.052 183.614 191.907 183.468C191.774 183.33 191.576 183.334 191.467 183.473C191.356 183.612 191.374 183.837 191.511 183.973C191.544 184.008 194.653 187.524 194.669 191.885C194.669 191.941 194.681 191.995 194.703 192.045Z",
    fill: "#EBEBEB"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M182.284 113.987L182.284 113.987L182.284 113.987L182.284 113.987L182.518 114.021L182.581 114.226C182.588 114.238 182.606 114.266 182.642 114.309C182.719 114.4 182.878 114.555 183.188 114.755L182.284 113.987ZM182.284 113.987L182.284 113.987L182.281 113.986L182.27 113.984L182.226 113.977C182.186 113.971 182.129 113.961 182.058 113.947C181.916 113.921 181.72 113.88 181.509 113.825C181.297 113.771 181.073 113.703 180.873 113.623C180.668 113.542 180.509 113.456 180.41 113.373L180.41 113.373C180.22 113.216 180.123 112.982 180.087 112.714C180.051 112.45 180.08 112.19 180.11 112.033C180.112 112.03 180.117 112.024 180.126 112.016C180.152 111.993 180.196 111.967 180.256 111.942C180.314 111.918 180.374 111.901 180.421 111.889C180.443 111.884 180.462 111.88 180.473 111.878L180.485 111.876L180.486 111.876L180.486 111.876L180.487 111.876L180.487 111.876L180.487 111.876L181.649 111.704L180.601 111.171C180.355 111.046 180.24 110.867 180.193 110.643C180.142 110.4 180.172 110.093 180.263 109.748C180.347 109.434 180.512 109.325 180.637 109.276C180.707 109.249 180.775 109.238 180.825 109.235C180.85 109.233 180.869 109.233 180.88 109.233L180.889 109.234L181.852 109.34L181.207 108.612C181.076 108.464 180.985 108.14 181.02 107.754C181.054 107.368 181.2 107.067 181.368 106.94L181.369 106.94C181.584 106.778 181.813 106.726 181.994 106.716C182.085 106.711 182.161 106.716 182.212 106.723C182.238 106.726 182.257 106.729 182.268 106.731L182.278 106.733C182.279 106.734 182.279 106.734 182.279 106.734L182.278 106.733L182.277 106.733L182.276 106.733L182.276 106.733C182.276 106.733 182.276 106.733 182.276 106.732L182.601 106.076C182.601 106.075 182.601 106.075 182.601 106.075M182.284 113.987L189.642 100.936M182.601 106.075L182.601 106.075L182.601 106.075L182.601 106.075ZM182.601 106.075L182.6 106.074L182.59 106.066C182.58 106.058 182.565 106.045 182.546 106.027C182.508 105.993 182.455 105.942 182.399 105.879C182.281 105.746 182.175 105.59 182.132 105.44L182.132 105.439C182.089 105.292 182.069 104.97 182.187 104.669C182.296 104.393 182.526 104.119 183.032 104.012C183.589 103.894 184.078 103.959 184.572 104.105C184.822 104.179 185.07 104.273 185.333 104.375C185.369 104.389 185.405 104.404 185.442 104.418C185.668 104.506 185.906 104.599 186.151 104.682C186.616 104.84 187.077 105.056 187.485 105.248C187.536 105.272 187.586 105.296 187.635 105.319C187.85 105.419 188.056 105.514 188.228 105.575C188.313 105.605 188.404 105.633 188.492 105.647C188.569 105.659 188.701 105.672 188.833 105.614C188.833 105.614 188.833 105.614 188.833 105.613L188.681 105.271C188.85 105.196 188.832 104.713 188.812 104.158C188.802 103.897 188.792 103.619 188.801 103.361C188.802 103.324 188.803 103.286 188.804 103.247C188.826 102.526 188.857 101.493 189.323 100.739C190.115 99.4563 190.918 99.4782 191.172 100.054M191.172 100.054L190.806 100.137C190.809 100.148 190.812 100.161 190.814 100.175M191.172 100.054C191.209 100.218 191.254 100.57 191.311 101.017C191.427 101.927 191.593 103.228 191.847 104.133C192.203 105.402 192.338 105.838 192.629 106.784C192.648 106.843 192.666 106.904 192.686 106.967L192.328 107.078C192.328 107.078 192.328 107.078 192.328 107.078M191.172 100.054L190.829 100.205C190.824 100.194 190.819 100.185 190.814 100.175M190.814 100.175C190.783 100.118 190.747 100.087 190.717 100.072C190.684 100.055 190.629 100.041 190.54 100.063C190.347 100.112 190.017 100.329 189.642 100.936M190.814 100.175C190.837 100.289 190.865 100.487 190.9 100.76C190.912 100.854 190.925 100.955 190.939 101.062C190.968 101.294 191.002 101.554 191.038 101.825C191.146 102.613 191.289 103.532 191.486 104.234C191.843 105.508 191.979 105.948 192.271 106.895C192.289 106.954 192.308 107.015 192.328 107.078M189.642 100.936C189.642 100.936 189.642 100.936 189.642 100.936L189.323 100.739L189.642 100.936ZM192.328 107.078C192.633 108.071 192.974 109.23 193.125 110.124C193.26 110.92 193.775 112.376 195.12 113.544C195.769 114.107 198.567 116.167 201.178 118.07C202.489 119.025 203.761 119.946 204.704 120.628C205.176 120.969 205.566 121.25 205.838 121.446L206.153 121.673L206.236 121.733L206.257 121.748L206.262 121.752L206.263 121.753L206.264 121.753C206.264 121.753 206.264 121.753 206.288 121.719C206.314 121.683 206.368 121.608 206.479 121.454L206.264 121.753L206.56 121.966L206.781 121.676C207.944 120.149 208.936 118.889 210.048 117.476C210.274 117.19 210.504 116.898 210.741 116.596C212.15 114.803 213.814 112.673 216.232 109.483C218.647 106.297 220.769 104.535 224.145 103.676L222.908 120.223C222.874 120.265 222.828 120.322 222.771 120.392C222.632 120.562 222.427 120.811 222.162 121.126C221.631 121.758 220.861 122.656 219.903 123.725C217.987 125.862 215.321 128.675 212.321 131.382C209.957 133.515 208.451 134.245 207.178 134.229C205.892 134.212 204.737 133.441 203.03 132.206C200.535 130.4 198.024 127.793 195.96 125.649C195.279 124.943 194.647 124.286 194.08 123.725C192.963 122.621 192.074 121.597 191.294 120.686C191.23 120.611 191.166 120.536 191.102 120.462C190.406 119.647 189.782 118.918 189.157 118.325C188.585 117.782 187.843 117.369 187.155 117.04C186.825 116.882 186.5 116.74 186.208 116.612L186.165 116.593C185.858 116.459 185.594 116.343 185.384 116.235C184.903 115.988 184.423 115.664 184.027 115.378C183.83 115.235 183.657 115.103 183.516 114.996L183.495 114.981C183.371 114.886 183.259 114.801 183.189 114.755L192.328 107.078Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M184.371 112.777C184.399 112.984 184.307 113.172 184.175 113.311C184.01 113.473 183.802 113.655 183.604 113.797C183.506 113.876 183.406 113.951 183.301 114.016C183.198 114.088 183.104 114.107 182.977 114.153L182.23 114.358C182.493 114.397 182.754 114.396 183.02 114.366C183.147 114.359 183.305 114.31 183.424 114.241C183.544 114.176 183.659 114.103 183.768 114.024C183.976 113.842 184.17 113.684 184.34 113.445C184.418 113.324 184.478 113.184 184.488 113.035C184.49 112.939 184.464 112.85 184.423 112.769C184.638 112.734 184.839 112.664 185.031 112.596C185.324 112.469 185.657 112.388 185.9 112.086C186.011 111.929 186.059 111.779 186.11 111.607C186.124 111.552 186.128 111.496 186.126 111.44L186.381 111.122C186.381 111.122 186.471 111.915 187.272 113.019C188.074 114.123 189.242 114.61 189.242 114.61C189.242 114.61 188.35 114.144 187.569 112.645C186.897 111.357 187.2 109.62 187.604 108.754C187.622 108.748 187.641 108.75 187.659 108.741C187.79 108.669 187.861 108.562 187.921 108.465C188.05 108.244 188.055 107.984 188.009 107.763C187.959 107.539 187.864 107.336 187.75 107.151C187.289 106.408 186.517 105.982 185.75 105.722C185.687 105.536 185.591 105.383 185.484 105.235C185.368 105.08 185.235 104.941 185.092 104.814C185.218 104.958 185.332 105.112 185.432 105.272C185.53 105.431 185.617 105.608 185.653 105.779L185.66 105.81L185.692 105.823C186.431 106.131 187.139 106.596 187.545 107.281C187.742 107.608 187.874 108.035 187.697 108.323C187.587 108.495 187.516 108.54 187.327 108.495C187.145 108.457 186.942 108.39 186.741 108.344C186.333 108.246 185.926 108.203 185.537 108.117C185.148 108.032 184.777 107.891 184.417 107.709C184.058 107.526 183.717 107.3 183.371 107.081C183.028 106.858 182.679 106.642 182.37 106.371C182.945 106.97 183.618 107.45 184.324 107.888C184.682 108.099 185.075 108.268 185.483 108.36C185.888 108.457 186.294 108.507 186.678 108.608C186.757 108.628 186.834 108.651 186.912 108.674C187.043 108.815 187.129 108.994 187.133 109.182C187.153 109.522 186.937 109.814 186.646 109.968C186.34 110.139 186.038 110.304 185.717 110.403C185.394 110.49 185.044 110.584 184.734 110.546C184.09 110.465 183.475 110.053 182.843 109.757C182.21 109.447 181.577 109.14 180.927 108.862C181.522 109.246 182.132 109.601 182.743 109.954C183.047 110.132 183.357 110.298 183.673 110.464C183.99 110.621 184.325 110.785 184.707 110.824C184.939 110.828 185.162 110.797 185.381 110.751C185.594 110.838 185.786 110.968 185.895 111.158C185.969 111.283 185.99 111.43 185.945 111.56C185.895 111.694 185.825 111.854 185.738 111.952C185.556 112.148 185.238 112.249 184.949 112.355C184.655 112.454 184.351 112.549 184.081 112.506C183.804 112.475 183.544 112.292 183.234 112.16C182.929 112.033 182.619 111.943 182.307 111.872C181.686 111.724 181.063 111.598 180.432 111.507C181.037 111.711 181.647 111.89 182.252 112.081C182.552 112.183 182.856 112.267 183.135 112.396C183.406 112.515 183.679 112.73 184.042 112.785C184.157 112.797 184.265 112.791 184.371 112.777ZM187.049 108.726C187.044 108.72 187.041 108.714 187.036 108.708L187.037 108.708C187.04 108.714 187.046 108.72 187.049 108.726Z",
    fill: "white"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M226.115 100.483C221.181 101.543 219.046 103.752 215.199 108.863C211.351 113.973 209.342 116.985 208.049 118.448C206.547 120.147 205.686 120.908 205.686 120.908L206.485 121.447C210.67 123.548 213.311 128.751 213.557 130.752C214.079 131.228 215.639 130.956 217.977 128.47C220.642 125.638 228.046 117.021 228.046 117.021L226.115 100.483Z",
    fill: "#BA5780"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.115 100.483C221.181 101.543 219.046 103.752 215.199 108.863C211.351 113.973 209.342 116.985 208.049 118.448C206.547 120.147 205.686 120.908 205.686 120.908L206.485 121.447C210.67 123.548 213.311 128.751 213.557 130.752C214.079 131.228 215.639 130.956 217.977 128.47C220.642 125.638 228.046 117.021 228.046 117.021L226.115 100.483Z",
    fill: "black"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M216.088 129.34C215.715 127.156 213.251 122.514 210.624 120.925C207.515 119.044 205.845 119.546 205.156 120.489L205.686 120.909C208.311 122.532 210.657 128.343 210.916 130.39C211.175 132.437 210.8 133.123 210.8 133.123L209.885 133.734C209.885 133.734 210.187 134.592 211.503 134.524C212.818 134.456 213.007 133.049 214.055 132.786C215.103 132.523 216.461 131.525 216.088 129.34Z",
    fill: "#B2473D"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M221.876 113.224C222.765 105.436 224.987 102.326 226.369 100.678L238.495 98.873C240.991 99.4477 249.561 102.428 252.445 103.518C254.302 104.219 255.031 108.3 255.314 114.677C255.543 119.856 255.513 124.192 255.212 131.34C254.96 137.331 254.689 144.156 252.746 152.451C245.709 155.026 225.561 152.044 217.686 142.439C218.374 140.317 221.03 136.507 221.519 132.224C221.425 123.228 221.507 116.452 221.876 113.224Z",
    fill: "#FAFAFA"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M234.653 99.9952C231.035 101.357 228.328 105.389 227.374 111.021C226.42 116.653 225.458 131.055 224.783 135.306C224.108 139.558 221.309 146.934 221.309 146.934C221.309 146.934 216.278 144.382 215.123 140.818C217.202 138.149 218.609 133.732 219.027 130.185C219.443 126.639 219.909 116.957 220.513 112.633C221.116 108.309 222.801 103.368 226.119 100.483C230.035 99.6197 234.632 99.0151 234.632 99.0151L234.653 99.9952Z",
    fill: "#BA5780"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.377 110.992C226.981 110.844 226.584 110.699 226.189 110.55C224.601 109.95 222.941 109.392 221.343 108.715C221.283 108.922 221.224 109.128 221.169 109.335C221.828 109.645 222.505 109.928 223.196 110.2C223.179 111.171 223.053 112.603 222.973 113.704C222.854 115.341 222.725 116.978 222.576 118.614C222.291 121.738 222.044 123.986 221.576 127.087C220.751 132.561 219.151 138.03 216.861 143.591C217.036 143.779 217.215 143.962 217.398 144.137C220.868 135.714 222.407 127.042 223.197 117.905C223.309 116.605 223.41 115.304 223.504 114.002C223.59 112.829 223.592 111.455 223.688 110.387C224.478 110.693 225.269 110.987 226.045 111.288C226.448 111.444 226.852 111.595 227.255 111.748C227.293 111.494 227.332 111.248 227.37 111.021C227.373 111.011 227.376 111.002 227.377 110.992Z",
    fill: "black"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M226.925 114.274C228.953 105.306 234.754 100.753 234.754 100.753L234.867 97.6704C234.867 97.6704 232.788 98.4169 230.868 99.6353C228.949 100.854 225.597 104.802 224.691 108.022C226.626 106.404 227.331 109.11 226.925 114.274Z",
    fill: "#A25049"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M245.569 96.5261C246.273 93.8253 249.2 91.2148 250.619 88.9368C251.987 86.7397 252.838 85.0157 252.904 82.8345C252.943 81.5426 252.31 79.7264 251.413 79.2725C251.516 79.3242 251.776 76.9924 251.764 76.7695C251.707 75.6825 251.517 74.5996 250.894 73.6971C249.765 72.0627 248.019 70.9559 246.171 70.3016C244.324 69.6473 242.362 69.4098 240.415 69.2279C239.202 69.1145 237.971 69.0202 236.796 68.6632C235.674 68.3222 234.684 67.7077 233.596 67.2797C232.434 66.8225 231.001 66.6904 230.046 67.5073C229.115 68.3029 229.012 69.9174 229.833 70.8305C228.956 70.7761 228.038 70.9539 227.333 71.4894C226.627 72.0249 226.178 72.9586 226.352 73.8404C226.515 74.66 227.229 75.3315 228.04 75.4277C227.434 76.1099 226.976 76.9573 226.878 77.873C226.781 78.7894 227.085 79.7728 227.777 80.3627C228.575 81.0436 229.709 81.1006 230.746 81.0296C230.407 81.0528 231.599 83.3422 231.743 83.5081C232.34 84.1949 233.249 84.7111 234.09 85.0038C235.97 85.6574 237.933 86.0217 239.892 86.3561C240.014 86.3767 240.142 86.4013 240.231 86.4875C240.299 86.5526 240.334 86.6441 240.368 86.7324C241.089 88.6322 242.283 90.4338 243.246 92.2208C244.008 93.6329 244.769 95.045 245.532 96.4577C245.537 96.467 245.572 96.5141 245.569 96.5261Z",
    fill: "black"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M249.106 92.0139L249.106 92.0139C251.102 90.9605 252.341 88.2042 251.026 85.8833L251.026 85.8833C250.65 85.2186 250.009 84.8938 249.328 84.8477C248.637 84.8009 247.938 85.0446 247.49 85.4802C247.117 85.843 246.878 86.2225 246.646 86.5897C246.578 86.6979 246.511 86.8051 246.441 86.9104C246.151 87.3465 245.775 87.8081 245.082 87.784L245.082 87.784C244.637 87.7684 244.299 87.5746 244.07 87.273C243.853 86.9877 243.748 86.6275 243.699 86.2842C243.616 85.701 243.678 85.0579 243.746 84.6203C243.74 84.6154 243.734 84.6103 243.728 84.6051C243.671 84.5572 243.605 84.5019 243.534 84.442C243.466 84.3853 243.394 84.3244 243.319 84.2616C243.168 84.1341 243.011 84.0018 242.886 83.8929C242.823 83.8386 242.766 83.7887 242.721 83.7476C242.683 83.7127 242.634 83.6677 242.602 83.6301L249.106 92.0139ZM249.106 92.0139C248.226 92.478 247.547 92.4013 247.096 92.2326C246.864 92.1461 246.684 92.0319 246.563 91.9402C246.503 91.8945 246.458 91.855 246.43 91.8285C246.416 91.8153 246.406 91.8053 246.4 91.7995L246.395 91.7945L246.395 91.7941M249.106 92.0139L246.395 91.7941M246.395 91.7941L246.395 91.7941M246.395 91.7941L246.395 91.7941M246.395 91.7941C246.395 91.7937 246.394 91.7937 246.395 91.7939L245.782 91.1153M246.395 91.7941L245.782 91.1153M245.782 91.1153L245.743 92.0312M245.782 91.1153L245.743 92.0312M245.743 92.0312L245.361 101.125C244.551 102.847 242.68 104.083 240.534 104.855C238.488 105.591 236.272 105.875 234.685 105.779C234.362 104.268 234.503 102.548 235.105 100.881L235.125 100.825L235.127 100.767L235.241 97.6845L235.257 97.2379L234.815 97.2992L234.815 97.2992L234.815 97.2992L234.815 97.2993L234.815 97.2993M245.743 92.0312L234.815 97.2993M228.159 83.7649C228.159 83.7649 228.159 83.7649 228.159 83.7649C228.327 83.0557 228.373 82.1727 228.411 81.4597C228.414 81.3879 228.418 81.3179 228.422 81.2498L228.159 83.7649ZM228.159 83.7649C227.497 86.5677 227.107 88.9509 227.444 91.3823L227.444 91.3823C227.876 94.5 229.575 96.1266 231.453 96.8065L231.453 96.8065C232.413 97.1547 233.262 97.277 233.868 97.3125C234.171 97.3303 234.412 97.3263 234.576 97.3182C234.657 97.3142 234.72 97.3091 234.76 97.3052C234.78 97.3033 234.795 97.3016 234.804 97.3005L234.814 97.2994L234.815 97.2993M228.159 83.7649L234.815 97.2993M229.344 77.4231C228.869 78.6302 228.491 79.979 228.422 81.2498L229.344 77.4231ZM229.344 77.4231C229.656 76.6337 230.062 75.8836 230.551 75.196C230.585 75.1484 230.621 75.0961 230.659 75.0412C230.822 74.8047 231.021 74.5177 231.23 74.3333C231.336 74.2399 231.396 74.218 231.415 74.2129C231.432 74.2256 231.465 74.2609 231.51 74.3507L231.51 74.351C231.607 74.545 231.695 74.7414 231.786 74.9468C231.816 75.0159 231.848 75.086 231.88 75.1574C232.004 75.4349 232.141 75.7238 232.31 76.001C233.113 77.32 234.391 78.3806 236.02 78.3574L236.719 78.3475L236.324 77.7708C236.157 77.5267 236.031 77.2365 235.963 76.9329L229.344 77.4231ZM231.403 74.2068C231.403 74.2063 231.406 74.2068 231.411 74.2101C231.406 74.209 231.403 74.2073 231.403 74.2068Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M239.692 97.2289C238.615 97.6777 237.184 97.9851 235.201 98.0434L235.23 97.209C236.756 97.1102 237.931 96.9389 238.982 96.5973C240.116 96.2286 241.084 95.6684 242.183 94.8218L242.184 94.8218C242.632 94.4766 243.027 94.1134 243.37 93.7589C243.07 94.2911 242.69 94.8566 242.213 95.4041L242.213 95.4042C241.599 96.1114 240.834 96.7533 239.692 97.2289Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M236.648 83.7424C236.621 84.321 237.04 84.8101 237.584 84.8346C238.129 84.8592 238.591 84.4106 238.617 83.832C238.644 83.2533 238.225 82.7643 237.681 82.7397C237.137 82.7152 236.674 83.1638 236.648 83.7424Z",
    fill: "black"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M237.406 80.7066L239.424 82.053C239.779 81.4578 239.614 80.6734 239.057 80.3018C238.5 79.9296 237.76 80.1107 237.406 80.7066Z",
    fill: "black"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M229.215 80.9207L231.538 80.2001C231.366 79.5305 230.707 79.1497 230.066 79.3487C229.424 79.5471 229.043 80.2512 229.215 80.9207Z",
    fill: "black"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M229.37 82.7824C229.393 83.3611 229.852 83.811 230.396 83.7864C230.94 83.7625 231.362 83.2741 231.34 82.6955C231.317 82.1169 230.857 81.667 230.314 81.6909C229.769 81.7147 229.347 82.2031 229.37 82.7824Z",
    fill: "black"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M235.005 82.2763L234.006 87.3868L231.645 86.472C232.132 85.3046 232.81 84.2189 233.488 83.4376C233.85 83.0206 234.205 82.6986 234.522 82.4961C234.71 82.3764 234.871 82.3069 235.005 82.2763Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M236.433 89.8071L232.449 90.4229C232.589 91.5849 233.595 92.3898 234.696 92.2199C235.796 92.0493 236.574 90.9697 236.433 89.8071Z",
    fill: "black"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M235.919 90.4336C236.087 90.4256 236.248 90.4429 236.405 90.4707C236.248 91.354 235.581 92.0826 234.696 92.2193C234.474 92.2538 234.259 92.2385 234.051 92.1987C234.046 91.2677 234.865 90.4834 235.919 90.4336Z",
    fill: "white"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M255.085 105.305L246.883 100.723C246.883 100.723 243.052 104.591 240.513 109.75C237.973 114.908 237.83 114.221 237.255 126.455C236.828 135.535 234.432 149.549 233.307 153.215C236.558 154.679 244.79 156.643 254.865 155.038C254.865 155.038 255.692 148.55 256.355 130.631C256.699 121.343 259.476 108.017 255.085 105.305Z",
    fill: "#BA5780"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M252.231 116.808C247.534 116.606 242.905 115.772 238.364 114.566C238.294 114.811 238.23 115.065 238.17 115.335C239.749 115.76 241.334 116.142 242.963 116.47C242.888 117.897 242.792 119.42 242.702 120.854C242.608 122.319 242.516 123.783 242.422 125.247C242.23 128.281 242.037 131.314 241.844 134.348C241.484 139.997 241.11 145.669 240.005 151.226C239.759 152.461 239.465 153.686 239.139 154.902C239.408 154.952 239.683 155.001 239.965 155.048C240.157 154.314 240.335 153.577 240.497 152.835C241.117 150.012 241.532 147.145 241.84 144.27C242.464 138.458 242.731 132.605 243.101 126.773C243.212 125.038 243.322 123.302 243.433 121.566C243.536 119.939 243.56 118.048 243.647 116.61C246.573 117.174 249.531 117.555 252.514 117.691C253.054 117.714 252.679 116.827 252.231 116.808Z",
    fill: "black"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M237.752 118.211C238.886 110.071 242.427 109.718 243.149 112.414C246.131 108.027 248.875 103.465 248.858 101.942C248.089 100.749 247.436 99.6782 247.137 99.1713C246.573 98.2184 245.867 98.083 245.867 98.083L245.773 100.325C245.773 100.325 243.388 103.417 240.95 106.368C239.16 108.535 238.296 111.336 237.752 118.211Z",
    fill: "#A25049"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M180.652 152.351L201.691 140.393L239.068 163.452C239.239 163.558 239.234 163.813 239.06 163.912L218.364 175.614L180.652 152.351Z",
    fill: "black"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M238.277 160.747L238.266 161.416C238.255 162.092 237.892 162.711 237.317 163.039L219.535 173.103C219.247 173.267 218.926 173.344 218.606 173.338C218.289 173.333 217.97 173.244 217.689 173.071L185.708 153.407C185.141 153.059 184.799 152.427 184.811 151.752L184.819 151.292L218.626 172.08L238.277 160.747Z",
    fill: "#EBEBEB"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M184.818 151.292L204.162 140.31C204.506 140.114 204.925 140.122 205.262 140.329L238.159 160.559C238.321 160.658 238.317 160.899 238.152 160.993L218.627 172.082L184.818 151.292Z",
    fill: "#FAFAFA"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M218.832 170.42L229.265 164.502L199.359 146.113L188.873 151.999L218.832 170.42Z",
    fill: "#E0E0E0"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M224.197 153.54L224.005 153.65L218.891 156.553L209.976 151.071L209.791 150.958L215.097 147.946L224.197 153.54Z",
    fill: "#E0E0E0"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M224.003 153.65L218.889 156.553L209.975 151.071L215.091 148.168L224.003 153.65Z",
    fill: "#E6E6E6"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M218.625 172.08L218.604 173.338C218.287 173.333 217.968 173.244 217.687 173.071L185.706 153.407C185.139 153.059 184.797 152.427 184.809 151.752L184.817 151.292L218.625 172.08Z",
    fill: "#EBEBEB"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.625 172.08L218.604 173.338C218.287 173.333 217.968 173.244 217.687 173.071L185.706 153.407C185.139 153.059 184.797 152.427 184.809 151.752L184.817 151.292L218.625 172.08Z",
    fill: "#E0E0E0"
  }))), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 154.883C238.347 155.005 237.913 155.314 237.405 155.675C236.414 156.38 235.138 157.287 233.666 157.406C232.282 157.519 230.842 157.343 229.65 157.198C228.305 157.034 227.275 156.908 227 157.28C226.897 157.669 226.756 157.986 226.591 158.306C226.556 158.308 226.522 158.311 226.491 158.313C226.438 158.318 226.392 158.321 226.355 158.324L226.38 158.698L226.709 158.878C226.748 158.807 226.787 158.736 226.825 158.665C227.207 158.641 227.693 158.633 228.051 158.746C228.545 158.875 229.074 159.685 228.831 159.99C228.675 160.187 228.417 160.285 228.111 160.402C228.016 160.438 227.917 160.475 227.815 160.518M238.695 154.883C245.266 152.573 249.91 150.482 256.603 147.087M238.695 154.883L238.57 154.529C238.57 154.529 238.57 154.529 238.57 154.529M238.695 154.883L238.57 154.529M256.603 147.087C261.957 144.37 262.373 142.201 262.503 137.513C262.744 128.844 262.348 124.785 261.943 120.633C261.834 119.52 261.725 118.401 261.627 117.184C261.121 110.887 259.935 108.108 254.8 106.055M256.603 147.087L256.434 146.752M256.603 147.087L256.434 146.752C256.434 146.752 256.434 146.752 256.434 146.752M254.8 106.055C250.195 110.631 249.151 112.444 249.078 119.448M254.8 106.055L255.065 106.321C255.005 106.379 254.947 106.438 254.889 106.496M254.8 106.055L254.661 106.403C254.738 106.434 254.814 106.465 254.889 106.496M249.078 119.448L250.56 135.825M249.078 119.448L249.452 119.415L249.453 119.433M249.078 119.448L249.453 119.452C249.453 119.446 249.453 119.44 249.453 119.433M250.56 135.825C250.56 135.825 246.049 139.517 241.102 143.202C240.81 143.419 240.525 143.634 240.246 143.844C237.052 146.244 234.585 148.097 230.628 148.201C229.42 148.232 228.417 148.231 227.547 148.23C225.318 148.226 223.968 148.224 222.307 148.783M250.56 135.825L250.797 136.116L250.951 135.99L250.933 135.792L249.453 119.433M250.56 135.825L250.797 136.116L250.797 136.116L250.796 136.116L250.794 136.118L250.784 136.126L250.745 136.158L250.593 136.282C250.459 136.391 250.264 136.549 250.013 136.752C249.512 137.156 248.793 137.733 247.919 138.426C246.171 139.81 243.804 141.657 241.326 143.502C241.031 143.722 240.743 143.939 240.459 144.153C237.28 146.543 234.72 148.469 230.638 148.576L230.637 148.576C229.556 148.604 228.639 148.606 227.836 148.605C227.738 148.605 227.641 148.605 227.546 148.605C226.866 148.604 226.274 148.603 225.73 148.617C224.498 148.651 223.534 148.766 222.427 149.138M222.307 148.783C221.079 149.197 218.275 150.161 217.311 150.551C216.764 150.772 215.949 151.365 215.048 152.02C214.361 152.519 213.624 153.055 212.919 153.489M222.307 148.783L222.427 149.138C222.427 149.138 222.427 149.138 222.427 149.138M222.307 148.783L222.427 149.138M212.919 153.489C211.379 154.523 213.113 155.342 214.256 155.114C215.449 154.877 216.3 154.466 217.13 154.066C217.336 153.966 217.542 153.867 217.751 153.771M212.919 153.489L213.128 153.8C213.126 153.802 213.124 153.803 213.123 153.804M212.919 153.489L213.116 153.808C213.118 153.807 213.12 153.806 213.123 153.804M217.751 153.771C218.421 153.464 219.08 153.313 219.752 153.159C219.926 153.119 220.101 153.079 220.277 153.036C220.312 152.94 220.345 152.853 220.376 152.777L220.723 152.92L220.824 153.281C220.737 153.305 220.65 153.328 220.563 153.351C220.262 154.218 219.867 155.637 219.804 156.29M217.751 153.771L217.595 153.43M217.751 153.771L217.595 153.43C217.595 153.43 217.595 153.43 217.595 153.43M219.804 156.29C219.794 156.391 219.781 156.494 219.767 156.6C219.696 157.15 219.619 157.745 220.032 158.173C220.244 158.393 220.651 158.568 220.985 158.712C221.087 158.756 221.183 158.797 221.263 158.835M219.804 156.29L220.177 156.326C220.177 156.326 220.177 156.326 220.177 156.326M219.804 156.29L220.177 156.326M221.263 158.835C221.263 158.835 221.235 159.186 221.462 159.465C221.694 159.748 222.185 159.842 222.525 159.855M221.263 158.835C221.637 158.866 221.637 158.866 221.637 158.866L221.637 158.866L221.263 158.835ZM222.525 159.855C222.605 159.858 222.693 159.856 222.778 159.852C222.778 159.832 222.779 159.812 222.78 159.792L223.154 159.818M222.525 159.855L222.54 159.481C222.54 159.481 222.54 159.481 222.54 159.481M222.525 159.855L222.539 159.481C222.539 159.481 222.539 159.481 222.54 159.481M223.154 159.818L223.191 160.104C223.289 160.411 223.554 160.678 223.762 160.788M223.154 159.818L223.106 159.446M223.154 159.818L223.106 159.446L223.106 159.446L223.103 159.447L223.093 159.448L223.052 159.453C223.016 159.457 222.966 159.462 222.908 159.467L228.517 159.78M223.762 160.788C224.684 161.275 226.141 161.196 226.364 161.127M223.762 160.788L223.938 160.456M223.762 160.788L223.937 160.456C223.938 160.456 223.938 160.456 223.938 160.456M226.364 161.127C226.459 161.098 227.009 160.863 227.423 160.685C227.587 160.615 227.73 160.554 227.815 160.518M226.364 161.127L226.254 160.769C226.255 160.769 226.255 160.769 226.254 160.769M226.364 161.127L226.253 160.769L226.252 160.769C226.252 160.769 226.253 160.769 226.254 160.769M227.815 160.518L227.67 160.173M227.815 160.518L227.67 160.173C227.67 160.173 227.67 160.173 227.67 160.173M227.67 160.173C227.778 160.127 227.882 160.087 227.976 160.052L227.994 160.045C228.094 160.006 228.18 159.974 228.257 159.94C228.391 159.88 228.469 159.83 228.517 159.78M227.67 160.173C227.584 160.208 227.439 160.271 227.273 160.341C227.148 160.395 227.012 160.453 226.88 160.509C226.726 160.575 226.578 160.638 226.461 160.686C226.402 160.71 226.353 160.731 226.314 160.746C226.295 160.754 226.279 160.759 226.268 160.764C226.261 160.766 226.256 160.768 226.254 160.769M228.517 159.78C228.517 159.788 228.517 159.793 228.517 159.796M228.517 159.78L228.517 159.798C228.517 159.798 228.517 159.797 228.517 159.796M228.517 159.78C228.516 159.774 228.515 159.766 228.513 159.756C228.501 159.694 228.466 159.605 228.401 159.504C228.263 159.287 228.075 159.14 227.956 159.109L227.948 159.106L227.939 159.104C227.736 159.04 227.454 159.021 227.154 159.026C226.936 159.03 226.737 159.046 226.571 159.06C226.511 159.064 226.455 159.069 226.405 159.072L225.722 159.118L226.051 158.518C226.308 158.05 226.506 157.681 226.637 157.184L226.655 157.115L226.698 157.057C226.833 156.875 227.031 156.782 227.217 156.732C227.405 156.682 227.62 156.664 227.844 156.663C228.291 156.66 228.856 156.724 229.467 156.798C229.54 156.807 229.614 156.816 229.688 156.825C230.886 156.971 232.291 157.142 233.636 157.032L233.636 157.032C234.652 156.95 235.587 156.454 236.424 155.899C236.694 155.721 236.942 155.545 237.179 155.376C237.314 155.28 237.446 155.186 237.576 155.096C237.918 154.859 238.26 154.638 238.57 154.529M228.517 159.78L217.595 153.43M228.517 159.78C228.524 159.772 228.531 159.765 228.538 159.757L228.538 159.756C228.523 159.775 228.518 159.79 228.517 159.796M228.517 159.78L228.517 159.796M226.254 160.769C226.251 160.769 226.229 160.774 226.18 160.78C226.128 160.787 226.058 160.793 225.974 160.797C225.805 160.806 225.588 160.807 225.349 160.792C224.862 160.76 224.33 160.663 223.938 160.456M223.938 160.456C223.86 160.415 223.743 160.319 223.652 160.189C223.559 160.059 223.522 159.938 223.528 159.845L223.561 159.387L223.106 159.446M223.106 159.446C223.106 159.446 223.106 159.446 223.106 159.446L223.106 159.446ZM238.57 154.529C245.122 152.226 249.75 150.143 256.434 146.752M256.434 146.752C259.085 145.407 260.446 144.23 261.182 142.862C261.924 141.482 262.063 139.855 262.128 137.502C262.369 128.858 261.975 124.821 261.57 120.672C261.461 119.558 261.352 118.436 261.254 117.214C261.001 114.071 260.581 111.876 259.625 110.215C258.708 108.624 257.272 107.482 254.889 106.496M254.889 106.496C252.692 108.689 251.376 110.211 250.582 111.994C249.771 113.818 249.49 115.953 249.453 119.433M222.427 149.138C221.195 149.554 218.403 150.514 217.452 150.898C217.022 151.072 216.372 151.523 215.584 152.094C215.481 152.168 215.376 152.245 215.27 152.322C214.586 152.819 213.838 153.363 213.123 153.804M213.123 153.804C212.773 154.04 212.698 154.207 212.687 154.272C212.681 154.309 212.685 154.378 212.815 154.481C212.947 154.586 213.162 154.681 213.423 154.734C213.681 154.787 213.953 154.792 214.183 154.746L214.183 154.746C215.325 154.519 216.127 154.132 216.951 153.735C217.162 153.633 217.375 153.531 217.595 153.43M222.54 159.481C222.393 159.475 222.22 159.452 222.065 159.403C221.904 159.353 221.803 159.288 221.752 159.227C221.692 159.154 221.661 159.064 221.647 158.981C221.64 158.942 221.638 158.908 221.637 158.886C221.637 158.875 221.637 158.867 221.637 158.863L221.637 158.863L221.637 158.862L221.637 158.861L221.658 158.608L221.424 158.497C221.337 158.455 221.235 158.412 221.135 158.368L221.113 158.359C221.003 158.311 220.891 158.263 220.783 158.212C220.556 158.104 220.389 158.003 220.302 157.913C220.148 157.753 220.088 157.549 220.086 157.272C220.084 157.074 220.108 156.888 220.135 156.681C220.149 156.57 220.165 156.454 220.177 156.326M222.54 159.481L220.177 156.326",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M220.139 153.066C220.551 152.251 221.16 151.291 221.811 151.116C221.404 151.5 220.852 152.625 220.722 152.919C220.525 152.974 220.332 153.02 220.139 153.066Z",
    fill: "white"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M221.262 158.835C221.195 158.215 221.281 157.593 221.373 156.982C221.468 156.371 221.611 155.769 221.771 155.173C221.943 154.586 222.112 153.976 222.423 153.426C222.729 152.891 223.092 152.342 223.639 152.049C223.403 152.241 223.232 152.494 223.077 152.751C222.917 153.004 222.778 153.272 222.662 153.548C222.423 154.094 222.27 154.678 222.106 155.27C221.939 155.856 221.789 156.447 221.633 157.038C221.489 157.632 221.339 158.223 221.262 158.835Z",
    fill: "white"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M223.154 159.818C223.132 159.209 223.215 158.601 223.318 158.004C223.421 157.404 223.575 156.816 223.746 156.234C223.926 155.654 224.125 155.08 224.388 154.53C224.655 153.997 224.919 153.398 225.435 153.061C225.213 153.264 225.094 153.545 224.967 153.809C224.844 154.079 224.734 154.355 224.635 154.637C224.436 155.199 224.249 155.766 224.079 156.339C223.732 157.485 223.401 158.633 223.154 159.818Z",
    fill: "white"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M228.05 158.745C227.782 158.738 227.537 158.729 227.308 158.782C227.067 158.817 226.888 158.923 226.583 158.992L226.721 158.806C226.726 158.957 226.687 159.054 226.641 159.161C226.595 159.265 226.522 159.35 226.448 159.426C226.298 159.577 226.113 159.672 225.92 159.711C226.056 159.566 226.174 159.421 226.261 159.274C226.304 159.198 226.331 159.119 226.355 159.044C226.377 158.973 226.386 158.879 226.384 158.837L226.378 158.697L226.523 158.652C226.712 158.591 226.95 158.561 227.227 158.569C227.508 158.581 227.836 158.579 228.05 158.745Z",
    fill: "white"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M218.108 172.352C217.493 172.583 216.798 172.524 216.225 172.169L184.386 152.591C183.826 152.247 183.447 151.667 183.349 151.006L180.189 129.447C180.172 129.325 180.164 129.202 180.166 129.079C180.177 128.48 180.419 127.911 180.84 127.499L213.928 147.847C214.341 148.103 214.621 148.531 214.694 149.02L218.108 172.352Z",
    fill: "#BA5780"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.108 172.352C217.493 172.583 216.798 172.524 216.225 172.169L184.386 152.591C183.826 152.247 183.447 151.667 183.349 151.006L180.189 129.447C180.172 129.325 180.164 129.202 180.166 129.079C180.177 128.48 180.419 127.911 180.84 127.499L213.928 147.847C214.341 148.103 214.621 148.531 214.694 149.02L218.108 172.352Z",
    fill: "white"
  }))), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M218.633 172.083L218.411 172.209C218.314 172.263 218.212 172.311 218.108 172.352L214.694 149.02C214.621 148.532 214.341 148.103 213.928 147.847L180.84 127.499C180.971 127.369 181.125 127.255 181.292 127.159L214.447 147.546C214.86 147.801 215.14 148.23 215.213 148.718L218.633 172.083Z",
    fill: "#FAFAFA"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M200.329 152.188C200.117 150.744 198.698 148.807 197.159 147.861C195.62 146.914 194.544 147.317 194.755 148.761C194.967 150.204 196.386 152.142 197.925 153.088C199.464 154.034 200.54 153.631 200.329 152.188Z",
    fill: "#BA5780"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M255.085 105.305C260.649 108.407 261.654 110.52 262.338 116.278C263.065 122.394 262.997 124.24 263.142 131.966C263.288 139.747 262.795 142.367 261.933 143.812C255.324 134.499 250.292 135.702 250.292 135.702C250.292 135.702 248.804 123.335 248.537 119.277C248.27 115.219 249.909 108.713 255.085 105.305Z",
    fill: "#BA5780"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.085 105.305C260.649 108.407 261.654 110.52 262.338 116.278C263.065 122.394 262.997 124.24 263.142 131.966C263.288 139.747 262.795 142.367 261.933 143.812C255.324 134.499 250.292 135.702 250.292 135.702C250.292 135.702 248.804 123.335 248.537 119.277C248.27 115.219 249.909 108.713 255.085 105.305Z",
    fill: "black"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M262.588 140.619C261.482 138.46 257.38 134.446 254.108 133.684C250.237 132.783 248.222 136.133 248.402 137.563L249.392 136.771C252.671 137.569 256.061 140.02 257.003 142.075C257.945 144.129 258.003 146.322 258.003 146.322L257.122 146.817C257.122 146.817 257.959 147.331 259.063 146.983C260.447 146.547 260.577 145.561 261.589 144.926C262.599 144.29 263.693 142.779 262.588 140.619Z",
    fill: "#B2473D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecommunications);
export default __webpack_public_path__ + "static/media/Telecommunications.bdd137ea5c0d3e059a7ec61b998d98ea.svg";
export { ForwardRef as ReactComponent };